import React, { useState, useCallback } from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import { FaCheck, FaSearch, FaChevronDown } from "react-icons/fa";

import "./Register.css";

import { useNavigate } from "react-router-dom";

import Navbar from "../../Pages/Navbar/Navbar";

import Swal from 'sweetalert2';

import BaseUrl from '../../ApiServices/BaseUrl'
import {
  DOMESTIC_HELPER_POSITIONS,
  COMPANY_WORKER_DUAL_CATEGORY_POSITIONS,
  JOB_SEEKER_CATEGORY_OPTIONS,
  HOSPITALITY_CATEGORY,
  HOSPITALITY_POSITIONS,
  SOFTWARE_IT_CATEGORY,
  SOFTWARE_IT_POSITIONS,
  CONSTRUCTION_CATEGORY,
  CONSTRUCTION_POSITIONS,
  RETAIL_SALES_CATEGORY,
  RETAIL_SALES_POSITIONS,
  CLEANING_MAINTENANCE_CATEGORY,
  CLEANING_MAINTENANCE_POSITIONS,
  SECURITY_CATEGORY,
  SECURITY_POSITIONS,
  OFFICE_STAFF_CATEGORY,
  OFFICE_STAFF_POSITIONS,
  DRIVER_CATEGORY,
  DRIVER_POSITIONS,
  HEALTHCARE_POSITIONS,
  fromCategoryDisplayLabel,
  filterCompanyWorkerPositions
} from "../../../Constants/dropdownOptions";

import { Form, Button, Container, Row, Col, Dropdown } from "react-bootstrap";

import { useLocation } from 'react-router-dom';

// Array of religions mapping to PersonalInfo

const religions = ['Christian', 'Muslim', 'Hindu', 'Buddhism', 'Sikhism', 'Judaism'];



// Enhanced country codes with all requested countries

const countryCodes = [

  // Job Seeker Source Countries

  // Add this in the employer section (around line 90-140):

  { code: "+385", name: "Croatia", category: "jobSeeker", nationality: true },

  { code: "+91", name: "India", category: "jobSeeker", nationality: true },

  { code: "+880", name: "Bangladesh", category: "jobSeeker", nationality: true },

  { code: "+977", name: "Nepal", category: "jobSeeker", nationality: true },

  { code: "+94", name: "Sri Lanka", category: "jobSeeker", nationality: true },

  { code: "+92", name: "Pakistan", category: "jobSeeker", nationality: true },

  { code: "+63", name: "Philippines", category: "jobSeeker", nationality: true },

  { code: "+62", name: "Indonesia", category: "jobSeeker", nationality: true },

  { code: "+95", name: "Myanmar", category: "jobSeeker", nationality: true },

  { code: "+84", name: "Vietnam", category: "jobSeeker", nationality: true },

  { code: "+855", name: "Cambodia", category: "jobSeeker", nationality: true },

  { code: "+357", name: "Cyprus", category: "jobSeeker", nationality: true },

  { code: "+66", name: "Thailand", category: "jobSeeker", nationality: true },

  { code: "+251", name: "Ethiopia", category: "jobSeeker", nationality: true },

  { code: "+254", name: "Kenya", category: "jobSeeker", nationality: true },

  { code: "+256", name: "Uganda", category: "jobSeeker", nationality: true },

  { code: "+255", name: "Tanzania", category: "jobSeeker", nationality: true },

  { code: "+250", name: "Rwanda", category: "jobSeeker", nationality: true },

  { code: "+233", name: "Ghana", category: "jobSeeker", nationality: true },

  { code: "+234", name: "Nigeria", category: "jobSeeker", nationality: true },

  { code: "+232", name: "Sierra Leone", category: "jobSeeker", nationality: true },

  { code: "+257", name: "Burundi", category: "jobSeeker", nationality: true },

  { code: "+237", name: "Cameroon", category: "jobSeeker", nationality: true },

  { code: "+853", name: "Macau", category: "jobSeeker", nationality: true },



  // Employer/Hiring Countries

  // Employer Countries (Updated)

  // Add this in the employer section (around line 90-140):

  { code: "+385", name: "Croatia", category: "employer", nationality: true },

  { code: "+971", name: "UAE", category: "employer", nationality: true },

  { code: "+971", name: "Dubai (UAE)", category: "employer", nationality: true }, // Dubai uses UAE code

  { code: "+966", name: "Saudi Arabia", category: "employer", nationality: true },

  { code: "+974", name: "Qatar", category: "employer", nationality: true },

  { code: "+965", name: "Kuwait", category: "employer", nationality: true },

  { code: "+973", name: "Bahrain", category: "employer", nationality: true },

  { code: "+968", name: "Oman", category: "employer", nationality: true },



  { code: "+65", name: "Singapore", category: "employer", nationality: true },

  { code: "+60", name: "Malaysia", category: "employer", nationality: true },

  { code: "+852", name: "Hong Kong", category: "employer", nationality: true },

  { code: "+81", name: "Japan", category: "employer", nationality: true },

  { code: "+82", name: "South Korea", category: "employer", nationality: true },

  { code: "+886", name: "Taiwan", category: "employer", nationality: true },



  { code: "+49", name: "Germany", category: "employer", nationality: true },

  { code: "+31", name: "Netherlands", category: "employer", nationality: true },

  { code: "+44", name: "United Kingdom", category: "employer", nationality: true },

  { code: "+39", name: "Italy", category: "employer", nationality: true },

  { code: "+34", name: "Spain", category: "employer", nationality: true },

  { code: "+33", name: "France", category: "employer", nationality: true },

  { code: "+48", name: "Poland", category: "employer", nationality: true },

  { code: "+351", name: "Portugal", category: "employer", nationality: true },

  { code: "+40", name: "Romania", category: "employer", nationality: true },

  { code: "+36", name: "Hungary", category: "employer", nationality: true },



  { code: "+1", name: "Canada", category: "employer", nationality: true },

  { code: "+1", name: "United States", category: "employer", nationality: true },

  { code: "+61", name: "Australia", category: "employer", nationality: true },

  { code: "+64", name: "New Zealand", category: "employer", nationality: true },





  // Additional Agency Countries

  // Add Turkey with its country code

  { code: "+90", name: "Turkey", category: "employer", nationality: true },

  { code: "+853", name: "Macau", category: "employer", nationality: true },



  // Add more comprehensive country codes for agencies

  { code: "+93", name: "Afghanistan", category: "agency", nationality: true },

  { code: "+355", name: "Albania", category: "agency", nationality: true },

  { code: "+213", name: "Algeria", category: "agency", nationality: true },

  { code: "+376", name: "Andorra", category: "agency", nationality: true },

  { code: "+244", name: "Angola", category: "agency", nationality: true },

  { code: "+54", name: "Argentina", category: "agency", nationality: true },

  { code: "+374", name: "Armenia", category: "agency", nationality: true },

  { code: "+43", name: "Austria", category: "agency", nationality: true },

  { code: "+994", name: "Azerbaijan", category: "agency", nationality: true },

  { code: "+973", name: "Bahrain", category: "agency", nationality: true },

  { code: "+375", name: "Belarus", category: "agency", nationality: true },

  { code: "+32", name: "Belgium", category: "agency", nationality: true },

  { code: "+501", name: "Belize", category: "agency", nationality: true },

  { code: "+229", name: "Benin", category: "agency", nationality: true },

  { code: "+975", name: "Bhutan", category: "agency", nationality: true },

  { code: "+591", name: "Bolivia", category: "agency", nationality: true },

  { code: "+387", name: "Bosnia and Herzegovina", category: "agency", nationality: true },

  { code: "+267", name: "Botswana", category: "agency", nationality: true },

  { code: "+55", name: "Brazil", category: "agency", nationality: true },

  { code: "+673", name: "Brunei", category: "agency", nationality: true },

  { code: "+853", name: "Macau", category: "agency", nationality: true },

  { code: "+359", name: "Bulgaria", category: "agency", nationality: true },

  { code: "+226", name: "Burkina Faso", category: "agency", nationality: true },

  { code: "+257", name: "Burundi", category: "agency", nationality: true },

  { code: "+238", name: "Cabo Verde", category: "agency", nationality: true },

  { code: "+237", name: "Cameroon", category: "agency", nationality: true },

  { code: "+236", name: "Central African Republic", category: "agency", nationality: true },

  { code: "+235", name: "Chad", category: "agency", nationality: true },

  { code: "+56", name: "Chile", category: "agency", nationality: true },

  { code: "+86", name: "China", category: "agency", nationality: true },

  { code: "+57", name: "Colombia", category: "agency", nationality: true },

  { code: "+269", name: "Comoros", category: "agency", nationality: true },

  { code: "+242", name: "Congo", category: "agency", nationality: true },

  { code: "+506", name: "Costa Rica", category: "agency", nationality: true },

  { code: "+385", name: "Croatia", category: "agency", nationality: true },

  { code: "+53", name: "Cuba", category: "agency", nationality: true },

  { code: "+357", name: "Cyprus", category: "employer", nationality: true },

  { code: "+357", name: "Cyprus", category: "agency", nationality: true },

  { code: "+420", name: "Czech Republic", category: "agency", nationality: true },

  { code: "+243", name: "Democratic Republic of the Congo", category: "agency", nationality: true },

  { code: "+45", name: "Denmark", category: "agency", nationality: true },

  { code: "+253", name: "Djibouti", category: "agency", nationality: true },

  { code: "+1-767", name: "Dominica", category: "agency", nationality: true },

  { code: "+1-809", name: "Dominican Republic", category: "agency", nationality: true },

  { code: "+670", name: "East Timor", category: "agency", nationality: true },

  { code: "+593", name: "Ecuador", category: "agency", nationality: true },

  { code: "+20", name: "Egypt", category: "agency", nationality: true },

  { code: "+503", name: "El Salvador", category: "agency", nationality: true },

  { code: "+240", name: "Equatorial Guinea", category: "agency", nationality: true },

  { code: "+291", name: "Eritrea", category: "agency", nationality: true },

  { code: "+372", name: "Estonia", category: "agency", nationality: true },

  { code: "+268", name: "Eswatini", category: "agency", nationality: true },

  { code: "+251", name: "Ethiopia", category: "agency", nationality: true },

  { code: "+679", name: "Fiji", category: "agency", nationality: true },

  { code: "+358", name: "Finland", category: "agency", nationality: true },

  { code: "+241", name: "Gabon", category: "agency", nationality: true },

  { code: "+220", name: "Gambia", category: "agency", nationality: true },

  { code: "+995", name: "Georgia", category: "agency", nationality: true },

  { code: "+233", name: "Ghana", category: "agency", nationality: true },

  { code: "+30", name: "Greece", category: "agency", nationality: true },

  { code: "+1-473", name: "Grenada", category: "agency", nationality: true },

  { code: "+502", name: "Guatemala", category: "agency", nationality: true },

  { code: "+224", name: "Guinea", category: "agency", nationality: true },

  { code: "+245", name: "Guinea-Bissau", category: "agency", nationality: true },

  { code: "+592", name: "Guyana", category: "agency", nationality: true },

  { code: "+509", name: "Haiti", category: "agency", nationality: true },

  { code: "+504", name: "Honduras", category: "agency", nationality: true },

  { code: "+36", name: "Hungary", category: "agency", nationality: true },

  { code: "+354", name: "Iceland", category: "agency", nationality: true },

  { code: "+91", name: "India", category: "agency", nationality: true },

  { code: "+62", name: "Indonesia", category: "agency", nationality: true },

  { code: "+98", name: "Iran", category: "agency", nationality: true },

  { code: "+964", name: "Iraq", category: "agency", nationality: true },

  { code: "+353", name: "Ireland", category: "agency", nationality: true },

  { code: "+972", name: "Israel", category: "agency", nationality: true },

  { code: "+39", name: "Italy", category: "agency", nationality: true },

  { code: "+225", name: "Ivory Coast", category: "agency", nationality: true },

  { code: "+1-876", name: "Jamaica", category: "agency", nationality: true },

  { code: "+962", name: "Jordan", category: "agency", nationality: true },

  { code: "+7", name: "Kazakhstan", category: "agency", nationality: true },

  { code: "+254", name: "Kenya", category: "agency", nationality: true },

  { code: "+686", name: "Kiribati", category: "agency", nationality: true },

  { code: "+965", name: "Kuwait", category: "agency", nationality: true },

  { code: "+996", name: "Kyrgyzstan", category: "agency", nationality: true },

  { code: "+856", name: "Laos", category: "agency", nationality: true },

  { code: "+371", name: "Latvia", category: "agency", nationality: true },

  { code: "+961", name: "Lebanon", category: "agency", nationality: true },

  { code: "+266", name: "Lesotho", category: "agency", nationality: true },

  { code: "+231", name: "Liberia", category: "agency", nationality: true },

  { code: "+218", name: "Libya", category: "agency", nationality: true },

  { code: "+423", name: "Liechtenstein", category: "agency", nationality: true },

  { code: "+370", name: "Lithuania", category: "agency", nationality: true },

  { code: "+352", name: "Luxembourg", category: "agency", nationality: true },

  { code: "+261", name: "Madagascar", category: "agency", nationality: true },

  { code: "+265", name: "Malawi", category: "agency", nationality: true },

  { code: "+60", name: "Malaysia", category: "agency", nationality: true },

  { code: "+960", name: "Maldives", category: "agency", nationality: true },

  { code: "+223", name: "Mali", category: "agency", nationality: true },

  { code: "+356", name: "Malta", category: "agency", nationality: true },

  { code: "+692", name: "Marshall Islands", category: "agency", nationality: true },

  { code: "+222", name: "Mauritania", category: "agency", nationality: true },

  { code: "+230", name: "Mauritius", category: "agency", nationality: true },

  { code: "+52", name: "Mexico", category: "agency", nationality: true },

  { code: "+691", name: "Micronesia", category: "agency", nationality: true },

  { code: "+373", name: "Moldova", category: "agency", nationality: true },

  { code: "+377", name: "Monaco", category: "agency", nationality: true },

  { code: "+976", name: "Mongolia", category: "agency", nationality: true },

  { code: "+382", name: "Montenegro", category: "agency", nationality: true },

  { code: "+212", name: "Morocco", category: "agency", nationality: true },

  { code: "+258", name: "Mozambique", category: "agency", nationality: true },

  { code: "+95", name: "Myanmar", category: "agency", nationality: true },

  { code: "+264", name: "Namibia", category: "agency", nationality: true },

  { code: "+674", name: "Nauru", category: "agency", nationality: true },

  { code: "+977", name: "Nepal", category: "agency", nationality: true },

  { code: "+31", name: "Netherlands", category: "agency", nationality: true },

  { code: "+505", name: "Nicaragua", category: "agency", nationality: true },

  { code: "+227", name: "Niger", category: "agency", nationality: true },

  { code: "+234", name: "Nigeria", category: "agency", nationality: true },

  { code: "+850", name: "North Korea", category: "agency", nationality: true },

  { code: "+389", name: "North Macedonia", category: "agency", nationality: true },

  { code: "+47", name: "Norway", category: "agency", nationality: true },

  { code: "+968", name: "Oman", category: "agency", nationality: true },

  { code: "+92", name: "Pakistan", category: "agency", nationality: true },

  { code: "+680", name: "Palau", category: "agency", nationality: true },

  { code: "+970", name: "Palestine", category: "agency", nationality: true },

  { code: "+507", name: "Panama", category: "agency", nationality: true },

  { code: "+675", name: "Papua New Guinea", category: "agency", nationality: true },

  { code: "+595", name: "Paraguay", category: "agency", nationality: true },

  { code: "+51", name: "Peru", category: "agency", nationality: true },

  { code: "+63", name: "Philippines", category: "agency", nationality: true },

  { code: "+48", name: "Poland", category: "agency", nationality: true },

  { code: "+351", name: "Portugal", category: "agency", nationality: true },

  { code: "+974", name: "Qatar", category: "agency", nationality: true },

  { code: "+40", name: "Romania", category: "agency", nationality: true },

  { code: "+7", name: "Russia", category: "agency", nationality: true },

  { code: "+250", name: "Rwanda", category: "agency", nationality: true },

  { code: "+1-869", name: "Saint Kitts and Nevis", category: "agency", nationality: true },

  { code: "+1-758", name: "Saint Lucia", category: "agency", nationality: true },

  { code: "+1-784", name: "Saint Vincent and the Grenadines", category: "agency", nationality: true },

  { code: "+685", name: "Samoa", category: "agency", nationality: true },

  { code: "+378", name: "San Marino", category: "agency", nationality: true },

  { code: "+239", name: "Sao Tome and Principe", category: "agency", nationality: true },

  { code: "+966", name: "Saudi Arabia", category: "agency", nationality: true },

  { code: "+221", name: "Senegal", category: "agency", nationality: true },

  { code: "+381", name: "Serbia", category: "agency", nationality: true },

  { code: "+248", name: "Seychelles", category: "agency", nationality: true },

  { code: "+232", name: "Sierra Leone", category: "agency", nationality: true },

  { code: "+65", name: "Singapore", category: "agency", nationality: true },

  { code: "+421", name: "Slovakia", category: "agency", nationality: true },

  { code: "+386", name: "Slovenia", category: "agency", nationality: true },

  { code: "+677", name: "Solomon Islands", category: "agency", nationality: true },

  { code: "+252", name: "Somalia", category: "agency", nationality: true },

  { code: "+27", name: "South Africa", category: "agency", nationality: true },

  { code: "+82", name: "South Korea", category: "agency", nationality: true },

  { code: "+211", name: "South Sudan", category: "agency", nationality: true },

  { code: "+34", name: "Spain", category: "agency", nationality: true },

  { code: "+94", name: "Sri Lanka", category: "agency", nationality: true },

  { code: "+249", name: "Sudan", category: "agency", nationality: true },

  { code: "+597", name: "Suriname", category: "agency", nationality: true },

  { code: "+46", name: "Sweden", category: "agency", nationality: true },

  { code: "+41", name: "Switzerland", category: "agency", nationality: true },

  { code: "+963", name: "Syria", category: "agency", nationality: true },

  { code: "+886", name: "Taiwan", category: "agency", nationality: true },

  { code: "+992", name: "Tajikistan", category: "agency", nationality: true },

  { code: "+255", name: "Tanzania", category: "agency", nationality: true },

  { code: "+66", name: "Thailand", category: "agency", nationality: true },

  { code: "+228", name: "Togo", category: "agency", nationality: true },

  { code: "+676", name: "Tonga", category: "agency", nationality: true },

  { code: "+1-868", name: "Trinidad and Tobago", category: "agency", nationality: true },

  { code: "+216", name: "Tunisia", category: "agency", nationality: true },

  { code: "+90", name: "Turkey", category: "agency", nationality: true },

  { code: "+993", name: "Turkmenistan", category: "agency", nationality: true },

  { code: "+688", name: "Tuvalu", category: "agency", nationality: true },

  { code: "+256", name: "Uganda", category: "agency", nationality: true },

  { code: "+380", name: "Ukraine", category: "agency", nationality: true },

  { code: "+971", name: "United Arab Emirates", category: "agency", nationality: true },

  { code: "+44", name: "United Kingdom", category: "agency", nationality: true },

  { code: "+598", name: "Uruguay", category: "agency", nationality: true },

  { code: "+998", name: "Uzbekistan", category: "agency", nationality: true },

  { code: "+678", name: "Vanuatu", category: "agency", nationality: true },

  { code: "+379", name: "Vatican City", category: "agency", nationality: true },

  { code: "+58", name: "Venezuela", category: "agency", nationality: true },

  { code: "+84", name: "Vietnam", category: "agency", nationality: true },

  { code: "+967", name: "Yemen", category: "agency", nationality: true },

  { code: "+260", name: "Zambia", category: "agency", nationality: true },

  { code: "+263", name: "Zimbabwe", category: "agency", nationality: true }



  // Oceania Employer Countries

  // { code: "+61", name: "Australia", category: "employer", nationality: true },

  // { code: "+64", name: "New Zealand", category: "employer", nationality: true },



  // // North America

  // { code: "+1", name: "Canada", category: "employer", nationality: true },

  // { code: "+1", name: "United States", category: "employer", nationality: true },



  // Middle East

  // { code: "+972", name: "Israel", category: "employer", nationality: true },



  // Other common countries

  // { code: "+20", name: "Egypt", category: "jobSeeker", nationality: true },

  // { code: "+93", name: "Afghanistan", category: "jobSeeker", nationality: true },

];





// Currency mapping with all country currencies

const currencyMap = {

  "Qatar": "QAR (Qatari Riyal)",

  "Saudi Arabia": "SAR (Saudi Riyal)",

  "United Arab Emirates": "AED (UAE Dirham)",

  "Dubai": "AED (UAE Dirham)",

  "Kuwait": "KWD (Kuwaiti Dinar)",

  "Oman": "OMR (Omani Rial)",

  "Bahrain": "BHD (Bahraini Dinar)",

  "Italy": "EUR (Euro)",

  "Germany": "EUR (Euro)",

  "France": "EUR (Euro)",

  "Spain": "EUR (Euro)",

  "Netherlands": "EUR (Euro)",

  "Belgium": "EUR (Euro)",

  "Portugal": "EUR (Euro)",

  "Croatia": "EUR (Euro)",

  "United Kingdom": "GBP (British Pound Sterling)",

  "Switzerland": "CHF (Swiss Franc)",

  "Norway": "NOK (Norwegian Krone)",

  "Sweden": "SEK (Swedish Krona)",

  "Denmark": "DKK (Danish Krone)",

  "Poland": "PLN (Polish Zloty)",

  "Czech Republic": "CZK (Czech Koruna)",

  "Hungary": "HUF (Hungarian Forint)",

  "Romania": "RON (Romanian Leu)",

  "Bulgaria": "BGN (Bulgarian Lev)",

  "Serbia": "RSD (Serbian Dinar)",

  "Turkey": "TRY (Turkish Lira)",

  "United States": "USD (US Dollar)",

  "India": "INR (Indian Rupee)",

  "Singapore": "SGD (Singapore Dollar)",

  "Malaysia": "MYR (Malaysian Ringgit)",

  "Hong Kong": "HKD (Hong Kong Dollar)",

  "Japan": "JPY (Japanese Yen)",

  "South Korea": "KRW (South Korean Won)",

  "Israel": "ILS (Israeli Shekel)",

  "Mauritius": "MUR (Mauritian Rupee)",

  "Seychelles": "SCR (Seychellois Rupee)",

  "Brunei": "BND (Brunei Dollar)"

};



const currencyOptions = [

  "QAR (Qatari Riyal)",

  "SAR (Saudi Riyal)",

  "AED (UAE Dirham)",

  "BHD (Bahraini Dinar)",

  "OMR (Omani Rial)",

  "KWD (Kuwaiti Dinar)",

  "EUR (Euro)",

  "GBP (British Pound Sterling)",

  "CHF (Swiss Franc)",

  "NOK (Norwegian Krone)",

  "SEK (Swedish Krona)",

  "DKK (Danish Krone)",

  "PLN (Polish Zloty)",

  "CZK (Czech Koruna)",

  "HUF (Hungarian Forint)",

  "RON (Romanian Leu)",

  "BGN (Bulgarian Lev)",

  "RSD (Serbian Dinar)",

  "TRY (Turkish Lira)",

  "USD (US Dollar)",

  "INR (Indian Rupee)",

  "SGD (Singapore Dollar)",

  "MYR (Malaysian Ringgit)",

  "HKD (Hong Kong Dollar)",

  "JPY (Japanese Yen)",

  "KRW (South Korean Won)",

  "ILS (Israeli Shekel)",

  "MUR (Mauritian Rupee)",

  "SCR (Seychellois Rupee)",

  "BND (Brunei Dollar)"

];



const salaryTypeOptions = [

  "Fix salary",

  "Negotiable"

];



const fixedSalaryOptions = [

  "800",

  "900",

  "1,000",

  "1,100",

  "1,200",

  "1,300",

  "1,400",

  "1,500",

  "1,600",

  "1,700",

  "1,800",

  "1,900",

  "2,000",

  "2,500",

  "3,000",

  "3,500",

  "4,000",

  "5,000",

  "6,000",

  "7,000",

  "8,000",

  "9,000",

  "10,000",

  "11,000",

  "12,000",

  "13,000",

  "14,000",

  "15,000",

  "16,000",

  "17,000",

  "18,000",

  "19,000",

  "20,000",

  "21,000",

  "22,000",

  "23,000",

  "24,000",

  "25,000+"

];



const salaryRangeOptions = [

  "800–1,000",

  "1,000–1,200",

  "1,200–1,500",

  "1,500–1,800",

  "1,800–2,000",

  "2,000–2,500",

  "2,500–3,000",

  "3,000–3,500",

  "3,500–4,000",

  "4,000–5,000",

  "5,000–7,000",

  "7,000–9,000",

  "9,000–11,000",

  "11,000–12,000",

  "12,000–15,000",

  "15,000+"

];



const countryApplyCurrencyMap = {

  "Jobs in Qatar": "QAR (Qatari Riyal)",

  "Jobs in Saudi Arabia": "SAR (Saudi Riyal)",

  "Jobs in United Arab Emirates": "AED (UAE Dirham)",

  "Jobs in Dubai (UAE)": "AED (UAE Dirham)",

  "Jobs in Kuwait": "KWD (Kuwaiti Dinar)",

  "Jobs in Oman": "OMR (Omani Rial)",

  "Jobs in Bahrain": "BHD (Bahraini Dinar)",

  "Jobs in Italy": "EUR (Euro)",

  "Jobs in Germany": "EUR (Euro)",

  "Jobs in France": "EUR (Euro)",

  "Jobs in Spain": "EUR (Euro)",

  "Jobs in Netherlands": "EUR (Euro)",

  "Jobs in Belgium": "EUR (Euro)",

  "Jobs in Portugal": "EUR (Euro)",

  "Jobs in Austria": "EUR (Euro)",

  "Jobs in Ireland": "EUR (Euro)",

  "Jobs in Finland": "EUR (Euro)",

  "Jobs in Greece": "EUR (Euro)",

  "Jobs in Slovakia": "EUR (Euro)",

  "Jobs in Slovenia": "EUR (Euro)",

  "Jobs in Estonia": "EUR (Euro)",

  "Jobs in Latvia": "EUR (Euro)",

  "Jobs in Lithuania": "EUR (Euro)",

  "Jobs in Luxembourg": "EUR (Euro)",

  "Jobs in Malta": "EUR (Euro)",

  "Jobs in Cyprus": "EUR (Euro)",

  "Jobs in Croatia": "EUR (Euro)",

  "Jobs in United Kingdom": "GBP (British Pound Sterling)",

  "Jobs in Switzerland": "CHF (Swiss Franc)",

  "Jobs in Norway": "NOK (Norwegian Krone)",

  "Jobs in Sweden": "SEK (Swedish Krona)",

  "Jobs in Denmark": "DKK (Danish Krone)",

  "Jobs in Poland": "PLN (Polish Zloty)",

  "Jobs in Czech Republic": "CZK (Czech Koruna)",

  "Jobs in Hungary": "HUF (Hungarian Forint)",

  "Jobs in Romania": "RON (Romanian Leu)",

  "Jobs in Bulgaria": "BGN (Bulgarian Lev)",

  "Jobs in Serbia": "RSD (Serbian Dinar)",

  "Jobs in Turkey": "TRY (Turkish Lira)",

  "Jobs in United States": "USD (US Dollar)",

  "Jobs in India": "INR (Indian Rupee)",

  "Jobs in Singapore": "SGD (Singapore Dollar)",

  "Jobs in Malaysia": "MYR (Malaysian Ringgit)",

  "Jobs in Hong Kong": "HKD (Hong Kong Dollar)",

  "Jobs in Japan": "JPY (Japanese Yen)",

  "Jobs in South Korea": "KRW (South Korean Won)",

  "Jobs in Israel": "ILS (Israeli Shekel)",

  "Jobs in Mauritius": "MUR (Mauritian Rupee)",

  "Jobs in Seychelles": "SCR (Seychellois Rupee)",

  "Jobs in Brunei": "BND (Brunei Dollar)"

};



const conversionRates = {

  "USD": { toUSD: 1, toQAR: 3.64 },

  "QAR": { toUSD: 0.27, toQAR: 1 },

  "SAR": { toUSD: 0.27, toQAR: 0.97 },

  "AED": { toUSD: 0.27, toQAR: 0.99 },

  "BHD": { toUSD: 2.65, toQAR: 9.64 },

  "OMR": { toUSD: 2.60, toQAR: 9.46 },

  "KWD": { toUSD: 3.25, toQAR: 11.82 },

  "EUR": { toUSD: 1.07, toQAR: 3.89 },

  "GBP": { toUSD: 1.24, toQAR: 4.51 },

  "CHF": { toUSD: 1.13, toQAR: 4.11 },

  "NOK": { toUSD: 0.095, toQAR: 0.35 },

  "SEK": { toUSD: 0.098, toQAR: 0.36 },

  "DKK": { toUSD: 0.14, toQAR: 0.51 },

  "PLN": { toUSD: 0.25, toQAR: 0.91 },

  "CZK": { toUSD: 0.043, toQAR: 0.16 },

  "HUF": { toUSD: 0.0027, toQAR: 0.0098 },

  "RON": { toUSD: 0.21, toQAR: 0.76 },

  "BGN": { toUSD: 0.55, toQAR: 2.00 },

  "RSD": { toUSD: 0.0092, toQAR: 0.033 },

  "TRY": { toUSD: 0.030, toQAR: 0.11 },

  "INR": { toUSD: 0.012, toQAR: 0.044 },

  "SGD": { toUSD: 0.74, toQAR: 2.69 },

  "MYR": { toUSD: 0.21, toQAR: 0.76 },

  "HKD": { toUSD: 0.13, toQAR: 0.47 },

  "JPY": { toUSD: 0.0068, toQAR: 0.025 },

  "KRW": { toUSD: 0.00076, toQAR: 0.0028 },

  "ILS": { toUSD: 0.27, toQAR: 0.98 },

  "MUR": { toUSD: 0.022, toQAR: 0.080 },

  "SCR": { toUSD: 0.073, toQAR: 0.27 },

  "BND": { toUSD: 0.74, toQAR: 2.69 }

};

const getCurrencyCode = (currencyValue = "") => {

  const match = currencyValue.match(/^([A-Z]{3})/);

  return match ? match[1] : "";

};



const parseStoredCurrencyValue = (currencyValue = "") => {

  const parts = currencyValue.split(" | ").map(part => part.trim()).filter(Boolean);

  return {

    baseCurrency: parts[0] || "",

    salaryType: parts[1] || "",

    salaryDisplay: parts[2] || ""

  };

};



const buildStoredCurrencyValue = (currencyValue = "", salaryType = "", salaryDisplay = "") => {

  if (!currencyValue) return "";

  const parts = [currencyValue];

  if (salaryType) parts.push(salaryType);

  if (salaryDisplay) parts.push(salaryDisplay);

  return parts.join(" | ");

};



const normalizeSalaryNumber = (value = "") => value.replace(/,/g, "").replace(/\+/g, "").trim();



const getSalaryAmountForConversion = (salaryType = "", salaryValue = "") => {

  if (!salaryValue || salaryType === "Negotiable") return 0;

  if (salaryType === "Salary Range") {

    const normalized = salaryValue.replace(/,/g, "");

    if (normalized.includes("–")) {

      return parseFloat(normalized.split("–")[0]) || 0;

    }

  }

  return parseFloat(normalizeSalaryNumber(salaryValue)) || 0;

};



const getSalaryOptionsByType = (salaryType = "") => {

  if (salaryType === "Fix salary") return fixedSalaryOptions;

  return [];

};





// Country-state-city data structure (add after countryCodes array)

const countryStateCityData = {

  "United Kingdom": {

    "London": ["London", "Westminster", "Croydon", "Wembley", "Stratford", "Hounslow"],

    "Birmingham": ["Birmingham", "Solihull", "Wolverhampton", "West Bromwich", "Dudley", "Walsall"],

    "Manchester": ["Manchester", "Salford", "Bolton", "Stockport", "Oldham", "Rochdale"],

    "Leeds": ["Leeds", "Bradford", "Wakefield", "Huddersfield", "Halifax", "Dewsbury"],

    "Liverpool": ["Liverpool", "Birkenhead", "St Helens", "Bootle", "Southport", "Wallasey"]

  },



  "Croatia": {

    "City of Zagreb": ["Zagreb", "Sesvete", "Novi Zagreb"],

    "Zagreb County": ["Velika Gorica", "Samobor", "Zaprešić", "Dugo Selo"],

    "Split-Dalmatia County": ["Split", "Sinj", "Solin", "Kaštela", "Trogir", "Makarska"],

    "Istria County": ["Pula", "Poreč", "Rovinj", "Umag", "Labin", "Buzet"],

    "Primorje-Gorski Kotar County": ["Rijeka", "Opatija", "Crikvenica", "Kraljevica", "Delnice"],

    "Osijek-Baranja County": ["Osijek", "Belišće", "Donji Miholjac", "Beli Manastir"],

    "Varaždin County": ["Varaždin", "Ivanec", "Ludbreg", "Lepoglava"],

    "Međimurje County": ["Čakovec", "Prelog", "Mursko Središće"],

    "Šibenik-Knin County": ["Šibenik", "Knin", "Drniš", "Vodice"],

    "Zadar County": ["Zadar", "Biograd na Moru", "Benkovac", "Nin"],

    "Bjelovar-Bilogora County": ["Bjelovar", "Čazma", "Garešnica", "Grubišno Polje"],

    "Brod-Posavina County": ["Slavonski Brod", "Nova Gradiška", "Vrpolje"],

    "Dubrovnik-Neretva County": ["Dubrovnik", "Metković", "Ploče", "Korčula", "Opuzen"],

    "Karlovac County": ["Karlovac", "Ogulin", "Duga Resa", "Slunj"],

    "Koprivnica-Križevci County": ["Koprivnica", "Križevci", "Đurđevac"],

    "Krapina-Zagorje County": ["Krapina", "Zabok", "Pregrada", "Donja Stubica"],

    "Lika-Senj County": ["Gospić", "Otočac", "Senj", "Novalja"],

    "Požega-Slavonia County": ["Požega", "Pleternica", "Kutjevo"],

    "Sisak-Moslavina County": ["Sisak", "Petrinja", "Kutina", "Glina"],

    "Virovitica-Podravina County": ["Virovitica", "Orahovica", "Slatina"],

    "Vukovar-Srijem County": ["Vukovar", "Vinkovci", "Županja", "Ilok"]

  },

  "Turkey": {

    "Adana": ["Adana", "Ceyhan", "Kozan", "Feke", "Saimbeyli"],

    "Adıyaman": ["Adıyaman", "Kahta", "Besni", "Gölbaşı", "Çelikhan"],

    "Afyonkarahisar": ["Afyonkarahisar", "Sandıklı", "Dinar", "Bolvadin", "Sinanpaşa"],

    "Ağrı": ["Ağrı", "Patnos", "Doğubayazıt", "Diyadin", "Tutak"],

    "Amasya": ["Amasya", "Merzifon", "Suluova", "Taşova", "Göynücek"],

    "Ankara": ["Ankara", "Polatlı", "Çubuk", "Beypazarı", "Kızılcahamam"],

    "Antalya": ["Antalya", "Alanya", "Manavgat", "Serik", "Kaş"],

    "Artvin": ["Artvin", "Hopa", "Arhavi", "Yusufeli", "Borçka"],

    "Aydın": ["Aydın", "Nazilli", "Söke", "Kuşadası", "Didim"],

    "Balıkesir": ["Balıkesir", "Bandırma", "Edremit", "Gönen", "Burhaniye"],

    "Bilecik": ["Bilecik", "Bozüyük", "Söğüt", "Osmaneli", "Pazaryeri"],

    "Bitlis": ["Bitlis", "Tatvan", "Ahlat", "Hizan", "Mutki"],

    "Bolu": ["Bolu", "Gerede", "Mudurnu", "Dörtdivan", "Yeniçağa"],

    "Burdur": ["Burdur", "Bucak", "Gölhisar", "Tefenni", "Yeşilova"],

    "Bursa": ["Bursa", "İnegöl", "Gemlik", "Mustafakemalpaşa", "Orhangazi"],

    "Çanakkale": ["Çanakkale", "Bigadiç", "Çan", "Biga", "Ezine"],

    "Çankırı": ["Çankırı", "Çerkeş", "Ilgaz", "Orta", "Şabanözü"],

    "Çorum": ["Çorum", "İskilip", "Sungurlu", "Osmancık", "Alaca"],

    "Denizli": ["Denizli", "Pamukkale", "Çivril", "Tavas", "Buldan"],

    "Diyarbakır": ["Diyarbakır", "Bismil", "Silvan", "Ergani", "Çınar"],

    "Edirne": ["Edirne", "Keşan", "Uzunköprü", "İpsala", "Havsa"],

    "Elazığ": ["Elazığ", "Kovancılar", "Keban", "Maden", "Sivrice"],

    "Erzincan": ["Erzincan", "Refahiye", "Çayırlı", "İliç", "Kemah"],

    "Erzurum": ["Erzurum", "Pasinler", "Horasan", "Oltu", "İspir"],

    "Eskişehir": ["Eskişehir", "Sivrihisar", "Çifteler", "Alpu", "Mihalıççık"],

    "Gaziantep": ["Gaziantep", "Şahinbey", "Şehitkamil", "Nizip", "İslahiye"],

    "Giresun": ["Giresun", "Bulancak", "Espiye", "Tirebolu", "Görele"],

    "Gümüşhane": ["Gümüşhane", "Kelkit", "Şiran", "Köse", "Torul"],

    "Hakkari": ["Hakkari", "Yüksekova", "Çukurca", "Şemdinli", "Derecik"],

    "Hatay": ["Antakya", "İskenderun", "Dörtyol", "Reyhanlı", "Samandağ"],

    "Isparta": ["Isparta", "Yalvaç", "Eğirdir", "Şarkikaraağaç", "Gelendost"],

    "Mersin": ["Mersin", "Tarsus", "Silifke", "Erdemli", "Anamur"],

    "Istanbul": ["Istanbul", "Kadıköy", "Üsküdar", "Beşiktaş", "Fatih", "Beyoğlu"],

    "Izmir": ["Izmir", "Bornova", "Karşıyaka", "Buca", "Konak", "Çeşme"],

    "Kars": ["Kars", "Sarıkamış", "Kağızman", "Digor", "Selim"],

    "Kastamonu": ["Kastamonu", "Taşköprü", "İnebolu", "Tosya", "Cide"],

    "Kayseri": ["Kayseri", "Develi", "Yahyalı", "Bünyan", "Pınarbaşı"],

    "Kırklareli": ["Kırklareli", "Lüleburgaz", "Babaeski", "Vize", "Pınarhisar"],

    "Kırşehir": ["Kırşehir", "Kaman", "Mucur", "Çiçekdağı", "Akpınar"],

    "Kocaeli": ["İzmit", "Gebze", "Darıca", "Körfez", "Gölcük"],

    "Konya": ["Konya", "Ereğli", "Akşehir", "Beyşehir", "Çumra"],

    "Kütahya": ["Kütahya", "Tavşanlı", "Simav", "Emet", "Gediz"],

    "Malatya": ["Malatya", "Battalgazi", "Doğanşehir", "Yeşilyurt", "Akçadağ"],

    "Manisa": ["Manisa", "Akhisar", "Salihli", "Turgutlu", "Soma"],

    "Kahramanmaraş": ["Kahramanmaraş", "Elbistan", "Afşin", "Pazarcık", "Göksun"],

    "Mardin": ["Mardin", "Kızıltepe", "Nusaybin", "Derik", "Mazıdağı"],

    "Muğla": ["Muğla", "Bodrum", "Fethiye", "Marmaris", "Milas"],

    "Muş": ["Muş", "Bulanık", "Malazgirt", "Varto", "Korkut"],

    "Nevşehir": ["Nevşehir", "Ürgüp", "Avanos", "Gülşehir", "Hacıbektaş"],

    "Niğde": ["Niğde", "Bor", "Çiftlik", "Ulukışla", "Altunhisar"],

    "Ordu": ["Ordu", "Ünye", "Fatsa", "Perşembe", "Kumru"],

    "Rize": ["Rize", "Çayeli", "Pazar", "Ardeşen", "Fındıklı"],

    "Sakarya": ["Adapazarı", "Sapanca", "Akyazı", "Hendek", "Karapürçek"],

    "Samsun": ["Samsun", "Bafra", "Çarşamba", "Terme", "Vezirköprü"],

    "Siirt": ["Siirt", "Kurtalan", "Pervari", "Şirvan", "Baykan"],

    "Sinop": ["Sinop", "Boyabat", "Ayancık", "Gerze", "Durağan"],

    "Sivas": ["Sivas", "Şarkışla", "Yıldızeli", "Zara", "Suşehri"],

    "Tekirdağ": ["Tekirdağ", "Çorlu", "Çerkezköy", "Malkara", "Saray"],

    "Tokat": ["Tokat", "Turhal", "Zile", "Erbaa", "Niksar"],

    "Trabzon": ["Trabzon", "Akçaabat", "Araklı", "Vakfıkebir", "Of"],

    "Tunceli": ["Tunceli", "Pertek", "Çemişgezek", "Hozat", "Mazgirt"],

    "Şanlıurfa": ["Şanlıurfa", "Siverek", "Viranşehir", "Ceylanpınar", "Birecik"],

    "Uşak": ["Uşak", "Banaz", "Eşme", "Sivaslı", "Ulubey"],

    "Van": ["Van", "Erciş", "Başkale", "Çatak", "Gevaş"],

    "Yozgat": ["Yozgat", "Sorgun", "Akdağmadeni", "Yerköy", "Çekerek"],

    "Zonguldak": ["Zonguldak", "Kozlu", "Çaycuma", "Devrek", "Ereğli"]

  },

  "UAE": {

    "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Madinat Zayed", "Ruwais", "Liwa", "Ghayathi"],

    "Dubai": ["Dubai", "Jebel Ali", "Hatta"],

    "Sharjah": ["Sharjah", "Khor Fakkan", "Kalba", "Dibba Al-Hisn", "Al Dhaid"],

    "Ajman": ["Ajman", "Masfout", "Manama"],

    "Ras Al Khaimah": ["Ras Al Khaimah", "Al Jazirah Al Hamra", "Khatt", "Rams"],

    "Fujairah": ["Fujairah", "Dibba Al-Fujairah"],

    "Umm Al Quwain": ["Umm Al Quwain", "Falaj Al Mualla"]

  },

  "Qatar": {

    "Doha": ["Doha", "West Bay", "Al Dafna", "Al Sadd", "Bin Mahmoud", "Old Doha"],

    "Al Rayyan": ["Al Rayyan", "Al Wakrah Camp", "Education City", "Al Gharrafa", "Al Wajba"],

    "Al Wakrah": ["Al Wakrah", "Al Wukair", "Mesaieed"],

    "Umm Salal": ["Umm Salal Mohammed", "Umm Salal Ali"],

    "Al Daayen": ["Lusail", "Al Daayen", "Umm Qarn"],

    "Al Khor": ["Al Khor", "Al Thakhira"],

    "Al Shamal": ["Madinat ash Shamal", "Ar Ru'ays"]

  },

  "Saudi Arabia": {

    "Riyadh": ["Riyadh", "Diriyah", "Al Kharj", "Al Majma'ah", "Dawadmi", "Shaqra"],

    "Makkah": ["Makkah", "Jeddah", "Taif", "Rabigh", "Al Lith"],

    "Madinah": ["Madinah", "Yanbu", "Al Ula", "Badr"],

    "Eastern Province – Dammam": ["Dammam", "Khobar", "Dhahran", "Jubail", "Qatif", "Ras Tanura", "Al Ahsa (Hofuf)"],

    "Asir": ["Abha", "Khamis Mushait", "Ahad Rifaidah", "Mahayel Aseer"],

    "Jazan": ["Jazan", "Sabya", "Abu Arish", "Al Ardah"],

    "Najran": ["Najran", "Sharurah", "Hubuna"],

    "Al Qassim": ["Buraidah", "Unaizah", "Al Rass", "Al Bukayriyah"],

    "Tabuk": ["Tabuk", "Duba", "Umluj", "Tayma"],

    "Hail": ["Hail", "Baqaa", "Ghazalah"],

    "Al Jawf": ["Sakaka", "Qurayyat", "Dumat Al Jandal"],

    "Northern Borders": ["Arar", "Rafha", "Turaif"],

    "Al Baha": ["Al Baha", "Baljurashi", "Al Makhwah"]

  },

  "Oman": {

    "Muscat": ["Muscat", "Muttrah", "Ruwi", "Seeb", "Bawshar", "Al Amerat"],

    "Dhofar": ["Salalah", "Taqah", "Mirbat", "Thumrait", "Rakhyut"],

    "Al Batinah North": ["Sohar", "Shinas", "Liwa", "Saham", "Al Khaburah"],

    "Al Batinah South": ["Rustaq", "Awabi", "Nakhal", "Wadi Al Maawil"],

    "Al Dakhiliyah": ["Nizwa", "Bahla", "Adam", "Manah", "Izki", "Samail"],

    "Al Sharqiyah North": ["Ibra", "Bidiyah", "Al Mudhaibi", "Qabil"],

    "Al Sharqiyah South": ["Sur", "Jalan Bani Bu Ali", "Jalan Bani Bu Hassan", "Masirah"],

    "Al Dhahirah": ["Ibri", "Yanqul", "Dhank"],

    "Al Buraimi": ["Al Buraimi", "Mahdah", "Al Sunaynah"],

    "Al Wusta": ["Haima", "Duqm", "Mahout"],

    "Musandam": ["Khasab", "Bukha", "Dibba Al-Bayah"]

  },

  "Kuwait": {

    "Al Asimah (Capital)": ["Kuwait City", "Sharq", "Dasman", "Qibla", "Mirqab", "Dasma"],

    "Hawalli": ["Hawalli", "Salmiya", "Jabriya", "Bayan", "Mishref", "Rumaithiya", "Salwa"],

    "Farwaniya": ["Farwaniya", "Khaitan", "Abbassiya", "Riggae", "Jleeb Al-Shuyoukh", "Omariya"],

    "Ahmadi": ["Ahmadi", "Fahaheel", "Mangaf", "Mahboula", "Riqqa", "Hadiya", "Sabahiya"],

    "Jahra": ["Jahra", "Qasr", "Sulaibiya", "Taima", "Saad Al Abdullah"],

    "Mubarak Al-Kabeer": ["Mubarak Al-Kabeer", "Sabah Al-Salem", "Al-Adan", "Qurain", "Abu Al-Hasaniya", "Abu Futaira"]

  },

  "Bahrain": {

    "Capital Governorate": ["Manama", "Seef", "Juffair", "Diplomatic Area", "Sanabis", "Karbabad"],

    "Muharraq Governorate": ["Muharraq", "Hidd", "Arad", "Galali", "Diyar Al Muharraq"],

    "Northern Governorate": ["A'ali", "Barbar", "Budaiya", "Diraz", "Hamad Town", "Saar"],

    "Southern Governorate": ["Riffa", "Isa Town", "Sakhir", "Zallaq", "Awali", "East Riffa", "West Riffa"]

  },

  "Singapore": {

    "Central Region": ["Singapore (CBD)", "Orchard", "Marina Bay", "Bugis", "Chinatown", "Little India", "Tiong Bahru"],

    "East Region": ["Tampines", "Bedok", "Pasir Ris", "Changi", "Simei"],

    "West Region": ["Jurong East", "Jurong West", "Clementi", "Bukit Batok", "Bukit Panjang", "Tuas"],

    "North Region": ["Woodlands", "Yishun", "Sembawang", "Admiralty"],

    "North-East Region": ["Hougang", "Sengkang", "Punggol", "Serangoon"]

  },

  "Malaysia": {

    "Johor": ["Johor Bahru", "Iskandar Puteri", "Batu Pahat", "Kluang", "Muar", "Pontian"],

    "Kedah": ["Alor Setar", "Sungai Petani", "Kulim", "Langkawi"],

    "Kelantan": ["Kota Bharu", "Pasir Mas", "Tumpat", "Tanah Merah"],

    "Melaka": ["Melaka City", "Ayer Keroh", "Alor Gajah", "Jasin"],

    "Negeri Sembilan": ["Seremban", "Port Dickson", "Nilai", "Tampin"],

    "Pahang": ["Kuantan", "Temerloh", "Bentong", "Raub", "Cameron Highlands"],

    "Penang (Pulau Pinang)": ["George Town", "Butterworth", "Bukit Mertajam", "Bayan Lepas"],

    "Perak": ["Ipoh", "Taiping", "Teluk Intan", "Batu Gajah", "Lumut"],

    "Perlis": ["Kangar", "Kuala Perlis"],

    "Sabah": ["Kota Kinabalu", "Sandakan", "Tawau", "Lahad Datu"],

    "Sarawak": ["Kuching", "Miri", "Sibu", "Bintulu"],

    "Selangor": ["Shah Alam", "Petaling Jaya", "Subang Jaya", "Klang", "Cyberjaya"],

    "Terengganu": ["Kuala Terengganu", "Dungun", "Kemaman", "Marang"],

    "Federal Territory of Kuala Lumpur": ["Kuala Lumpur"],

    "Federal Territory of Putrajaya": ["Putrajaya"],

    "Federal Territory of Labuan": ["Labuan"]

  },

  "Hong Kong": {

    "Hong Kong Island": ["Central", "Admiralty", "Wan Chai", "Causeway Bay", "North Point", "Quarry Bay", "Aberdeen"],

    "Kowloon": ["Tsim Sha Tsui", "Mong Kok", "Yau Ma Tei", "Jordan", "Sham Shui Po", "Kowloon City", "Hung Hom"],

    "New Territories": ["Sha Tin", "Tai Po", "Tsuen Wan", "Tuen Mun", "Yuen Long", "Fanling", "Sheung Shui"],

    "Outlying Islands": ["Lantau Island", "Tung Chung", "Cheung Chau", "Lamma Island", "Peng Chau"]

  },

  "Taiwan": {

    "Taipei City": ["Taipei", "Zhongshan", "Wanhua", "Da'an", "Xinyi"],

    "New Taipei City": ["Banqiao", "Xinzhuang", "Tamsui", "Sanchong", "Linkou"],

    "Taoyuan City": ["Taoyuan", "Zhongli", "Bade", "Luzhu"],

    "Taichung City": ["Taichung", "Fengyuan", "Dali", "Beitun"],

    "Tainan City": ["Tainan", "Yongkang", "Rende"],

    "Kaohsiung City": ["Kaohsiung", "Zuoying", "Lingya", "Xiaogang"]

  },

  "South Korea": {

    "Seoul": ["Seoul", "Gangnam", "Jongno", "Mapo", "Songpa", "Yeongdeungpo"],

    "Busan": ["Busan", "Haeundae", "Suyeong", "Dongnae", "Sasang"],

    "Incheon": ["Incheon", "Bupyeong", "Namdong", "Yeonsu", "Songdo"],

    "Daegu": ["Daegu", "Suseong", "Dalseo", "Dong"],

    "Daejeon": ["Daejeon", "Yuseong", "Seo", "Dong"],

    "Gwangju": ["Gwangju", "Buk", "Seo", "Gwangsan"],

    "Ulsan": ["Ulsan", "Nam", "Dong", "Buk"],

    "Gyeonggi-do": ["Suwon", "Seongnam", "Goyang", "Yongin", "Bucheon", "Ansan", "Anyang"],

    "Gangwon-do": ["Chuncheon", "Wonju", "Gangneung", "Donghae"],

    "Chungcheongbuk-do": ["Cheongju", "Chungju", "Jecheon"],

    "Chungcheongnam-do": ["Cheonan", "Asan", "Seosan", "Dangjin"],

    "Jeollabuk-do": ["Jeonju", "Iksan", "Gunsan"],

    "Jeollanam-do": ["Mokpo", "Yeosu", "Suncheon", "Gwangyang"],

    "Gyeongsangbuk-do": ["Pohang", "Gumi", "Andong", "Gyeongju"],

    "Gyeongsangnam-do": ["Changwon", "Gimhae", "Jinju", "Yangsan"],

    "Jeju Special Self-Governing Province": ["Jeju City", "Seogwipo"]

  },

  "Japan": {

    "Tokyo": ["Tokyo", "Shinjuku", "Shibuya", "Minato", "Chiyoda", "Taito", "Ikebukuro"],

    "Kanagawa": ["Yokohama", "Kawasaki", "Yokosuka", "Kamakura"],

    "Osaka": ["Osaka", "Sakai", "Toyonaka", "Higashiosaka"],

    "Aichi": ["Nagoya", "Toyota", "Okazaki", "Ichinomiya"],

    "Saitama": ["Saitama", "Kawaguchi", "Kawagoe", "Tokorozawa"],

    "Chiba": ["Chiba", "Funabashi", "Matsudo", "Ichikawa"],

    "Hyogo": ["Kobe", "Himeji", "Nishinomiya", "Amagasaki"],

    "Hokkaido": ["Sapporo", "Hakodate", "Asahikawa"],

    "Fukuoka": ["Fukuoka", "Kitakyushu", "Kurume"],

    "Hiroshima": ["Hiroshima", "Fukuyama", "Kure"],

    "Kyoto": ["Kyoto", "Uji", "Kameoka"],

    "Okinawa": ["Naha", "Okinawa City", "Uruma"]

  },

  "Germany": {

    "Bavaria (Bayern)": ["Munich", "Nuremberg", "Augsburg", "Regensburg", "Würzburg"],

    "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen", "Duisburg", "Bochum"],

    "Baden-Württemberg": ["Stuttgart", "Mannheim", "Karlsruhe", "Freiburg", "Heidelberg"],

    "Hesse (Hessen)": ["Frankfurt am Main", "Wiesbaden", "Darmstadt", "Kassel", "Offenbach"],

    "Lower Saxony (Niedersachsen)": ["Hanover", "Wolfsburg", "Braunschweig", "Oldenburg", "Osnabrück"],

    "Berlin (City State)": ["Berlin", "Mitte", "Charlottenburg", "Neukölln", "Kreuzberg"],

    "Hamburg (City State)": ["Hamburg", "Altona", "Wandsbek", "Eimsbüttel"],

    "Saxony (Sachsen)": ["Dresden", "Leipzig", "Chemnitz"],

    "Rhineland-Palatinate (Rheinland-Pfalz)": ["Mainz", "Ludwigshafen", "Koblenz", "Trier"],

    "Schleswig-Holstein": ["Kiel", "Lübeck", "Flensburg", "Neumünster"],

    "Brandenburg": ["Potsdam", "Cottbus", "Brandenburg an der Havel"],

    "Saarland": ["Saarbrücken", "Neunkirchen", "Homburg"],

    "Bremen (City State)": ["Bremen", "Bremerhaven"],

    "Mecklenburg-Vorpommern": ["Rostock", "Schwerin", "Wismar"],

    "Thuringia (Thüringen)": ["Erfurt", "Jena", "Weimar"],

    "Saxony-Anhalt (Sachsen-Anhalt)": ["Magdeburg", "Halle (Saale)", "Dessau-Roßlau"]

  },

  "Netherlands": {
    "Noord-Holland": ["Amsterdam", "Haarlem"],
    "Zuid-Holland": ["Rotterdam", "The Hague", "Leiden"],
    "Utrecht": ["Utrecht"],
    "Noord-Brabant": ["Eindhoven", "Tilburg"],
    "Gelderland": ["Arnhem", "Nijmegen"],
    "Overijssel": ["Enschede", "Zwolle"],
    "Limburg": ["Maastricht"],
    "Groningen": ["Groningen"],
    "Friesland": ["Leeuwarden"],
    "Drenthe": ["Assen"],
    "Flevoland": ["Almere", "Lelystad"],
    "Zeeland": ["Middelburg"]
  },
  "Poland": {
    "Masovian Voivodeship": ["Warsaw", "Radom", "Płock", "Siedlce", "Pruszków", "Legionowo", "Ostrołęka"],

    "Lesser Poland Voivodeship": ["Krakow", "Tarnów", "Nowy Sącz", "Oświęcim", "Chrzanów", "Olkusz", "Zakopane"],

    "Silesian Voivodeship": ["Katowice", "Częstochowa", "Sosnowiec", "Gliwice", "Zabrze", "Bytom", "Ruda Śląska", "Rybnik"],

    "Greater Poland Voivodeship": ["Poznań", "Kalisz", "Konin", "Piła", "Ostrów Wielkopolski", "Gniezno", "Leszno"],

    "Lower Silesian Voivodeship": ["Wrocław", "Wałbrzych", "Legnica", "Jelenia Góra", "Lubin", "Głogów", "Świdnica"],

    "Łódź Voivodeship": ["Łódź", "Piotrków Trybunalski", "Pabianice", "Tomaszów Mazowiecki", "Zgierz", "Skierniewice"],

    "Pomeranian Voivodeship": ["Gdańsk", "Gdynia", "Sopot", "Tczew", "Starogard Gdański", "Wejherowo", "Kościerzyna"],

    "West Pomeranian Voivodeship": ["Szczecin", "Koszalin", "Świnoujście", "Stargard", "Police", "Gryfino", "Kołobrzeg"],

    "Lublin Voivodeship": ["Lublin", "Chełm", "Zamość", "Biała Podlaska", "Puławy", "Kraśnik"],

    "Podlaskie Voivodeship": ["Białystok", "Suwałki", "Łomża", "Augustów", "Sokółka", "Hajnówka"],

    "Świętokrzyskie Voivodeship": ["Kielce", "Ostrowiec Świętokrzyski", "Starachowice", "Skarżysko-Kamienna", "Sandomierz"],

    "Warmian-Masurian Voivodeship": ["Olsztyn", "Elbląg", "Ełk", "Iława", "Mrągowo", "Giżycko"],

    "Lubusz Voivodeship": ["Gorzów Wielkopolski", "Zielona Góra", "Nowa Sól", "Żary", "Żagań", "Międzyrzecz"],

    "Kuyavian-Pomeranian Voivodeship": ["Bydgoszcz", "Toruń", "Włocławek", "Grudziądz", "Inowrocław", "Brodnica"],

    "Opole Voivodeship": ["Opole", "Kędzierzyn-Koźle", "Nysa", "Brzeg", "Prudnik", "Strzelce Opolskie"],

    "Subcarpathian Voivodeship": ["Rzeszów", "Przemyśl", "Stalowa Wola", "Mielec", "Tarnobrzeg", "Krosno", "Jarosław"]

  },



  "Ireland": {

    "County Dublin": ["Dublin City", "Tallaght", "Dún Laoghaire", "Swords", "Blanchardstown", "Lucan", "Malahide"],

    "County Cork": ["Cork City", "Ballincollig", "Carrigaline", "Midleton", "Cobh", "Mallow", "Youghal"],

    "County Galway": ["Galway City", "Tuam", "Ballinasloe", "Loughrea", "Oranmore", "Athenry", "Clifden"],

    "County Limerick": ["Limerick City", "Newcastle West", "Abbeyfeale", "Rathkeale", "Kilmallock", "Adare"],

    "County Waterford": ["Waterford City", "Dungarvan", "Tramore", "Dunmore East", "Lismore", "Portlaw"],

    "County Kerry": ["Tralee", "Killarney", "Listowel", "Kenmare", "Dingle", "Cahersiveen"],

    "County Clare": ["Ennis", "Shannon", "Kilrush", "Ennistymon", "Kilkee", "Newmarket-on-Fergus"],

    "County Wexford": ["Wexford Town", "Enniscorthy", "Gorey", "New Ross", "Rosslare", "Bunclody"],

    "County Mayo": ["Castlebar", "Ballina", "Westport", "Claremorris", "Swinford", "Belmullet"],

    "County Donegal": ["Letterkenny", "Buncrana", "Ballybofey", "Donegal Town", "Carndonagh", "Bundoran"],

    "County Kildare": ["Naas", "Newbridge", "Maynooth", "Celbridge", "Leixlip", "Athy", "Kildare Town"],

    "County Meath": ["Navan", "Drogheda (part)", "Trim", "Ashbourne", "Kells", "Dunboyne", "Duleek"],

    "County Wicklow": ["Bray", "Greystones", "Arklow", "Wicklow Town", "Rathdrum", "Blessington"],

    "County Louth": ["Dundalk", "Drogheda (part)", "Ardee", "Carlingford", "Dunleer"],

    "County Tipperary": ["Clonmel", "Nenagh", "Thurles", "Tipperary Town", "Carrick-on-Suir", "Roscrea", "Cahir"],

    "County Kilkenny": ["Kilkenny City", "Callan", "Thomastown", "Graiguenamanagh", "Castlecomer"]

  },



  "Canada": {

    "Ontario": ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor"],

    "Quebec": ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", "Saguenay", "Trois-Rivières"],

    "British Columbia": ["Vancouver", "Surrey", "Burnaby", "Richmond", "Kelowna", "Coquitlam", "Langley", "Delta", "Victoria"],

    "Alberta": ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "St. Albert", "Medicine Hat", "Grande Prairie", "Airdrie"],

    "Manitoba": ["Winnipeg", "Brandon", "Thompson", "Steinbach", "Portage la Prairie", "Winkler", "Selkirk"],

    "Saskatchewan": ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw", "Yorkton", "Swift Current", "North Battleford"],

    "Nova Scotia": ["Halifax", "Sydney", "Dartmouth", "Truro", "New Glasgow", "Glace Bay", "Amherst"],

    "New Brunswick": ["Moncton", "Saint John", "Fredericton", "Dieppe", "Miramichi", "Edmundston", "Bathurst"],

    "Newfoundland and Labrador": ["St. John's", "Mount Pearl", "Corner Brook", "Grand Falls-Windsor", "Gander", "Labrador City"],

    "Prince Edward Island": ["Charlottetown", "Summerside", "Stratford", "Montague", "Kensington", "Alberton"],

    "Northwest Territories": ["Yellowknife", "Hay River", "Inuvik", "Fort Smith", "Behchokǫ"],

    "Yukon": ["Whitehorse", "Dawson City", "Watson Lake", "Haines Junction", "Carmacks"],

    "Nunavut": ["Iqaluit", "Rankin Inlet", "Arviat", "Baker Lake", "Cambridge Bay", "Pangnirtung"]

  },



  "Italy": {

    "Lombardy": ["Milan", "Bergamo", "Brescia", "Monza", "Como", "Varese", "Lecco", "Cremona", "Mantua"],

    "Lazio": ["Rome", "Latina", "Frosinone", "Viterbo", "Rieti", "Guidonia Montecelio", "Civitavecchia"],

    "Campania": ["Naples", "Salerno", "Caserta", "Benevento", "Avellino", "Pompei", "Sorrento", "Capri"],

    "Sicily": ["Palermo", "Catania", "Messina", "Syracuse", "Trapani", "Agrigento", "Ragusa", "Caltanissetta"],

    "Veneto": ["Venice", "Verona", "Padua", "Vicenza", "Treviso", "Belluno", "Rovigo", "Chioggia"],

    "Piedmont": ["Turin", "Novara", "Alessandria", "Asti", "Cuneo", "Vercelli", "Biella", "Verbania"],

    "Emilia-Romagna": ["Bologna", "Parma", "Modena", "Reggio Emilia", "Ravenna", "Ferrara", "Forlì", "Rimini", "Piacenza"],

    "Tuscany": ["Florence", "Pisa", "Lucca", "Arezzo", "Siena", "Prato", "Livorno", "Grosseto", "Massa"],

    "Apulia": ["Bari", "Lecce", "Taranto", "Foggia", "Brindisi", "Barletta", "Trani", "Andria"],

    "Liguria": ["Genoa", "La Spezia", "Savona", "Sanremo", "Imperia", "Rapallo", "Portofino"],

    "Marche": ["Ancona", "Pesaro", "Urbino", "Macerata", "Ascoli Piceno", "Fermo", "Senigallia"],

    "Abruzzo": ["L'Aquila", "Pescara", "Chieti", "Teramo", "Avezzano", "Vasto", "Sulmona"],

    "Umbria": ["Perugia", "Assisi", "Terni", "Foligno", "Spoleto", "Città di Castello", "Gubbio"],

    "Calabria": ["Reggio Calabria", "Catanzaro", "Cosenza", "Crotone", "Vibo Valentia", "Lamezia Terme"],

    "Sardinia": ["Cagliari", "Sassari", "Olbia", "Nuoro", "Oristano", "Alghero", "Carbonia"],

    "Friuli-Venezia Giulia": ["Trieste", "Udine", "Pordenone", "Gorizia", "Monfalcone", "Cervignano del Friuli"],

    "Trentino-Alto Adige": ["Trento", "Bolzano", "Merano", "Brixen", "Rovereto", "Pergine Valsugana"],

    "Molise": ["Campobasso", "Isernia", "Termoli", "Venafro", "Bojano", "Larino"],

    "Basilicata": ["Potenza", "Matera", "Melfi", "Pisticci", "Lauria", "Bernalda"],

    "Aosta Valley": ["Aosta", "Courmayeur", "Cervinia", "La Thuile", "Saint-Vincent", "Pré-Saint-Didier"]

  },

  "Romania": {

    "Alba": ["Alba Iulia", "Sebeș", "Blaj", "Aiud", "Cugir"],

    "Arad": ["Arad", "Ineu", "Chișineu-Criș", "Lipova", "Pâncota"],

    "Argeș": ["Pitești", "Curtea de Argeș", "Câmpulung", "Mioveni", "Costești"],

    "Bacău": ["Bacău", "Onești", "Moinești", "Comănești", "Buhuși"],

    "Bihor": ["Oradea", "Salonta", "Beiuș", "Marghita", "Aleșd"],

    "Bistrița-Năsăud": ["Bistrița", "Beclean", "Năsăud", "Sângeorz-Băi"],

    "Botoșani": ["Botoșani", "Dorohoi", "Darabani", "Săveni", "Flămânzi"],

    "Brăila": ["Brăila", "Ianca", "Însurăței", "Făurei"],

    "Brașov": ["Brașov", "Făgăraș", "Săcele", "Codlea", "Zărnești"],

    "București (Capital)": ["Bucharest", "Sector 1", "Sector 2", "Sector 3", "Sector 4", "Sector 5", "Sector 6"],

    "Buzău": ["Buzău", "Râmnicu Sărat", "Nehoiu", "Pogoanele"],

    "Călărași": ["Călărași", "Oltenița", "Lehliu Gară", "Budești"],

    "Caraș-Severin": ["Reșița", "Caransebeș", "Bocșa", "Oravița", "Moldova Nouă"],

    "Cluj": ["Cluj-Napoca", "Turda", "Dej", "Câmpia Turzii", "Gherla"],

    "Constanța": ["Constanța", "Mangalia", "Medgidia", "Năvodari", "Cernavodă"],

    "Covasna": ["Sfântu Gheorghe", "Târgu Secuiesc", "Covasna", "Întorsura Buzăului"],

    "Dâmbovița": ["Târgoviște", "Moreni", "Pucioasa", "Găești", "Titu"],

    "Dolj": ["Craiova", "Băilești", "Calafat", "Filiași", "Segarcea"],

    "Galați": ["Galați", "Tecuci", "Târgu Bujor", "Berești"],

    "Giurgiu": ["Giurgiu", "Bolintin-Vale", "Mihăilești"],

    "Gorj": ["Târgu Jiu", "Motru", "Rovinari", "Novaci", "Bumbești-Jiu"],

    "Harghita": ["Miercurea Ciuc", "Odorheiu Secuiesc", "Gheorgheni", "Toplița"],

    "Hunedoara": ["Deva", "Hunedoara", "Petroșani", "Lupeni", "Vulcan"],

    "Ialomița": ["Slobozia", "Fetești", "Urziceni", "Țăndărei"],

    "Iași": ["Iași", "Pașcani", "Hârlău", "Târgu Frumos"],

    "Ilfov": ["Buftea", "Voluntari", "Pantelimon", "Popești-Leordeni", "Bragadiru"],

    "Maramureș": ["Baia Mare", "Sighetu Marmației", "Borșa", "Vișeu de Sus"],

    "Mehedinți": ["Drobeta-Turnu Severin", "Orșova", "Vânju Mare", "Strehaia"],

    "Mureș": ["Târgu Mureș", "Reghin", "Sighișoara", "Târnăveni", "Luduș"],

    "Neamț": ["Piatra Neamț", "Roman", "Târgu Neamț", "Bicaz"],

    "Olt": ["Slatina", "Caracal", "Balș", "Corabia", "Scornicești"],

    "Prahova": ["Ploiești", "Câmpina", "Sinaia", "Bușteni", "Azuga"],

    "Sălaj": ["Zalău", "Șimleu Silvaniei", "Jibou", "Cehu Silvaniei"],

    "Satu Mare": ["Satu Mare", "Carei", "Negrești-Oaș", "Tășnad"],

    "Sibiu": ["Sibiu", "Mediaș", "Cisnădie", "Agnita", "Avrig"],

    "Suceava": ["Suceava", "Botoșani", "Fălticeni", "Rădăuți", "Câmpulung Moldovenesc"],

    "Teleorman": ["Alexandria", "Rosiori de Vede", "Turnu Măgurele", "Zimnicea"],

    "Timiș": ["Timișoara", "Lugoj", "Sânnicolau Mare", "Jimbolia"],

    "Tulcea": ["Tulcea", "Babadag", "Măcin", "Sulina"],

    "Vaslui": ["Vaslui", "Bârlad", "Huși", "Negrești"],

    "Vâlcea": ["Râmnicu Vâlcea", "Drăgășani", "Băile Olănești", "Călimănești"],

    "Vrancea": ["Focșani", "Adjud", "Mărășești", "Panciu"]

  },

  "Hungary": {

    "Bács-Kiskun": ["Kecskemét", "Baja", "Kalocsa", "Kiskunfélegyháza", "Kiskunhalas"],

    "Baranya": ["Pécs", "Komló", "Mohács", "Szigetvár", "Siklós"],

    "Békés": ["Békéscsaba", "Gyula", "Orosháza", "Szarvas", "Békés"],

    "Borsod-Abaúj-Zemplén": ["Miskolc", "Ózd", "Kazincbarcika", "Sátoraljaújhely", "Tiszaújváros"],

    "Csongrád-Csanád": ["Szeged", "Hódmezővásárhely", "Makó", "Szentes", "Mórahalom"],

    "Fejér": ["Székesfehérvár", "Dunaújváros", "Mór", "Bicske", "Gárdony"],

    "Győr-Moson-Sopron": ["Győr", "Sopron", "Mosonmagyaróvár", "Csorna", "Kapuvár"],

    "Hajdú-Bihar": ["Debrecen", "Hajdúböszörmény", "Hajdúszoboszló", "Berettyóújfalu", "Balmazújváros"],

    "Heves": ["Eger", "Hatvan", "Gyöngyös", "Füzesabony", "Heves"],

    "Jász-Nagykun-Szolnok": ["Szolnok", "Jászberény", "Karcag", "Törökszentmiklós", "Mezőtúr"],

    "Komárom-Esztergom": ["Tatabánya", "Esztergom", "Komárom", "Oroszlány", "Tata"],

    "Nógrád": ["Salgótarján", "Balassagyarmat", "Pásztó", "Bátonyterenye", "Rétság"],

    "Pest": ["Érd", "Gödöllő", "Vác", "Cegléd", "Dunakeszi"],

    "Somogy": ["Kaposvár", "Siófok", "Marcali", "Barcs", "Fonyód"],

    "Szabolcs-Szatmár-Bereg": ["Nyíregyháza", "Kisvárda", "Mátészalka", "Nyírbátor", "Fehérgyarmat"],

    "Tolna": ["Szekszárd", "Dombóvár", "Paks", "Tamási", "Bonyhád"],

    "Vas": ["Szombathely", "Sárvár", "Körmend", "Szentgotthárd", "Celldömölk"],

    "Veszprém": ["Veszprém", "Ajka", "Várpalota", "Pápa", "Balatonfüred"],

    "Zala": ["Zalaegerszeg", "Nagykanizsa", "Keszthely", "Lenti", "Zalaszentgrót"],

    "Budapest (Capital)": ["Budapest", "District I", "District II", "District III", "District IV", "District V"]

  },

  "Lithuania": {

    "Alytus County": ["Alytus", "Varėna", "Druskininkai", "Lazdijai"],

    "Kaunas County": ["Kaunas", "Jonava", "Kėdainiai", "Kaišiadorys", "Prienai"],

    "Klaipėda County": ["Klaipėda", "Mažeikiai", "Plungė", "Kretinga", "Palanga"],

    "Marijampolė County": ["Marijampolė", "Vilkaviškis", "Šakiai", "Kazlų Rūda"],

    "Panevėžys County": ["Panevėžys", "Kupiškis", "Rokiškis", "Biržai", "Pasvalys"],

    "Šiauliai County": ["Šiauliai", "Radviliškis", "Kelmė", "Pakruojis", "Joniškis"],

    "Tauragė County": ["Tauragė", "Šilutė", "Jurbarkas", "Pagėgiai"],

    "Telšiai County": ["Telšiai", "Mažeikiai", "Plungė", "Rietavas"],

    "Utena County": ["Utena", "Visaginas", "Anykščiai", "Molėtai", "Zarasai"],

    "Vilnius County": ["Vilnius (Capital)", "Ukmergė", "Elektrėnai", "Šalčininkai", "Trakai"]

  },

  "Czech Republic": {

    "Prague": ["Prague"],

    "Central Bohemian": ["Prague", "Brno", "Ostrava"],

    "South Bohemian": ["České Budějovice"],

    "Plzeň": ["Plzeň"],

    "Karlovy Vary": ["Karlovy Vary"],

    "Ústí nad Labem": ["Ústí nad Labem"],

    "Liberec": ["Liberec"],

    "Hradec Králové": ["Hradec Králové"],

    "Pardubice": ["Pardubice"],

    "Vysočina": ["Jihlava"],

    "South Moravian": ["Brno"],

    "Olomouc": ["Olomouc"],

    "Zlín": ["Zlín"],

    "Moravian-Silesian": ["Ostrava"]

  },

  "Slovakia": {

    "Bratislava": ["Bratislava"],

    "Trnava": ["Trnava"],

    "Trenčín": ["Trenčín"],

    "Nitra": ["Nitra"],

    "Žilina": ["Žilina", "Martin"],

    "Banská Bystrica": ["Banská Bystrica"],

    "Prešov": ["Prešov", "Poprad"],

    "Košice": ["Košice"]

  },

  "Belgium": {

    "Antwerp": ["Antwerp"],

    "East Flanders": ["Ghent"],

    "West Flanders": ["Bruges"],

    "Limburg": ["Hasselt"],

    "Flemish Brabant": ["Leuven"],

    "Walloon Brabant": ["Brussels"],

    "Hainaut": ["Charleroi", "Mons"],

    "Liège": ["Liège"],

    "Luxembourg": ["Namur"],

    "Namur": ["Namur"],

    "Brussels-Capital Region": ["Brussels"]

  },

  "Spain": {

    "Andalusia": ["Seville", "Málaga", "Córdoba"],

    "Aragon": ["Zaragoza"],

    "Asturias": ["Asturias"],

    "Balearic Islands": ["Palma"],

    "Basque Country": ["Bilbao"],

    "Canary Islands": ["Canary Islands"],

    "Cantabria": ["Cantabria"],

    "Castile and León": ["Valladolid"],

    "Castile-La Mancha": ["Castile-La Mancha"],

    "Catalonia": ["Barcelona"],

    "Extremadura": ["Extremadura"],

    "Galicia": ["Galicia"],

    "La Rioja": ["La Rioja"],

    "Community of Madrid": ["Madrid"],

    "Region of Murcia": ["Murcia"],

    "Navarre": ["Navarre"],

    "Valencian Community": ["Valencia", "Alicante"]

  },

  "Macau": {

    "Macau SAR": ["Macau Peninsula", "Taipa", "Coloane", "Cotai"]

  },

  "Philippines": {

    "Metro Manila (NCR)": ["Manila", "Quezon City", "Makati", "Taguig", "Pasay", "Pasig"],

    "Cebu": ["Cebu City"],

    "Davao del Sur": ["Davao City"],

    "Pampanga": ["Angeles City"],

    "Batangas": [],

    "Cavite": [],

    "Laguna": [],

    "Iloilo": ["Bacolod"],

    "Bulacan": [],

    "Rizal": []

  },

  "Indonesia": {

    "Jakarta (DKI Jakarta)": ["Jakarta"],

    "West Java": ["Bandung", "Bekasi"],

    "Central Java": ["Semarang", "Yogyakarta"],

    "East Java": ["Surabaya"],

    "Banten": ["Tangerang"],

    "Bali": ["Denpasar"],

    "North Sumatra": ["Medan"],

    "South Sulawesi": ["Makassar"],

    "East Kalimantan": [],

    "Riau": []

  },

  "Sri Lanka": {

    "Western Province": ["Colombo", "Negombo"],

    "Central Province": ["Kandy"],

    "Southern Province": ["Galle", "Matara"],

    "Northern Province": ["Jaffna"],

    "North Western Province": ["Kurunegala"],

    "North Central Province": ["Anuradhapura"],

    "Eastern Province": ["Batticaloa"],

    "Sabaragamuwa Province": ["Ratnapura"],

    "Uva Province": []

  },

  "India": {

    "Andhra Pradesh": ["Visakhapatnam", "Vijayawada"],

    "Arunachal Pradesh": ["Itanagar"],

    "Assam": ["Guwahati"],

    "Bihar": ["Patna", "Bhagalpur", "Muzaffarpur", "Gaya"],

    "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur", "Korba"],

    "Goa": ["Panaji"],

    "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Anand"],

    "Haryana": [],

    "Himachal Pradesh": ["Shimla"],

    "Jharkhand": ["Ranchi", "Dhanbad", "Jamshedpur"],

    "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi", "Belagavi"],

    "Kerala": ["Kochi", "Thiruvananthapuram"],

    "Madhya Pradesh": ["Indore", "Bhopal", "Gwalior"],

    "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Thane", "Kolhapur", "Solapur"],

    "Manipur": ["Imphal"],

    "Meghalaya": ["Shillong"],

    "Mizoram": ["Aizawl"],

    "Nagaland": ["Kohima"],

    "Odisha": [],

    "Punjab": ["Amritsar", "Ludhiana", "Jalandhar"],

    "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Ajmer", "Kota", "Bikaner"],

    "Sikkim": [],

    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem", "Tiruchirappalli", "Tirunelveli"],

    "Telangana": ["Hyderabad"],

    "Tripura": ["Agartala"],

    "Uttar Pradesh": ["Lucknow", "Kanpur", "Noida", "Ghaziabad", "Meerut", "Agra", "Varanasi", "Prayagraj", "Aligarh", "Bareilly", "Moradabad", "Gorakhpur"],

    "Uttarakhand": ["Dehradun"],

    "West Bengal": ["Kolkata", "Siliguri", "Durgapur", "Asansol", "Howrah"],

    "Andaman and Nicobar Islands": [],

    "Chandigarh": ["Chandigarh"],

    "Dadra and Nagar Haveli and Daman and Diu": [],

    "Delhi": ["Delhi"],

    "Jammu and Kashmir": ["Srinagar", "Jammu"],

    "Ladakh": [],

    "Lakshadweep": [],

    "Puducherry": []

  },

  "Nepal": {

    "Bagmati Province": ["Kathmandu", "Lalitpur", "Bharatpur"],

    "Gandaki Province": ["Pokhara"],

    "Koshi Province": ["Biratnagar"],

    "Madhesh Province": ["Birgunj"],

    "Lumbini Province": ["Nepalgunj"],

    "Sudurpashchim Province": ["Dhangadhi"],

    "Karnali Province": []

  },

  "Bangladesh": {

    "Dhaka": ["Dhaka", "Gazipur", "Narayanganj"],

    "Chattogram": ["Chattogram", "Cumilla"],

    "Rajshahi": ["Rajshahi"],

    "Khulna": ["Khulna"],

    "Barishal": ["Barishal"],

    "Sylhet": ["Sylhet"],

    "Rangpur": ["Rangpur"],

    "Mymensingh": []

  },

  "Pakistan": {

    "Punjab": ["Lahore", "Faisalabad", "Multan", "Rawalpindi", "Sialkot"],

    "Sindh": ["Karachi", "Hyderabad"],

    "Khyber Pakhtunkhwa (KPK)": ["Peshawar"],

    "Balochistan": ["Quetta"],

    "Islamabad Capital Territory (ICT)": ["Islamabad"],

    "Gilgit-Baltistan": [],

    "Azad Jammu & Kashmir (AJK)": []

  },

  "Thailand": {

    "Bangkok": ["Bangkok"],

    "Chonburi": ["Pattaya"],

    "Chiang Mai": ["Chiang Mai"],

    "Phuket": ["Phuket"],

    "Songkhla": ["Hat Yai"],

    "Nakhon Ratchasima": ["Nakhon Ratchasima"],

    "Khon Kaen": ["Khon Kaen"],

    "Udon Thani": ["Udon Thani"],

    "Surat Thani": ["Surat Thani"],

    "Rayong": ["Rayong"]

  },

  "Myanmar": {

    "Yangon Region": ["Yangon"],

    "Mandalay Region": ["Mandalay"],

    "Naypyidaw Union Territory": ["Naypyidaw (Capital)"],

    "Mon State": ["Mawlamyine"],

    "Bago Region": ["Bago"],

    "Ayeyarwady Region": ["Pathein"],

    "Shan State": ["Taunggyi"],

    "Rakhine State": ["Sittwe"],

    "Kachin State": [],

    "Kayah State": [],

    "Kayin State": [],

    "Chin State": [],

    "Magway Region": [],

    "Sagaing Region": [],

    "Tanintharyi Region": []

  },

  "Bhutan": {

    "Thimphu": ["Thimphu (Capital)"],

    "Chukha": ["Phuentsholing"],

    "Paro": ["Paro"],

    "Punakha": ["Punakha"],

    "Sarpang": ["Gelephu"],

    "Samdrup Jongkhar": ["Samdrup Jongkhar"],

    "Mongar": ["Mongar"],

    "Trashigang": ["Trashigang"],

    "Wangdue Phodrang": [],

    "Samtse": [],

    "Haa": [],

    "Bumthang": [],

    "Trongsa": [],

    "Tsirang": [],

    "Dagana": [],

    "Lhuentse": [],

    "Pemagatshel": [],

    "Zhemgang": [],

    "Gasa": [],

    "Trashi Yangtse": []

  },

  "Kenya": {

    "Nairobi County": ["Nairobi"],

    "Mombasa County": ["Mombasa"],

    "Kisumu County": ["Kisumu"],

    "Nakuru County": ["Nakuru"],

    "Kiambu County": ["Thika"],

    "Uasin Gishu County": ["Eldoret"],

    "Machakos County": ["Machakos"],

    "Kakamega County": ["Kakamega"],

    "Nyeri County": ["Nyeri"],

    "Meru County": ["Meru"]

  },

  "Uganda": {

    "Central Region": ["Kampala (Capital)", "Entebbe", "Masaka"],

    "Eastern Region": ["Jinja", "Mbale"],

    "Western Region": ["Mbarara", "Fort Portal"],

    "Northern Region": ["Gulu", "Arua", "Lira"]

  },

  "Ghana": {

    "Greater Accra": ["Accra (Capital)", "Tema"],

    "Ashanti": ["Kumasi"],

    "Western": ["Takoradi"],

    "Northern": ["Tamale"],

    "Central": ["Cape Coast"],

    "Volta": ["Ho"],

    "Bono": ["Sunyani"],

    "Upper East": ["Bolgatanga"],

    "Upper West": ["Wa"],

    "Eastern": []

  },

  "Ethiopia": {

    "Addis Ababa": ["Addis Ababa"],

    "Dire Dawa": ["Dire Dawa"],

    "Oromia": ["Adama (Nazret)", "Jimma"],

    "Amhara": ["Bahir Dar", "Gondar", "Dessie"],

    "Tigray": ["Mekelle"],

    "Sidama": ["Hawassa"],

    "Somali": ["Jijiga"],

    "Afar": [],

    "Benishangul-Gumuz": [],

    "Gambela": [],

    "Harari": [],

    "South West Ethiopia": [],

    "Central Ethiopia": []

  },

  "Nigeria": {

    "Lagos": ["Lagos"],

    "Abuja (Federal Capital Territory – FCT)": ["Abuja"],

    "Kano": ["Kano"],

    "Rivers": ["Port Harcourt"],

    "Oyo": ["Ibadan"],

    "Kaduna": ["Kaduna"],

    "Edo": ["Benin City"],

    "Anambra": ["Onitsha"],

    "Delta": ["Warri"],

    "Ogun": ["Abeokuta"]

  },

  "Jordan": {

    "Amman": ["Amman"],

    "Irbid": ["Irbid"],

    "Zarqa": ["Zarqa", "Russeifa"],

    "Balqa": ["Salt"],

    "Madaba": ["Madaba"],

    "Karak": ["Karak"],

    "Tafilah": ["Tafila"],

    "Ma'an": ["Ma'an"],

    "Aqaba": ["Aqaba"],

    "Mafraq": ["Mafraq"],

    "Jerash": ["Jerash"],

    "Ajloun": ["Ajloun"]

  },

  "Malta": {

    "Northern Region": ["Mosta", "Naxxar", "St. Julian's", "Sliema"],

    "Southern Region": ["Valletta (Capital)", "Qormi", "Marsa", "Hamrun"],

    "South Eastern Region": ["Żabbar", "Marsaskala", "Fgura"],

    "Western Region": ["Rabat", "Mdina", "Birkirkara"],

    "Gozo Region": ["Victoria (Gozo)"]

  },

  "Iraq": {

    "Baghdad": ["Baghdad"],

    "Basra": ["Basra"],

    "Nineveh": ["Mosul"],

    "Erbil": ["Erbil"],

    "Sulaymaniyah": ["Sulaymaniyah"],

    "Duhok": ["Duhok"],

    "Anbar": ["Ramadi", "Fallujah"],

    "Babil": ["Hilla"],

    "Karbala": ["Karbala"],

    "Najaf": ["Najaf"],

    "Wasit": ["Kut"],

    "Diyala": ["Baqubah"],

    "Kirkuk": ["Kirkuk"],

    "Salah al-Din": ["Samarra"],

    "Maysan": ["Amarah"],

    "Dhi Qar": ["Nasiriyah"],

    "Al-Qadisiyyah": ["Al Diwaniyah"],

    "Muthanna": ["Samawah"]

  },

  "Luxembourg": {

    "Luxembourg": ["Luxembourg City (Capital)", "Strassen", "Bertrange"],

    "Esch-sur-Alzette": ["Esch-sur-Alzette", "Differdange", "Dudelange"],

    "Diekirch": ["Diekirch", "Ettelbruck"],

    "Capellen": ["Capellen"],

    "Grevenmacher": ["Grevenmacher"],

    "Mersch": ["Mersch"],

    "Redange": ["Redange"],

    "Remich": ["Remich"],

    "Clervaux": ["Clervaux"],

    "Echternach": ["Echternach"],

    "Vianden": ["Vianden"],

    "Wiltz": ["Wiltz"]

  },

  "Cyprus": {

    "Nicosia District": ["Nicosia (Capital)", "Strovolos", "Lakatamia", "Aglandjia"],

    "Limassol District": ["Limassol", "Kato Polemidia", "Mesa Geitonia", "Agios Athanasios"],

    "Larnaca District": ["Larnaca", "Aradippou", "Livadia", "Dromolaxia"],

    "Paphos District": ["Paphos", "Geroskipou", "Peyia"],

    "Famagusta District": ["Paralimni", "Ayia Napa", "Deryneia"],

    "Kyrenia District": ["Kyrenia", "Lapithos", "Karavas"]

  }

};





// Country to Apply for Job options

const allCountryApplyOptions = [

  "Jobs in Afghanistan",

  "Jobs in Albania",

  "Jobs in Algeria",

  "Jobs in Andorra",

  "Jobs in Angola",

  "Jobs in Antigua and Barbuda",

  "Jobs in Argentina",

  "Jobs in Armenia",

  "Jobs in Australia",

  "Jobs in Austria",

  "Jobs in Azerbaijan",

  "Jobs in Bahamas",

  "Jobs in Bahrain",

  "Jobs in Bangladesh",

  "Jobs in Barbados",

  "Jobs in Belarus",

  "Jobs in Belgium",

  "Jobs in Belize",

  "Jobs in Benin",

  "Jobs in Bhutan",

  "Jobs in Bolivia",

  "Jobs in Bosnia and Herzegovina",

  "Jobs in Botswana",

  "Jobs in Brazil",

  "Jobs in Brunei",

  "Jobs in Bulgaria",

  "Jobs in Burkina Faso",

  "Jobs in Burundi",

  "Jobs in Cabo Verde",

  "Jobs in Cambodia",

  "Jobs in Cameroon",

  "Jobs in Canada",

  "Jobs in Central African Republic",

  "Jobs in Chad",

  "Jobs in Chile",

  "Jobs in China",

  "Jobs in Colombia",

  "Jobs in Comoros",

  "Jobs in Congo",

  "Jobs in Costa Rica",

  "Jobs in Croatia",

  "Jobs in Cuba",

  "Jobs in Cyprus",

  "Jobs in Czech Republic",

  "Jobs in Democratic Republic of the Congo",

  "Jobs in Denmark",

  "Jobs in Djibouti",

  "Jobs in Dominica",

  "Jobs in Dominican Republic",

  "Jobs in East Timor",

  "Jobs in Ecuador",

  "Jobs in Egypt",

  "Jobs in El Salvador",

  "Jobs in Equatorial Guinea",

  "Jobs in Eritrea",

  "Jobs in Estonia",

  "Jobs in Eswatini",

  "Jobs in Ethiopia",

  "Jobs in Fiji",

  "Jobs in Finland",

  "Jobs in France",

  "Jobs in Gabon",

  "Jobs in Gambia",

  "Jobs in Georgia",

  "Jobs in Germany",

  "Jobs in Ghana",

  "Jobs in Greece",

  "Jobs in Grenada",

  "Jobs in Guatemala",

  "Jobs in Guinea",

  "Jobs in Guinea-Bissau",

  "Jobs in Guyana",

  "Jobs in Haiti",

  "Jobs in Honduras",

  "Jobs in Hong Kong",

  "Jobs in Hungary",

  "Jobs in Iceland",

  "Jobs in India",

  "Jobs in Indonesia",

  "Jobs in Iran",

  "Jobs in Iraq",

  "Jobs in Ireland",

  "Jobs in Israel",

  "Jobs in Italy",

  "Jobs in Ivory Coast",

  "Jobs in Jamaica",

  "Jobs in Japan",

  "Jobs in Jordan",

  "Jobs in Kazakhstan",

  "Jobs in Kenya",

  "Jobs in Kiribati",

  "Jobs in Korea, North",

  "Jobs in Korea, South",

  "Jobs in Kosovo",

  "Jobs in Kuwait",

  "Jobs in Kyrgyzstan",

  "Jobs in Laos",

  "Jobs in Latvia",

  "Jobs in Lebanon",

  "Jobs in Lesotho",

  "Jobs in Liberia",

  "Jobs in Libya",

  "Jobs in Liechtenstein",

  "Jobs in Lithuania",

  "Jobs in Luxembourg",

  "Jobs in Macau",

  "Jobs in Madagascar",

  "Jobs in Malawi",

  "Jobs in Malaysia",

  "Jobs in Maldives",

  "Jobs in Mali",

  "Jobs in Malta",

  "Jobs in Marshall Islands",

  "Jobs in Mauritania",

  "Jobs in Mauritius",

  "Jobs in Mexico",

  "Jobs in Micronesia",

  "Jobs in Moldova",

  "Jobs in Monaco",

  "Jobs in Mongolia",

  "Jobs in Montenegro",

  "Jobs in Morocco",

  "Jobs in Mozambique",

  "Jobs in Myanmar",

  "Jobs in Namibia",

  "Jobs in Nauru",

  "Jobs in Nepal",

  "Jobs in Netherlands",

  "Jobs in New Zealand",

  "Jobs in Nicaragua",

  "Jobs in Niger",

  "Jobs in Nigeria",

  "Jobs in North Macedonia",

  "Jobs in Norway",

  "Jobs in Oman",

  "Jobs in Pakistan",

  "Jobs in Palau",

  "Jobs in Palestine",

  "Jobs in Panama",

  "Jobs in Papua New Guinea",

  "Jobs in Paraguay",

  "Jobs in Peru",

  "Jobs in Philippines",

  "Jobs in Poland",

  "Jobs in Portugal",

  "Jobs in Qatar",

  "Jobs in Romania",

  "Jobs in Russia",

  "Jobs in Rwanda",

  "Jobs in Saint Kitts and Nevis",

  "Jobs in Saint Lucia",

  "Jobs in Saint Vincent and the Grenadines",

  "Jobs in Samoa",

  "Jobs in San Marino",

  "Jobs in Sao Tome and Principe",

  "Jobs in Saudi Arabia",

  "Jobs in Senegal",

  "Jobs in Serbia",

  "Jobs in Seychelles",

  "Jobs in Sierra Leone",

  "Jobs in Singapore",

  "Jobs in Slovakia",

  "Jobs in Slovenia",

  "Jobs in Solomon Islands",

  "Jobs in Somalia",

  "Jobs in South Africa",

  "Jobs in South Sudan",

  "Jobs in Spain",

  "Jobs in Sri Lanka",

  "Jobs in Sudan",

  "Jobs in Suriname",

  "Jobs in Sweden",

  "Jobs in Switzerland",

  "Jobs in Syria",

  "Jobs in Taiwan",

  "Jobs in Tajikistan",

  "Jobs in Tanzania",

  "Jobs in Thailand",

  "Jobs in Togo",

  "Jobs in Tonga",

  "Jobs in Trinidad and Tobago",

  "Jobs in Tunisia",

  "Jobs in Turkey",

  "Jobs in Turkmenistan",

  "Jobs in Tuvalu",

  "Jobs in Uganda",

  "Jobs in Ukraine",

  "Jobs in United Arab Emirates (UAE)",

  "Jobs in United Kingdom (UK)",

  "Jobs in United States (USA)",

  "Jobs in Uruguay",

  "Jobs in Uzbekistan",

  "Jobs in Vanuatu",

  "Jobs in Vatican City",

  "Jobs in Venezuela",

  "Jobs in Vietnam",

  "Jobs in Yemen",

  "Jobs in Zambia",

  "Jobs in Zimbabwe",

  "Jobs Worldwide (Any)"

];



const priorityCountryApplyOptions = [
  "Job in any Gulf country",
  "Job in any European country",

  "Jobs in Saudi Arabia",

  "Jobs in Dubai (UAE)",

  "Jobs in Qatar",

  "Jobs in Kuwait",

  "Jobs in Oman",

  "Jobs in Bahrain",

  "Jobs in Singapore",

  "Jobs in Brunei",

  "Jobs in South Korea",

  "Jobs in Japan",

  "Jobs in Croatia",

  "Jobs in Belgium",

  "Jobs in Poland",

  "Jobs in Yemen",

  "Jobs in Iraq",

  "Jobs in Iran",

  "Jobs in Jordan",

  "Jobs in Lebanon",

  "Jobs in Syria",

  "Jobs in Israel",

  "Jobs in Palestine"

];



const countryApplyOptions = [

  ...priorityCountryApplyOptions,

  ...allCountryApplyOptions

    .filter((country) => !priorityCountryApplyOptions.includes(country))

    .filter((country) => country !== "Jobs in Korea, South")

];





// UAE States (Emirates) and Cities Data

const uaeData = {

  country: "UAE",

  emirates: [

    {

      name: "Abu Dhabi (Emirate)",

      cities: ["Abu Dhabi", "Al Ain", "Madinat Zayed", "Ruwais", "Liwa", "Ghayathi"]

    },

    {

      name: "Dubai (Emirate)",

      cities: ["Dubai", "Jebel Ali", "Hatta"]

    },

    {

      name: "Sharjah (Emirate)",

      cities: ["Sharjah", "Khor Fakkan", "Kalba", "Dibba Al-Hisn", "Al Dhaid"]

    },

    {

      name: "Ajman (Emirate)",

      cities: ["Ajman", "Masfout", "Manama"]

    },

    {

      name: "Ras Al Khaimah (Emirate)",

      cities: ["Ras Al Khaimah", "Al Jazirah Al Hamra", "Khatt", "Rams"]

    },

    {

      name: "Fujairah (Emirate)",

      cities: ["Fujairah", "Dibba Al-Fujairah"]

    },

    {

      name: "Umm Al Quwain (Emirate)",

      cities: ["Umm Al Quwain", "Falaj Al Mualla"]

    }

  ]

};



// Get country options for dropdowns based on user type

// Get country options for dropdowns based on user type

// Update the getCountryOptions function (replace the employer section)

// const getCountryOptions = (userType, purpose = "country") => {

//   if (purpose === "nationality") {

//     if (userType === "jobSeeker") {

//       const jobSeekerNationalities = [

//         "India", "Bangladesh", "Nepal", "Sri Lanka", "Pakistan",

//         "Philippines", "Indonesia", "Myanmar", "Vietnam", "Cambodia",

//         "Thailand", "Ethiopia", "Kenya", "Uganda", "Tanzania",

//         "Rwanda", "Ghana", "Nigeria", "Sierra Leone", "Burundi", "Cameroon"

//       ];

//       return jobSeekerNationalities.sort();

//     } else {

//       return [...new Set(countryCodes

//         .filter(country => country.nationality)

//         .map(country => country.name))].sort();

//     }

//   }



//   if (userType === "jobSeeker") {

//     return [];

//   } else if (userType === "employer") {

//     // Return all countries from countryStateCityData

//     return Object.keys(countryStateCityData).sort();

//   } else if (userType === "agency") {

//     if (purpose === "country") {

//       // For agency country selection, return ALL countries from countryCodes

//       const allCountries = [...new Set(countryCodes.map(country => country.name))].sort();

//       return allCountries;

//     } else {

//       // For agency nationality, use existing logic

//       const agencyCountries = countryCodes

//         .filter(country => country.category === "employer" || country.category === "agency")

//         .map(country => country.name);

//       return [...new Set(agencyCountries)].sort();

//     }

//   }



//   return [];

// };





const getCountryOptions = (userType, purpose = "country") => {

  if (purpose === "nationality") {

    if (userType === "jobSeeker") {

      // Return ALL world countries for job seeker nationality

      return allWorldCountries.sort();

    } else if (userType === "employer") {

      // Priority countries at the top

      const priorityCountries = [

        "Qatar",

        "Dubai (UAE)",

        "UAE",

        "Saudi Arabia",

        "Kuwait",

        "Oman",

        "Bahrain",

        "Singapore",

        "Brunei",

        "South Korea",

        "Japan",

        "Croatia",

        "Belgium",

        "Poland",

        "Yemen",

        "Iraq",

        "Iran",

        "Jordan",

        "Lebanon",

        "Syria",

        "Israel",

        "Palestine"

      ];



      // Get all other countries excluding priority ones

      const otherCountries = allWorldCountries

        .filter(country => !priorityCountries.includes(country))

        .sort();



      // Return priority countries first, then all others

      return [...priorityCountries, ...otherCountries];

    } else {

      // Return ALL nationalities for agency

      return [...new Set(countryCodes

        .filter(country => country.nationality)

        .map(country => country.name))].sort();

    }

  }



  if (userType === "jobSeeker") {

    // For "Which country are you living now?" field, return ALL world countries

    return allWorldCountries.sort();

  } else if (userType === "employer") {

    // Return ALL world countries for employer

    return allWorldCountries.sort();

  } else if (userType === "agency") {

    if (purpose === "country") {

      // For agency country selection, return ALL world countries

      return allWorldCountries.sort();

    } else {

      // For agency nationality, use existing logic

      const agencyCountries = countryCodes

        .filter(country => country.category === "employer" || country.category === "agency")

        .map(country => country.name);

      return [...new Set(agencyCountries)].sort();

    }

  }



  return [];

};





// Job Position options for job seekers

const cncPositions = [
    "CNC Machinist",
  "CNC Programmer",
  "CNC Operator",
  "CNC Milling Programmer",
  "CNC Turning Programmer",
  "CNC 5-Axis Programmer",
  "CNC CAD/CAM Programmer",
  "CNC Setter",
  "CNC Setup Operator",
  "CNC Quality Inspector (CMM)",
  "CNC Maintenance Technician",
  "CNC Tool Room Technician",
  "CNC Production Technician",
  "CNC Machine Operator",
  "CNC Milling Operator",
  "CNC Turning Operator",
  "CNC Lathe Operator",
  "CNC VMC Operator",
  "CNC HMC Operator"
];

const getUniqueOptions = (options) =>

  Array.from(

    new Set(

      (Array.isArray(options) ? options : [])

        .map((option) => String(option ?? "").trim())

        .filter(Boolean)

    )

  );


const baseJobPositionOptions = [
  "Home Care Nurse",
  "Elderly Care",
  "Company Driver",
  "Light Driver",
  ...DOMESTIC_HELPER_POSITIONS,
  "Driver (Company / House)",
  "Bus Driver",
  "Plumber",
  "Taxi Driver",
  "Operator",
  "Electrician",
  "Welder",
  "6G Certified Pipe Welder",
  "6G TIG + SMAW Pipe Welder",
  "6G / 6GR Pipe Welder",
  "High Pressure 6G Pipe Welder",
  "ASME 6G Pipe Welder",
  "6G Oil & Gas Pipe Welder",
  "Nurse",
  "Tutor",
  "Hospital Nurse",

  "Physiotherapy",

  "Midwife (Midwifery)",

  "Hospital Doctor",

  "Resident Doctor",

  "Heavy Driver",

  "Bike Driver",

  "Workers",

  "Skilled Workers",

  "Construction Workers",

  "Skilled Construction Workers",

  "Mason",

  "Carpenter",

  "Steel Fixer",

  "Painter",

  "AC Technician", "HVAC Technician", "Chiller Technician",

  "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator",

  "Heavy Equipment Operator",

  "Scaffolder",

  "Healthcare Assistants",

  "Doctors",

  "Lab Technicians",

  "Physiotherapy",

  "Physiotherapists",

  "Elderly Care Workers",

  ...HOSPITALITY_POSITIONS,

  ...SOFTWARE_IT_POSITIONS,

  ...CONSTRUCTION_POSITIONS,

  ...RETAIL_SALES_POSITIONS,

  ...CLEANING_MAINTENANCE_POSITIONS,

  ...SECURITY_POSITIONS,

  ...OFFICE_STAFF_POSITIONS,

  "Factory Workers",

  "Production Workers",

  "Warehouse Workers",

  "Packing Staff",

  "Machine Operators",

  "Assembly Line Workers",

  "Forklift Operators",

  "Delivery Drivers",

  "Truck Drivers",

  "Logistics Staff",

  "Farm Workers",

  "Fruit Pickers",

  "Dairy Workers",

  "Poultry Workers",

  "Greenhouse Workers",

  "Caretakers",

  ...cncPositions,

  "Machine Operator",

  "Assembly Line Worker",

  "Production Worker",

  "MIG Welder",

  "TIG Welder",

  "Industrial Welder",

  "Fabricator",

  "Pipe Fitter",

  "Steel Structure Welder",

  "Heavy Truck Mechanic",

  "Diesel Mechanic",

  "Auto Mechanic",

  "Bus Mechanic",

  "Vehicle Technician",

  "Industrial Electrician",

  "Maintenance Electrician",

  "Panel Electrician",

  "Maintenance Technician",

  "Electrical Technician",

  "PLC Technician",

  "Automation Technician",

  "Construction Worker",

  "Warehouse Worker",

  "Forklift Operator",

  "Picker & Packer",

  "Delivery Van Driver",

  "Logistics Assistant",

  "Heavy Truck Driver (CE)",

  "Trailer Driver",

  "Chef",

  "Kitchen Assistant",

  "Hotel Housekeeping",

  "Medical Technician",

  "Instrument Technician",

  "Mechanical Maintenance Technician",

  "Heavy Equipment Mechanic",

  "6G Welder",

  "Structural Welder",

  "Shipyard Welder",
  "FCAW Welder (Shipyard)",
  "MIG/MAG Welder (Shipyard)",
  "TIG Welder (Shipyard)",
  "6G Pipe Welder (Shipyard)",

  "Elevator Technician",
  "Elevator Installation Technician",
  "Elevator Maintenance Technician",
  "Elevator Repair Technician",
  "Escalator Technician",

  "Heavy Trailer Driver",

  "Fuel Tanker Driver",

  "Ready-Mix Driver",

  "Registered Nurse",
  "Professional Chef",
  "Home Nurse",
  "Salesman",
  "Sales Executive",
  "Senior Sales Executive",
  "Outdoor Salesman",
  "Indoor Salesman",
  "Business Development Executive",
  "Marketing Executive",
  "Digital Marketing Executive",
  "Tele-Sales Executive",
  "Account Manager (Sales)",
  "Receptionist",
  "Front Desk Executive",
  "Office Assistant",
  "Office Boy",
  "Office Helper",
  "Admin Assistant",
  "Customer Support Executive",
  "Call Center Agent",
  "Admin Executive",
  "Office Administrator",
  "Operations Executive",
  "Document Controller",
  "Data Entry Operator",
  "HR Assistant",
  "HR Executive",
  "Accountant",
  "Assistant Accountant",
  "Accounts Executive",
  "Cashier",
  "Billing Executive",
  "Payroll Executive",
  "Back Office Executive",
  "Office Coordinator",
  "Project Coordinator",
  "Logistics Coordinator",
  "Sales Coordinator",
  "Office Manager",
  "Operations Manager",
  "Admin Manager",
  "Sales Manager"
];

const companyWorkerBottomOptions = [
  "JCB Operator",
  "Bulldozer Operator",
  "Excavator Operator",
  "Loader Operator",
  "Skid Steer Loader Operator",
  "Grader Operator",
  "Trench Excavator / Trencher Operator",
  "Backhoe Operator",
  "Dragline Operator",
  "Scraper Operator",
  "Crane Operator",
  "Telehandler Operator",
  "Reach Stacker Operator",
  "Boom Lift / Cherry Picker Operator",
  "Container Handler Operator",
  "Road Roller Operator",
  "Asphalt Paver Operator",
  "Bitumen Sprayer Operator",
  "Concrete Paver Operator",
  "Soil Stabilizer Operator",
  "Drilling Machine / Drill Rig Operator",
  "Rock Breaker / Hydraulic Hammer Operator",
  "Loader-Dumper Operator",
  "Dump Truck Operator",
  "Stone Crusher Operator",
  "Grizzly Feeder / Conveyor Operator",
  "Tractor Operator",
  "Harvester / Combine Operator",
  "Dozer / Land Leveling Operator",
  "Tower Crane Operator",
  "Mobile Crane Operator",
  "Crawler Crane Operator",
  "Piling Machine Operator",
  "Concrete Mixer Truck Operator",
  "Concrete Pump Operator",
  "Compactor Operator",
  "Pipe Layer Operator",
  "Forklift / Warehouse Equipment Operator",
  "Boom Truck / Loader Crane Operator",
  "Road Sweeper Operator",
  "Water Tanker / Firefighting Vehicle Operator",
  "Excavator Mounted Drill Operator",
  "Heavy Truck / Tip Truck Operator",
  "Loader Excavator Operator",
  "Teleporter Crane Operator",
  "Material Handler / Port Crane Operator",
  "Hydraulic Excavator Operator",
  "Multi-Functional Heavy M"
];

const jobPositionOptions = getUniqueOptions([
  ...baseJobPositionOptions,
  ...companyWorkerBottomOptions.filter((position) => !baseJobPositionOptions.includes(position))
]);




// Worker Category Options for Employer - Use same options as job positions

const workerCategoryOptions = jobPositionOptions;



// Comprehensive list of all countries for agency registration

const allWorldCountries = [

  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",

  "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",

  "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",

  "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad",

  "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",

  "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor",

  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji",

  "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala",

  "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia",

  "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan",

  "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",

  "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",

  "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia",

  "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",

  "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",

  "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",

  "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines",

  "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",

  "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan",

  "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",

  "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",

  "Ukraine", "Dubai (UAE)", "UAE", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",

  "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"

];





// Driving License Options

const drivingLicenseOptions = [
    "Not Licensed", "Qatar", "Dubai", "Oman", "Saudi", "Kuwait", "Bahrain", "EU Driving Licence", "Singapore",
    "UAE", "Turkey", "Malaysia", "Taiwan", "South Korea", "Hongkong", "Russia",
    "Jordan", "Israel", "USA", "UK", "Canada", "Australia", "India", "Philippines",
    "Saudi Arabia", "Brunei", "Hong Kong", "Japan", "Germany", "Netherlands",
    "United Kingdom", "Italy", "Spain", "France", "Poland", "Portugal", "Romania",
    "Hungary", "United States", "New Zealand", "Bangladesh", "Nepal", "Sri Lanka",
    "Pakistan", "Indonesia", "Myanmar", "Vietnam", "Cambodia", "Thailand",
    "Ethiopia", "Kenya", "Uganda", "Tanzania", "Rwanda", "Ghana", "Nigeria",
    "Sierra Leone", "Burundi", "Cameroon", "Maldives",
    "Home Country Licence", "International Driving Permit"
];



// Total Experience Options

const totalExperienceOptions = [

  "Fresher (0 Year)",

  "1 – 2 Years",

  "2 – 3 Years",

  "3 – 5 Years",

  "5 – 7 Years",

  "7 – 10 Years",

  "10+ Years"

];





// Nurse-related job positions

const nursePositions = [
  "Nurse",

  "Home Care Nurse",

  "Hospital Nurse",

  "Physiotherapy",

  "Midwife (Midwifery)",


  "Registered Nurse"

];

const doctorPositionKeywords = [
  "doctor",
  "physician",
  "surgeon",
  "pediatrician",
  "gynecologist",
  "orthopedic",
  "cardiologist",
  "neurologist",
  "dermatologist",
  "ent",
  "ophthalmologist",
  "anesthesiologist",
  "radiologist",
  "psychiatrist",
  "medical officer",
  "dental"
];

const hasHealthcareLicenseFlow = (jobPosition) => {
  const normalizedPosition = String(jobPosition || "").toLowerCase().trim();
  if (!normalizedPosition) return false;
  return nursePositions.includes(jobPosition) || doctorPositionKeywords.some((keyword) => normalizedPosition.includes(keyword));
};



// Nurse License / Exam Status options

const nurseLicenseOptions = [

  "Not Yet Started",

  "DataFlow Completed",

  "DataFlow In Process",

  "Prometric Completed",

  "Prometric In Process",

  "Prometric + DataFlow Completed"

];

const nursingLicenseCountries = [
  "Qatar - QCHP / DHP",
  "UAE - DHA / DOH / MOH",
  "Saudi Arabia - SCFHS",
  "Oman - MOH License",
  "Kuwait - MOH License",
  "Bahrain - NHRA",
  "Applied",
  "In Progress",
  "Eligible",
  "UK - NMC Registration",
  "Germany - Nursing License",
  "Ireland - NMBI",
  "Netherlands - BIG Register",
  "France - Nursing License",
  "Italy - Nursing License",
  "Not Licensed",
  "Spain - Nursing License",
  "Belgium - Nursing License",
  "Norway / Sweden - Nursing License",
  "Poland - Nursing License",
  "Romania - Nursing License",
  "Croatia - Nursing License",
  "Singapore - SNB License",
  "Malaysia - Nursing Board",
  "Hong Kong - Nursing Council",
  "Japan - Nursing License",
  "South Korea - Nursing License",
  "USA - NCLEX-RN",
  "Canada - NCLEX / Provincial License",
  "Australia - AHPRA",
  "New Zealand - Nursing Council"
];



// Cook-related job positions

const cookPositions = [

  "Home Cook",

  "Cook",

  "Chef",

  "Chefs",

  "Professional Chef",

  "Personal Chef"

];



// Cook Category Options

const cookCategoryOptions = [

  { group: "Arabic", options: ["Arabic Cook", "Lebanese Cook", "Turkish Cook", "Iranian Cook", "Yemeni Cook", "Moroccan Cook"] },

  { group: "Asian (South/South East)", options: ["Indian Cook", "Pakistani Cook", "Nepali Cook", "Sri Lankan Cook", "Bangladeshi Cook", "Filipino Cook", "Indonesian Cook", "Thai Cook", "Malaysian Cook", "Vietnamese Cook"] },

  { group: "Continental/European", options: ["Continental Cook", "Italian Cook", "French Cook", "Greek Cook", "Spanish Cook", "German Cook", "British Cook"] },

  { group: "Far East Asian", options: ["Chinese Cook", "Japanese Cook", "Korean Cook", "Sushi Chef", "Teppanyaki Chef"] },

  { group: "American/BBQ", options: ["American Cook", "Mexican Cook", "Tex-Mex Cook", "BBQ Cook"] },

  { group: "Others", options: ["Multi-Cuisine Cook"] }

];



// Flattened Cook Category Options for MultiSelectDropdown

const flatCookCategoryOptions = cookCategoryOptions.reduce((acc, group) => [...acc, ...group.options], []);





// Add these helper functions after getCountryOptions

const getAvailableStates = (country) => {

  if (!country || !countryStateCityData[country]) {

    return [];

  }

  return Object.keys(countryStateCityData[country]);

};



const getAvailableCities = (country, state) => {

  if (!country || !state || !countryStateCityData[country]) {

    return [];

  }

  return countryStateCityData[country][state] || [];

};







// Get phone country codes based on user type

// Get phone country codes based on user type

const getPhoneCountryCodes = (userType) => {

  if (userType === "jobSeeker") {

    // For job seekers, return ALL country codes

    const uniqueCountries = [];

    const seen = new Set();



    countryCodes.forEach(country => {

      if (!seen.has(country.name)) {

        seen.add(country.name);

        uniqueCountries.push(country);

      }

    });



    return uniqueCountries;

  } else if (userType === "employer") {

    return countryCodes.filter(country => country.category === "employer");

  } else if (userType === "agency") {

    // For agency, return ALL country codes from the countryCodes array

    // Remove duplicates by creating a Set of unique country codes

    const uniqueCountries = [];

    const seen = new Set();



    countryCodes.forEach(country => {

      if (!seen.has(country.name)) {

        seen.add(country.name);

        uniqueCountries.push(country);

      }

    });



    return uniqueCountries;

  }

  return countryCodes;

};



// Function to validate phone number input

const validatePhoneNumber = (value) => {

  return value.replace(/\D/g, '');

};



// Custom Dropdown Component with search

// Custom Dropdown Component with search

const CustomDropdown = ({

  title,

  field,

  options,

  selectedValue,

  onSelect,

  required = false,

  error = null,

  className = "",

  userType = "",

  purpose = "country",

  disabled = false,

  disabledMessage = null

}) => {

  const [searchTerm, setSearchTerm] = useState("");

  const [isOpen, setIsOpen] = useState(false);



  const filteredOptions = options.filter(option =>

    option.toLowerCase().includes(searchTerm.toLowerCase())

  );



  const getCountryCode = (countryName) => {

    const country = countryCodes.find(c => c.name === countryName);

    return country ? country.code : "";

  };



  return (

    <div className="mb-3">

      <Dropdown show={isOpen} onToggle={(nextShow) => {

        if (nextShow && disabledMessage) {

          Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

            let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

            if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

            if (targetElement) {

              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

              targetElement.classList.add('is-invalid');

              targetElement.classList.add('flash-highlight');



              setTimeout(() => {

                targetElement.classList.remove('flash-highlight');

              }, 1000);



              if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

            }

          });

          return;

        }

        setIsOpen(nextShow);

      }}>

        <Dropdown.Toggle

          variant="light"

          disabled={disabled}

          className={`w-100 d-flex justify-content-between align-items-center ${className} ${error ? 'is-invalid' : ''}`}

          id={`dropdown-${field}`}

          style={{

            textAlign: 'left',

            border: '1px solid #ced4da',

            borderRadius: '0.375rem',

            backgroundColor: '#fff',

            padding: '0.375rem 0.75rem',

            color: selectedValue ? '#212529' : '#6c757d',

            minHeight: '50px'

          }}

        >

          <span className="text-truncate">

            {selectedValue || `${title}${required ? ' *' : ''}`}

          </span>

          {/* REMOVED: <FaChevronDown className="ms-2" size={14} /> */}

        </Dropdown.Toggle>



        <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: '300px' }}>

          {/* Search Input */}

          <div className="px-2 mb-2 position-relative">

            <FaSearch

              className="position-absolute"

              style={{ top: '12px', left: '20px', color: '#6c757d' }}

              size={14}

            />

            <Form.Control

              type="text"

              placeholder={`Search ${purpose === "nationality" ? "nationality" : "country"}...`}

              value={searchTerm}

              onChange={(e) => setSearchTerm(e.target.value)}

              onClick={(e) => e.stopPropagation()}

              className="ps-4"

              style={{ paddingLeft: '35px' }}

              autoFocus

            />

          </div>



          {/* Options List */}

          <div className="dropdown-options" style={{ maxHeight: '250px' }}>

            {filteredOptions.length > 0 ? (

              filteredOptions.map((option) => {

                const code = purpose === "nationality" ? "" : getCountryCode(option);

                return (

                  <Dropdown.Item

                    key={option}

                    onClick={() => {

                      onSelect(field, option);

                      setSearchTerm("");

                      setIsOpen(false);

                    }}

                    className="d-flex justify-content-between align-items-center py-2"

                    active={selectedValue === option}

                  >

                    <span>{option}</span>

                    {code && purpose !== "nationality" && (

                      <small className="text-muted ms-2">{code}</small>

                    )}

                  </Dropdown.Item>

                );

              })

            ) : (

              <Dropdown.Item disabled className="text-center py-2">

                No options found

              </Dropdown.Item>

            )}

          </div>

        </Dropdown.Menu>

      </Dropdown>

      {error && <div className="invalid-feedback d-block">{error}</div>}

    </div>

  );

};



// Phone Input Component

const PhoneInputWithCountryCode = React.memo(({

  numberField,

  countryCodeField,

  placeholder,

  required = false,

  className = "form-control rounded-input",

  formData,

  onCountryCodeChange,

  onInputChange,

  userType = "",

  disabledMessage = null

}) => {

  const [searchTerm, setSearchTerm] = useState("");

  const [isOpen, setIsOpen] = useState(false);



  const filteredCountries = getPhoneCountryCodes(userType).filter(country =>

    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||

    country.code.toLowerCase().includes(searchTerm.toLowerCase())

  );



  const getDisplayValue = (code) => {

    const country = countryCodes.find(c => c.code === code);

    return country ? `${code} (${country.name})` : "Select Code";

  };



  return (

    <div className="row g-2 align-items-center">

      <div className="col-6">

        <Dropdown show={isOpen} onToggle={(nextShow) => {

          if (nextShow && disabledMessage) {

            Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

              let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

              if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

              if (targetElement) {

                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                targetElement.classList.add('is-invalid');

                targetElement.classList.add('flash-highlight');



                setTimeout(() => {

                  targetElement.classList.remove('flash-highlight');

                }, 1000);



                if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

              }

            });

            return;

          }

          setIsOpen(nextShow);

        }}>

          <Dropdown.Toggle

            variant="light"

            className="w-100 d-flex justify-content-between align-items-center"

            style={{

              border: '1px solid #ced4da',

              borderRadius: '0.375rem',

              backgroundColor: '#fff',

              padding: '0.375rem 0.75rem',

              fontSize: '0.875rem',

              minHeight: '50px'

            }}

          >

            <span className="text-truncate">

              {getDisplayValue(formData[countryCodeField])}

            </span>

            {/* REMOVED: <FaChevronDown className="ms-2" size={12} /> */}

          </Dropdown.Toggle>



          <Dropdown.Menu className="w-100 p-2" style={{ maxWidth: '300px' }}>

            <div className="px-2 mb-2 position-relative">

              <FaSearch

                className="position-absolute"

                style={{ top: '10px', left: '15px', color: '#6c757d' }}

                size={12}

              />

              <Form.Control

                type="text"

                placeholder="Search country/code..."

                value={searchTerm}

                onChange={(e) => setSearchTerm(e.target.value)}

                className="ps-4 py-1"

                style={{ fontSize: '0.875rem' }}

                size="sm"

                autoFocus

              />

            </div>



            <div style={{ maxHeight: '200px' }}>

              {filteredCountries.map((country) => (

                <Dropdown.Item

                  key={`${country.code}-${country.name}`}

                  onClick={() => {

                    onCountryCodeChange(countryCodeField, country.code);

                    setSearchTerm("");

                    setIsOpen(false);

                  }}

                  className="d-flex justify-content-between align-items-center py-1"

                  style={{ fontSize: '0.875rem' }}

                >

                  <span className="text-truncate">{country.name}</span>

                  <span className="text-muted ms-2">{country.code}</span>

                </Dropdown.Item>

              ))}

            </div>

          </Dropdown.Menu>

        </Dropdown>

      </div>



      <div className="col-6">

        <input

          type="tel"

          name={numberField}

          className={className}

          placeholder={placeholder}

          value={formData[numberField] || ""}

          onChange={onInputChange}

          required={required}

          pattern="[0-9]*"

          inputMode="numeric"

          onClick={(e) => {

            if (disabledMessage) {

              e.preventDefault();

              e.target.blur();

              if (!Swal.isVisible()) {

                Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

                  let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

                  if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

                  if (targetElement) {

                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    targetElement.classList.add('is-invalid');

                    targetElement.classList.add('flash-highlight');



                    setTimeout(() => {

                      targetElement.classList.remove('flash-highlight');

                    }, 1000);



                    if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

                  }

                });

              }

            }

          }}

          onFocus={(e) => {

            if (disabledMessage) {

              e.preventDefault();

              e.target.blur();

              if (!Swal.isVisible()) {

                Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

                  let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

                  if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

                  if (targetElement) {

                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    targetElement.classList.add('is-invalid');

                    targetElement.classList.add('flash-highlight');

                    if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

                  }

                });

              }

            }

          }}

          onKeyPress={(e) => {

            if (!/[0-9]/.test(e.key) &&

              e.key !== 'Backspace' &&

              e.key !== 'Delete' &&

              e.key !== 'Tab' &&

              e.key !== 'ArrowLeft' &&

              e.key !== 'ArrowRight' &&

              e.key !== 'Home' &&

              e.key !== 'End') {

              e.preventDefault();

            }

          }}

          style={{ height: '50px' }}

        />

      </div>

    </div>

  );

});



// Get UAE emirates (states)

const getUaeEmirates = () => {

  return uaeData.emirates.map(emirate => emirate.name);

};



// Get UAE cities based on selected emirate

const getUaeCities = (emirateName) => {

  const selectedEmirate = uaeData.emirates.find(

    emirate => emirate.name === emirateName

  );

  return selectedEmirate ? selectedEmirate.cities : [];

};



// Custom UAE Dropdown Component

const UAEDropdown = ({

  title,

  field,

  options,

  selectedValue,

  onSelect,

  required = false,

  error = null,

  className = "",

  disabled = false

}) => {

  const [searchTerm, setSearchTerm] = useState("");

  const [isOpen, setIsOpen] = useState(false);



  const filteredOptions = options.filter(option =>

    option.toLowerCase().includes(searchTerm.toLowerCase())

  );



  return (

    <div className="mb-3">

      <Dropdown show={isOpen} onToggle={(isOpen) => setIsOpen(isOpen)}>

        <Dropdown.Toggle

          variant="light"

          className={`w-100 d-flex justify-content-between align-items-center ${className} ${error ? 'is-invalid' : ''}`}

          id={`dropdown-${field}`}

          disabled={disabled}

          style={{

            textAlign: 'left',

            border: '1px solid #ced4da',

            borderRadius: '0.375rem',

            backgroundColor: '#fff',

            padding: '0.375rem 0.75rem',

            color: selectedValue ? '#212529' : '#6c757d',

            minHeight: '50px',

            opacity: disabled ? 0.6 : 1

          }}

        >

          <span className="text-truncate">

            {selectedValue || `${title}${required ? ' *' : ''}`}

          </span>

          <FaChevronDown className="ms-2" size={14} />

        </Dropdown.Toggle>



        <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: '300px' }}>

          <div className="px-2 mb-2 position-relative">

            <FaSearch

              className="position-absolute"

              style={{ top: '12px', left: '20px', color: '#6c757d' }}

              size={14}

            />

            <Form.Control

              type="text"

              placeholder={`Search ${title.toLowerCase()}...`}

              value={searchTerm}

              onChange={(e) => setSearchTerm(e.target.value)}

              onClick={(e) => e.stopPropagation()}

              className="ps-4"

              style={{ paddingLeft: '35px' }}

              autoFocus

            />

          </div>



          <div className="dropdown-options" style={{ maxHeight: '250px' }}>

            {filteredOptions.length > 0 ? (

              filteredOptions.map((option) => (

                <Dropdown.Item

                  key={option}

                  onClick={() => {

                    onSelect(field, option);

                    setSearchTerm("");

                    setIsOpen(false);

                  }}

                  className="py-2"

                  active={selectedValue === option}

                >

                  {option}

                </Dropdown.Item>

              ))

            ) : (

              <Dropdown.Item disabled className="text-center py-2">

                No options found

              </Dropdown.Item>

            )}

          </div>

        </Dropdown.Menu>

      </Dropdown>

      {error && <div className="invalid-feedback d-block">{error}</div>}

    </div>

  );

};



// Age Dropdown Component

const AgeDropdown = ({ selectedValue, onSelect, disabled = false, disabledMessage = null }) => {

  const [searchTerm, setSearchTerm] = useState("");

  const [isOpen, setIsOpen] = useState(false);



  const ages = Array.from({ length: 63 }, (_, i) => (i + 18).toString());

  const filteredAges = ages.filter(age => age.includes(searchTerm));



  return (

    <Dropdown show={isOpen} onToggle={(nextShow) => {

      if (nextShow && disabledMessage) {

        Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

          let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

          if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

          if (targetElement) {

            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

            targetElement.classList.add('is-invalid');

            targetElement.classList.add('flash-highlight');



            setTimeout(() => {

              targetElement.classList.remove('flash-highlight');

            }, 1000);



            if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

          }

        });

        return;

      }

      setIsOpen(nextShow);

    }}>

      <Dropdown.Toggle

        variant="light"

        disabled={disabled}

        className="w-100 d-flex justify-content-between align-items-center"

        style={{

          textAlign: 'left',

          border: '1px solid #ced4da',

          borderRadius: '0.375rem',

          backgroundColor: '#fff',

          padding: '0.375rem 0.75rem',

          color: selectedValue ? '#212529' : '#6c757d',

          minHeight: '50px'

        }}

      >

        <span className="text-truncate">

          {selectedValue || 'Select Age'}

        </span>

      </Dropdown.Toggle>



      <Dropdown.Menu className="w-100 p-2">

        <div className="px-2 mb-2 position-relative">

          <FaSearch

            className="position-absolute"

            style={{ top: '12px', left: '20px', color: '#6c757d' }}

            size={14}

          />

          <Form.Control

            type="text"

            placeholder="Search select your age..."

            value={searchTerm}

            onChange={(e) => setSearchTerm(e.target.value)}

            onClick={(e) => e.stopPropagation()}

            className="ps-4"

            style={{ paddingLeft: '35px' }}

            autoFocus

          />

        </div>



        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>

          {filteredAges.length > 0 ? (

            filteredAges.map((age) => (

              <Dropdown.Item

                key={age}

                onClick={() => {

                  onSelect('age', age);

                  setSearchTerm("");

                  setIsOpen(false);

                }}

                className="py-2"

                active={selectedValue === age}

              >

                {age}

              </Dropdown.Item>

            ))

          ) : (

            <Dropdown.Item disabled className="text-center py-2">

              No age found

            </Dropdown.Item>

          )}

        </div>

      </Dropdown.Menu>

    </Dropdown>

  );

};



const Register = () => {



  const location = useLocation();

  const { state } = location;

  const [userType, setUserType] = useState(state?.defaultTab || "jobSeeker");

  const navigate = useNavigate();

  const [formData, setFormData] = useState({

    // Common fields

    first_name: "",

    last_name: "",

    gender: "",

    age: "",

    religion: "",

    mobile_number: "",

    mobile_number_country_code: "",

    whatsapp_number: "",

    whatsapp_country_code: "",

    driving_license_country: [],

    driving_country_experience: [],

    total_work_experience: "",

    email: "",

    category: "",

    job_position: "",

    nurse_license_status: "",
    nursing_license_countries: [],

    cook_category: [],

    current_country: "",

    password: "",

    confirmPassword: "",

    nationality: "",

    expected_monthly_salary_currency: "",

    expected_monthly_salary: "",

    expected_monthly_salary_usd: "",

    expected_monthly_salary_qar: "",

    salary_type: "",

    salary_value: "",

    country_apply_for_job: "",

    country: "",

    state_or_province: "",

    working_city: "",

    termsAccepted: false,

    // UAE specific fields for employer

    domestic_worker_category: "",

    employer_type: "",

    company_size: "",

    uae_country: "",

    uae_emirate: "",

    uae_city: "",

    // Agency specific fields

    agency_name: "",

    contact_person_name: "",

    city: "",

    province: "",

    full_address: "",

    whatsapp_number_1: "",

    whatsapp_number_1_country_code: "",

    whatsapp_number_2: "",

    whatsapp_number_2_country_code: "",

    whatsapp_number_3: "",

    whatsapp_number_3_country_code: "",

    whatsapp_number_4: "",

    whatsapp_number_4_country_code: "",

    official_phone: "",

    official_phone_country_code: "",

    website_url: "",

    owner_name: "",

    owner_nationality: "",

    owner_mobile: "",

    owner_mobile_country_code: "",

    owner_email: "",

    manager_name: "",

    manager_nationality: "",

    manager_mobile: "",

    manager_mobile_country_code: "",

    manager_email: "",

    recruitment_categories: [],

    selected_plan: "Free",

    legalConfirmation: false,

  });



  const [showPassword, setShowPassword] = useState(false);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const [emailError, setEmailError] = useState("");

  const [otp, setOtp] = useState("");

  const [otpSent, setOtpSent] = useState(false);

  const [otpVerified, setOtpVerified] = useState(false);

  const [otpError, setOtpError] = useState("");

  const [otpLoading, setOtpLoading] = useState(false);

  const [registrationStep, setRegistrationStep] = useState(1);

  const [errors, setErrors] = useState({});

  const [whatsappSameAsMobile, setWhatsappSameAsMobile] = useState(false);



  // For file uploads

  const [files, setFiles] = useState({

    company_logo: null,

    business_card: null,

    license_copy: null,

    owner_photo: null,

    office_building_photo: null

  });



  const userOptions = [

    {

      value: "jobSeeker",

      label: "Job Seeker",

      sub: "I am looking for job",

    },

    {

      value: "employer",

      label: "Employer",

      sub: "I Want to hire",

    },

    {

      value: "agency",

      label: "Agency",

      sub: "Recruitment Agency",

    },

  ];



  const capitalizeFirstLetter = (value) => {

    if (!value) return value;



    const words = value.split(' ');

    const capitalizedWords = words.map(word => {

      if (word.length === 0) return word;

      return word.charAt(0).toUpperCase() + word.slice(1);

    });



    return capitalizedWords.join(' ');

  };



  const validateField = (name, value, currentFormData = formData) => {

    const newErrors = { ...errors };



    switch (name) {

      case 'email':

        if (!value) {

          newErrors.email = 'Email is required';

        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {

          newErrors.email = 'Please enter a valid email address';

        } else {

          delete newErrors.email;

        }

        break;



      // case 'password':

      //   if (!value) {

      //     newErrors.password = 'Password is required';

      //   } else if (value.length < 8) {

      //     newErrors.password = 'Password must be at least 8 characters';

      //   } else {

      //     delete newErrors.password;

      //   }

      //   break;



      // case 'confirmPassword':

      //   if (!value) {

      //     newErrors.confirmPassword = 'Please confirm your password';

      //   } else if (value !== currentFormData.password) {

      //     newErrors.confirmPassword = 'Passwords do not match';

      //   } else {

      //     delete newErrors.confirmPassword;

      //   }

      //   break;



      // In validateField function, add these cases:



      case 'category':

        if (!value) {

          newErrors.category = 'Category is required';

        } else {

          delete newErrors.category;

        }

        break;



      case 'job_position':

        if (!value) {

          newErrors.job_position = 'Job Position is required';

        } else {

          delete newErrors.job_position;

          // Only validate these dependent fields if a position is actually selected

          if (userType === "jobSeeker" && nursePositions.includes(value)) {

            validateField('nurse_license_status', currentFormData.nurse_license_status, { ...currentFormData, job_position: value });

          }

          if (userType === "jobSeeker" && cookPositions.includes(value)) {

            validateField('cook_category', currentFormData.cook_category, { ...currentFormData, job_position: value });

          }

        }

        break;



      // In the validateField function, add these cases:



      case 'domestic_worker_category':

        if (userType === "employer" && !value) {

          newErrors.domestic_worker_category = 'Worker category is required';

        } else {

          delete newErrors.domestic_worker_category;

        }

        break;



      case 'mobile_number':

        if (userType === "employer" && !value) {

          newErrors.mobile_number = 'Mobile number is required';

        } else if (userType === "employer" && value.length < 7) {

          newErrors.mobile_number = 'Please enter a valid mobile number';

        } else {

          delete newErrors.mobile_number;

        }

        break;



      case 'mobile_number_country_code':

        if (userType === "employer" && !value) {

          newErrors.mobile_number_country_code = 'Country code is required';

        } else {

          delete newErrors.mobile_number_country_code;

        }

        break;



      case 'whatsapp_number':

        if (userType === "employer" && !value) {

          newErrors.whatsapp_number = 'WhatsApp number is required';

        } else if (userType === "employer" && value.length < 7) {

          newErrors.whatsapp_number = 'Please enter a valid WhatsApp number';

        } else {

          delete newErrors.whatsapp_number;

        }

        break;



      case 'whatsapp_country_code':

        if (userType === "employer" && !value) {

          newErrors.whatsapp_country_code = 'WhatsApp country code is required';

        } else {

          delete newErrors.whatsapp_country_code;

        }

        break;



      case 'driving_license_country':

        if (userType === "jobSeeker" && Array.isArray(value) && value.length > 5) {

          newErrors.driving_license_country = 'Maximum 5 driving licenses can be selected';

        } else {

          delete newErrors.driving_license_country;

        }

        break;



      case 'driving_country_experience':

        if (userType === "jobSeeker" && Array.isArray(value) && value.length > 3) {

          newErrors.driving_country_experience = 'Maximum 3 countries can be selected';

        } else {

          delete newErrors.driving_country_experience;

        }

        break;



      case 'job_position':

        if (userType === "jobSeeker" && !value) {

          newErrors.job_position = 'Job position is required';

        } else {

          delete newErrors.job_position;

        }



        if (nursePositions.includes(value)) {

          validateField('nurse_license_status', currentFormData.nurse_license_status, { ...currentFormData, job_position: value });

        } else if (cookPositions.includes(value)) {

          validateField('cook_category', currentFormData.cook_category, { ...currentFormData, job_position: value });

        }

        break;



      case 'nurse_license_status':

        if (userType === "jobSeeker" && hasHealthcareLicenseFlow(currentFormData.job_position) && !value) {

          newErrors.nurse_license_status = 'License / Exam status is required';

        } else {

          delete newErrors.nurse_license_status;

        }

        break;



      case 'current_country':

        if (userType === "jobSeeker" && !value) {

          newErrors.current_country = 'Current country is required';

        } else {

          delete newErrors.current_country;

        }

        break;



      case 'whatsapp_number':

        if (!value) {

          newErrors.whatsapp_number = 'WhatsApp number is required';

        } else if (value.length < 7) {

          newErrors.whatsapp_number = 'Please enter a valid WhatsApp number';

        } else {

          delete newErrors.whatsapp_number;

        }

        break;



      case 'whatsapp_country_code':

        if (!value) {

          newErrors.whatsapp_country_code = 'WhatsApp country code is required';

        } else {

          delete newErrors.whatsapp_country_code;

        }

        break;



      case 'password':

        if (!value) {

          newErrors.password = 'Password is required';

        } else if (value.length < 8) {

          newErrors.password = 'Password must be at least 8 characters';

        } else {

          delete newErrors.password;

        }

        break;



      case 'confirmPassword':

        if (!value) {

          newErrors.confirmPassword = 'Please confirm your password';

        } else if (value !== currentFormData.password) {

          newErrors.confirmPassword = 'Passwords do not match';

        } else {

          delete newErrors.confirmPassword;

        }

        break;



      case 'cook_category':

        if (userType === "jobSeeker" && cookPositions.includes(currentFormData.job_position) && (!value || value.length === 0)) {

          newErrors.cook_category = 'Please select at least one cook category';

        } else {

          delete newErrors.cook_category;

        }

        break;



      case 'first_name':

        if (!value.trim()) {

          newErrors.first_name = 'Name is required';

        } else {

          delete newErrors.first_name;

        }

        break;



      case 'country':

        if (userType !== "jobSeeker" && !value) {

          newErrors.country = 'Country is required';

        } else {

          delete newErrors.country;

        }

        break;



      case 'nationality':

        if (!value) {

          newErrors.nationality = 'Nationality is required';

        } else {

          delete newErrors.nationality;

        }

        break;



      default:

        break;

    }



    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };



  const validateForm = () => {

    console.log('validateForm called for userType:', userType, 'registrationStep:', registrationStep); // Debug log

    const newErrors = {};



    // Common validations for all user types

    if (!formData.email) newErrors.email = 'Email is required';

    if (!formData.password) newErrors.password = 'Password is required';

    if (!formData.confirmPassword) newErrors.confirmPassword = 'Please confirm password';



    // Password length validation

    if (formData.password && formData.password.length < 8) {

      newErrors.password = 'Password must be at least 8 characters';

    }



    if (formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword) {

      newErrors.confirmPassword = 'Passwords do not match';

    }



    // Cook category validation

    if (userType === "jobSeeker" && cookPositions.includes(formData.job_position) && (!formData.cook_category || formData.cook_category.length === 0)) {

      newErrors.cook_category = 'Please select at least one cook category';

    }



    // Email format validation

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {

      newErrors.email = 'Please enter a valid email address';

    }



    // Job seeker validations

    if (userType === "jobSeeker") {

      if (!formData.first_name.trim()) {

        newErrors.first_name = 'Name is required';

      }

      // Country to apply for job validation

      if (!formData.country_apply_for_job) {

        newErrors.country_apply_for_job = 'Country to apply for job is required';

      }



      if (!formData.category) {

        newErrors.category = 'Job Category is required';

      }



      // Add validation for job_position

      if (!formData.job_position) {

        newErrors.job_position = 'Job position is required';

      }



      // License status validation for nurses

      if (hasHealthcareLicenseFlow(formData.job_position) && !formData.nurse_license_status) {

        newErrors.nurse_license_status = 'License / Exam status is required';

      }

      if (
        ["hospital", "healthcare"].includes(String(formData.category || "").toLowerCase()) &&
        hasHealthcareLicenseFlow(formData.job_position) &&
        formData.nurse_license_status &&
        formData.nurse_license_status !== "Not Yet Started" &&
        (!formData.nursing_license_countries || formData.nursing_license_countries.length === 0)
      ) {
        newErrors.nursing_license_countries = 'Please select at least one nursing license country';
      }



      // Driving license validation

      if (!formData.driving_license_country || formData.driving_license_country.length === 0) {

        newErrors.driving_license_country = 'Please select at least one driving license';

      }

      // Country experience validation

      if (!formData.driving_country_experience || formData.driving_country_experience.length === 0) {

        newErrors.driving_country_experience = 'Please select at least one country experience';

      }

      // Total work experience validation

      if (!formData.total_work_experience) {

        newErrors.total_work_experience = 'Please select total work experience';

      }



      if (!formData.nationality) {

        newErrors.nationality = 'Nationality is required';

      }

      if (!formData.current_country) {

        newErrors.current_country = 'Current country is required';

      }

      if (!formData.mobile_number) {

        newErrors.mobile_number = 'Mobile number is required';

      }

      if (!formData.mobile_number_country_code) {

        newErrors.mobile_number_country_code = 'Country code is required';

      }

      if (!formData.whatsapp_number) {

        newErrors.whatsapp_number = 'WhatsApp number is required';

      }

      if (!formData.whatsapp_country_code) {

        newErrors.whatsapp_country_code = 'WhatsApp country code is required';

      }

    }



    // Employer validations

    if (userType === "employer") {

      if (!formData.first_name.trim()) newErrors.first_name = 'Name is required';

      if (!formData.country) newErrors.country = 'Country is required';

      if (!formData.gender) newErrors.gender = 'Gender preference is required';

      if (!formData.age) newErrors.age = 'Age preference is required';

    }



    // Agency validations in step 1

    if (userType === "agency" && registrationStep === 1) {

      if (!formData.agency_name || !formData.agency_name.trim()) newErrors.agency_name = 'Agency Name is required';

      if (!formData.contact_person_name || !formData.contact_person_name.trim()) newErrors.contact_person_name = 'Owner Name is required';

      if (!formData.country) newErrors.country = 'Country is required';

      if (!formData.official_phone || !formData.official_phone.trim()) newErrors.official_phone = 'Mobile Number is required';

      if (!formData.recruitment_categories || formData.recruitment_categories.length === 0) newErrors.recruitment_categories = 'Select at least one recruitment category';

      if (!formData.legalConfirmation) newErrors.legalConfirmation = 'You must confirm that your agency operates legally';

    }



    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };



  const handleChange = useCallback((e) => {

    const { name, value } = e.target;



    let processedValue = value;



    // Apply validation for phone number fields

    if (name.includes('mobile_number') ||

      name.includes('whatsapp_number') ||

      name.includes('official_phone') ||

      name.includes('owner_mobile') ||

      name.includes('manager_mobile')) {

      processedValue = validatePhoneNumber(value);

    } else if (name === "first_name" || name === "last_name") {

      processedValue = capitalizeFirstLetter(value);

    }



    setFormData((prev) => {

      const newData = {

        ...prev,

        [name]: processedValue,

      };

      if (name === "contact_person_name") {
        newData.owner_name = processedValue;
      }



      // Validate field with the new data

      setTimeout(() => {

        validateField(name, processedValue, newData);



        // If password changes, validate confirmPassword with the new password value

        if (name === 'password' && newData.confirmPassword) {

          validateField('confirmPassword', newData.confirmPassword, newData);

        }

        // If confirmPassword changes, validate it against the current password

        if (name === 'confirmPassword' && newData.password) {

          validateField('password', newData.password, newData);

        }

      }, 0);



      return newData;

    });



    if (name === "email") {

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(value.trim())) {

        setEmailError("Please enter a valid email address");

      } else {

        setEmailError("");

      }

    }

  }, [userType, registrationStep, formData.password, formData.confirmPassword]);



  // Handle salary conversion when amount or currency changes

  const handleSalaryChange = (field, value) => {

    setFormData(prev => {

      const currentMeta = parseStoredCurrencyValue(prev.expected_monthly_salary_currency);

      let nextCurrency = currentMeta.baseCurrency;

      let nextSalaryType = prev.salary_type || currentMeta.salaryType || "";

      let nextSalaryValue = prev.salary_value || currentMeta.salaryDisplay || "";

      if (field === 'expected_monthly_salary_currency') {

        nextCurrency = value;

      } else if (field === 'salary_type') {

        nextSalaryType = value;

        nextSalaryValue = "";

      } else if (field === 'salary_value') {

        nextSalaryValue = value;

      } else {

        return prev;

      }

      const currencyCode = getCurrencyCode(nextCurrency);

      const rates = conversionRates[currencyCode];

      const hasSalaryValue = String(nextSalaryValue || "").trim() !== "";
      const amount = getSalaryAmountForConversion(nextSalaryType, nextSalaryValue);

      const expectedMonthlySalary = nextSalaryType === "Negotiable"
        ? "0"
        : hasSalaryValue && amount > 0
          ? amount.toString()
          : "";

      const expectedMonthlySalaryUsd = nextSalaryType === "Negotiable"
        ? "0"
        : (hasSalaryValue && amount > 0 && rates)
          ? Math.round(amount * rates.toUSD).toString()
          : "";

      const expectedMonthlySalaryQar = nextSalaryType === "Negotiable"
        ? "0"
        : (hasSalaryValue && amount > 0 && rates)
          ? Math.round(amount * rates.toQAR).toString()
          : "";

      return {

        ...prev,

        salary_type: nextSalaryType,

        salary_value: nextSalaryValue,

        expected_monthly_salary_currency: buildStoredCurrencyValue(
          nextCurrency,
          nextSalaryType,
          nextSalaryType !== "Negotiable" ? nextSalaryValue : ""
        ),

        expected_monthly_salary: expectedMonthlySalary,

        expected_monthly_salary_usd: expectedMonthlySalaryUsd,

        expected_monthly_salary_qar: expectedMonthlySalaryQar

      };

    });

  };



  const handleSelect = (field, value) => {

    setFormData(prev => {

      const newData = {

        ...prev,

        [field]: value

      };



      // Clear company_size if employer_type is Family

      if (field === 'employer_type' && value === 'Family') {

        newData.company_size = "";

      }



      if (field === 'country_apply_for_job') {

        const autoCurrency = countryApplyCurrencyMap[value] || "";

        newData.expected_monthly_salary_currency = autoCurrency
          ? buildStoredCurrencyValue(autoCurrency, prev.salary_type, prev.salary_value)
          : "";

        if (autoCurrency && prev.salary_type && prev.salary_type !== "Negotiable" && prev.salary_value) {

          const currencyCode = getCurrencyCode(autoCurrency);

          const rates = conversionRates[currencyCode];

          const amount = getSalaryAmountForConversion(prev.salary_type, prev.salary_value);

          newData.expected_monthly_salary = amount ? amount.toString() : "";

          newData.expected_monthly_salary_usd = amount && rates
            ? Math.round(amount * rates.toUSD).toString()
            : "";

          newData.expected_monthly_salary_qar = amount && rates
            ? Math.round(amount * rates.toQAR).toString()
            : "";

        } else if (autoCurrency && prev.salary_type === "Negotiable") {

          newData.expected_monthly_salary = "0";

          newData.expected_monthly_salary_usd = "0";

          newData.expected_monthly_salary_qar = "0";

        } else if (!autoCurrency) {

          newData.expected_monthly_salary_currency = "";

          newData.expected_monthly_salary_usd = prev.salary_type === "Negotiable" ? "0" : "";

          newData.expected_monthly_salary_qar = prev.salary_type === "Negotiable" ? "0" : "";

        }

      }



      // Reset state and city when country changes

      if (field === 'country') {

        newData.state_or_province = '';

        newData.working_city = '';



        // For EMPLOYER: Auto-select country code when country is selected

        if (userType === "employer") {

          // Find the country code for the selected country

          const selectedCountry = countryCodes.find(c => c.name === value);

          if (selectedCountry) {

            const countryCode = selectedCountry.code;



            // Set BOTH mobile and WhatsApp country codes automatically

            newData.mobile_number_country_code = countryCode;

            newData.whatsapp_country_code = countryCode;



            console.log(`Auto-selected country code ${countryCode} for ${value}`);

          }

        }



        // When country is selected in agency form, automatically set the country code for all phone fields

        if (userType === "agency") {

          // Find the country code for the selected country

          const selectedCountry = countryCodes.find(c => c.name === value);

          if (selectedCountry) {

            const countryCode = selectedCountry.code;



            // Set country code for all phone fields

            newData.official_phone_country_code = countryCode;

            newData.whatsapp_number_1_country_code = countryCode;

            newData.whatsapp_number_2_country_code = countryCode;

            newData.whatsapp_number_3_country_code = countryCode;

            newData.whatsapp_number_4_country_code = countryCode;

            newData.owner_mobile_country_code = countryCode;

            newData.manager_mobile_country_code = countryCode;

          }

        }



        // Auto-fill Macau SAR when Macau is selected

        if (value === 'Macau') {

          newData.state_or_province = 'Macau SAR';

          console.log(`Auto-filled state_or_province to Macau SAR for Macau`);

        }

      }



      // Reset city when state changes

      if (field === 'state_or_province') {

        newData.working_city = '';

      }



      // Auto-select country code when nationality is selected FOR ALL USER TYPES

      if (field === 'nationality') {

        // Find the country code for the selected nationality

        const selectedCountry = countryCodes.find(c => c.name === value);

        if (selectedCountry) {

          const countryCode = selectedCountry.code;



          // Set country codes based on user type

          if (userType === "jobSeeker") {

            // For job seekers, set ONLY mobile number country code when nationality is selected

            newData.mobile_number_country_code = countryCode;

          } else if (userType === "employer") {

            // For employers, set both mobile and whatsapp country codes

            newData.mobile_number_country_code = countryCode;

            newData.whatsapp_country_code = countryCode;

          } else if (userType === "agency") {

            // For agency, set owner and manager nationality-related country codes

            // Note: Agency phone fields are already handled in country selection

          }

        }

      }



      // Auto-select WhatsApp country code when current_country is selected (FOR JOB SEEKERS ONLY)

      if (field === 'current_country' && userType === "jobSeeker") {

        // Find the country code for the selected current country

        const selectedCountry = countryCodes.find(c => c.name === value);

        if (selectedCountry) {

          const countryCode = selectedCountry.code;

          // Set ONLY WhatsApp country code when current location is selected

          newData.whatsapp_country_code = countryCode;

        }

      }



            if (field === 'nurse_license_status' && value === 'Not Yet Started') {
        newData.nursing_license_countries = [];
      }

return newData;

    });



    validateField(field, value);

  };



  const handleCountryCodeChange = useCallback((fieldName, countryCode) => {

    setFormData(prev => ({

      ...prev,

      [fieldName]: countryCode

    }));

  }, []);



  const handleFileChange = (e) => {

    const { name, files: fileList } = e.target;

    const file = fileList[0];



    // Validate file type and size

    if (file) {

      const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

      const maxSize = 5 * 1024 * 1024; // 5MB



      if (name.includes('photo') || name === 'company_logo') {

        if (!validImageTypes.includes(file.type)) {

          setErrors(prev => ({

            ...prev,

            [name]: 'Please upload a valid image file (JPEG, PNG, JPG, GIF)'

          }));

          return;

        }

      }



      if (file.size > maxSize) {

        setErrors(prev => ({

          ...prev,

          [name]: 'File size must be less than 5MB'

        }));

        return;

      }



      setErrors(prev => {

        const newErrors = { ...prev };

        delete newErrors[name];

        return newErrors;

      });

    }



    setFiles(prev => ({

      ...prev,

      [name]: file

    }));

  };



  const sendOtp = async () => {

    console.log('sendOtp function called'); // Debug log

    if (emailError || !formData.email) {

      Swal.fire({

        icon: 'warning',

        title: 'Invalid Email',

        text: 'Please enter a valid email address first',

        confirmButtonColor: '#f27474'

      });

      return;

    }



    try {

      setOtpLoading(true);

      console.log('Sending OTP to:', formData.email); // Debug log



      const response = await fetch(`${BaseUrl}/send-reg-otp`, {

        method: "POST",

        headers: {

          "Content-Type": "application/json",

        },

        body: JSON.stringify({ email: formData.email })

      });



      const data = await response.json();



      if (!response.ok) throw new Error(data.message || data.error || 'Failed to send OTP');



      Swal.fire({

        icon: 'success',

        title: 'OTP Sent!',

        text: 'Please check your email for the verification code',

        confirmButtonColor: '#28a745'

      });



      setOtpSent(true);

      setRegistrationStep(2);

    } catch (error) {

      console.error("Error sending OTP:", error);

      Swal.fire({

        icon: 'error',

        title: 'Failed to Send OTP',

        text: error.message || 'Please try again later.',

        confirmButtonColor: '#d33'

      });

    } finally {

      setOtpLoading(false);

    }

  };



  const verifyOtp = async () => {

    if (!otp || otp.length < 4) {

      setOtpError("Please enter a valid OTP");

      return;

    }



    try {

      setOtpLoading(true);



      const response = await fetch(`${BaseUrl}/verify-otp`, {

        method: "POST",

        headers: {

          "Content-Type": "application/json",

        },

        body: JSON.stringify({

          email: formData.email,

          otp: otp

        })

      });



      const data = await response.json();



      if (!response.ok) throw new Error(data.message || data.error || 'OTP verification failed');



      Swal.fire({

        icon: 'success',

        title: 'OTP Verified!',

        text: 'Your email has been successfully verified',

        confirmButtonColor: '#28a745'

      });



      setOtpVerified(true);

      setOtpError("");



      if (userType === "agency") {

        setRegistrationStep(3);

      } else {

        await handleRegistration();

      }

    } catch (error) {

      console.error("Error verifying OTP:", error);

      setOtpError(error.message || "Invalid OTP. Please try again.");

    } finally {

      setOtpLoading(false);

    }

  };



  const getFilteredJobPositions = () => {
    const domesticSet = new Set(DOMESTIC_HELPER_POSITIONS);



    if (formData.category === "Hospital") {
      return getUniqueOptions(HEALTHCARE_POSITIONS);

    }



    if (formData.category === "Domestic Helper") {

      return getUniqueOptions(jobPositionOptions.filter((position) => domesticSet.has(position)));

    }



    if (formData.category === HOSPITALITY_CATEGORY) {

      return getUniqueOptions(HOSPITALITY_POSITIONS);

    }

    if (formData.category === SOFTWARE_IT_CATEGORY) {

      return getUniqueOptions(SOFTWARE_IT_POSITIONS);

    }

    if (formData.category === CONSTRUCTION_CATEGORY) {

      return getUniqueOptions(CONSTRUCTION_POSITIONS);

    }

    if (formData.category === RETAIL_SALES_CATEGORY) {

      return getUniqueOptions(RETAIL_SALES_POSITIONS);

    }

    if (formData.category === CLEANING_MAINTENANCE_CATEGORY) {

      return getUniqueOptions(CLEANING_MAINTENANCE_POSITIONS);

    }

    if (formData.category === SECURITY_CATEGORY) {

      return getUniqueOptions(SECURITY_POSITIONS);

    }

    if (formData.category === OFFICE_STAFF_CATEGORY) {

      return getUniqueOptions(OFFICE_STAFF_POSITIONS);

    }

    if (formData.category === DRIVER_CATEGORY || formData.category === "Driver") {

      return getUniqueOptions(DRIVER_POSITIONS);

    }



        if (formData.category === "Company Worker") {
      const companyPositions = filterCompanyWorkerPositions({
        positions: jobPositionOptions,
        domesticPositions: DOMESTIC_HELPER_POSITIONS,
        dualCategoryPositions: COMPANY_WORKER_DUAL_CATEGORY_POSITIONS,
        healthcarePositions: HEALTHCARE_POSITIONS
      });
      // Ensure CNC positions are included in Company Worker and follow the sequence
      const nonCncCompanyPositions = companyPositions.filter(pos => !cncPositions.includes(pos));
      return getUniqueOptions([...cncPositions, ...nonCncCompanyPositions]);
    }



    return getUniqueOptions(jobPositionOptions);

  };



  // Job Position Dropdown Component

  const JobPositionDropdown = ({

    title,

    field,

    selectedValue,

    onSelect,

    required = false,

    error = null,

    className = "",

    disabled = false,

    disabledMessage = null

  }) => {

    const [searchTerm, setSearchTerm] = useState("");

    const [isOpen, setIsOpen] = useState(false);



    const filteredOptions = getFilteredJobPositions().filter(option =>

      option.toLowerCase().includes(searchTerm.toLowerCase())

    );



    return (

      <div className="mb-3">

        <Dropdown show={isOpen} onToggle={(nextShow) => {

          if (nextShow && disabledMessage) {

            Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

              let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

              if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

              if (targetElement) {

                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                targetElement.classList.add('is-invalid');

                targetElement.classList.add('flash-highlight');

                if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

              }

            });

            return;

          }

          setIsOpen(nextShow);

        }}>

          <Dropdown.Toggle

            variant="light"

            disabled={disabled}

            className={`w-100 d-flex justify-content-between align-items-center ${className} ${error ? 'is-invalid' : ''}`}

            id={`dropdown-${field}`}

            style={{

              textAlign: 'left',

              border: '1px solid #ced4da',

              borderRadius: '0.375rem',

              backgroundColor: '#fff',

              padding: '0.375rem 0.75rem',

              color: selectedValue ? '#212529' : '#6c757d',

              minHeight: '50px'

            }}

          >

            <span className="text-truncate">

              {selectedValue || `${title}${required ? ' *' : ''}`}

            </span>

            {/* REMOVED: <FaChevronDown className="ms-2" size={14} /> */}

          </Dropdown.Toggle>



          <Dropdown.Menu className="w-100 p-2" style={{ overflow: 'hidden' }}>

            {/* Search Input */}

            <div className="px-2 mb-2 position-relative">

              <FaSearch

                className="position-absolute"

                style={{ top: '10px', left: '18px', color: '#6c757d' }}

                size={12}

              />

              <Form.Control

                type="text"

                placeholder="Search job position..."

                value={searchTerm}

                onChange={(e) => setSearchTerm(e.target.value)}

                onClick={(e) => e.stopPropagation()}

                className="ps-4"

                style={{ paddingLeft: '32px', fontSize: '0.9rem', minHeight: '38px' }}

                autoFocus

              />

            </div>



            {/* Options List */}

          <div className="dropdown-options" style={{ maxHeight: '180px', overflowY: 'auto' }}>

              {filteredOptions.length > 0 ? (

                filteredOptions.map((option) => (

                  <Dropdown.Item

                    key={option}

                    onClick={() => {

                      onSelect(field, option);

                      setSearchTerm("");

                      setIsOpen(false);

                    }}

                    className="py-2"

                    style={{ fontSize: '0.92rem', paddingTop: '0.38rem', paddingBottom: '0.38rem' }}

                    active={selectedValue === option}

                  >

                    {option}

                  </Dropdown.Item>

                ))

              ) : (

                <Dropdown.Item disabled className="text-center py-2">

                  No job positions found

                </Dropdown.Item>

              )}

            </div>

          </Dropdown.Menu>

        </Dropdown>

        {error && <div className="invalid-feedback d-block">{error}</div>}

      </div>

    );

  };



  // MultiSelectDropdown Component for selecting multiple countries

  const MultiSelectDropdown = ({

    title,

    field,

    options,

    selectedValues = [],

    onSelect,

    required = false,

    error = null,

    className = "",

    maxSelections = 3,

    disabled = false,

    disabledMessage = null

  }) => {

    const [searchTerm, setSearchTerm] = useState("");

    const [isOpen, setIsOpen] = useState(false);



    const filteredOptions = options.filter(option =>

      option.toLowerCase().includes(searchTerm.toLowerCase())

    );



    const toggleSelection = (value) => {

      let newSelections;

      const isDrivingField = field === 'driving_license_country';
      const isNursingField = field === 'nursing_license_countries';
      const noDrivingLabel = "Not Licensed";
      const noNursingLabel = "Not Licensed";

      if (isDrivingField) {
        if (value === noDrivingLabel) {
          newSelections = selectedValues.includes(value) ? [] : [noDrivingLabel];
          onSelect(field, newSelections);
          return;
        }
        if (selectedValues.includes(noDrivingLabel)) {
          newSelections = [value];
          onSelect(field, newSelections);
          return;
        }
      }

      if (isNursingField) {
        if (value === noNursingLabel) {
          newSelections = selectedValues.includes(value) ? [] : [noNursingLabel];
          onSelect(field, newSelections);
          return;
        }
        if (selectedValues.includes(noNursingLabel)) {
          newSelections = [value];
          onSelect(field, newSelections);
          return;
        }
      }

      if (selectedValues.includes(value)) {

        // Remove if already selected

        newSelections = selectedValues.filter(item => item !== value);

      } else {

        // Add if not already selected and within limit

        if (selectedValues.length < maxSelections) {

          newSelections = [...selectedValues, value];

        } else {

          // Show warning if trying to select more than max

          Swal.fire({

            icon: 'warning',

            title: 'Selection Limit',

            text: `You can select maximum ${maxSelections} options`,

            confirmButtonColor: '#f27474'

          });

          return;

        }

      }

      onSelect(field, newSelections);

    };



    return (

      <div className="mb-3">

        <Dropdown show={isOpen} onToggle={(nextShow) => {

          if (nextShow && disabledMessage) {

            Swal.fire({ icon: 'warning', title: disabledMessage.message, confirmButtonColor: '#f27474' }).then(() => {

              let targetElement = document.querySelector(`[name="${disabledMessage.targetId}"]`);

              if (!targetElement) targetElement = document.getElementById(`dropdown-${disabledMessage.targetId}`);

              if (targetElement) {

                targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                targetElement.classList.add('is-invalid');

                targetElement.classList.add('flash-highlight');

                if (targetElement.focus) setTimeout(() => targetElement.focus(), 500);

              }

            });

            return;

          }

          setIsOpen(nextShow);

        }}>

          <Dropdown.Toggle

            variant="light"

            disabled={disabled}

            className={`w-100 d-flex justify-content-between align-items-center ${className} ${error ? 'is-invalid' : ''}`}

            id={`dropdown-${field}`}

            style={{

              textAlign: 'left',

              border: '1px solid #ced4da',

              borderRadius: '0.375rem',

              backgroundColor: '#fff',

              padding: '0.375rem 0.75rem',

              color: selectedValues.length > 0 ? '#212529' : '#6c757d',

              minHeight: '50px'

            }}

          >

            <span className="text-truncate">

              {selectedValues.length > 0

                ? `${selectedValues.length} selected (${selectedValues.join(', ')})`

                : `${title}${required ? ' *' : ''} (max ${maxSelections})`

              }

            </span>

            {/* REMOVED: <FaChevronDown className="ms-2" size={14} /> */}

          </Dropdown.Toggle>



          <Dropdown.Menu className="w-100 p-2" style={{ overflow: 'hidden' }}>

            {/* Search Input */}

            <div className="px-2 mb-2 position-relative">

              <FaSearch

                className="position-absolute"

                style={{ top: '10px', left: '18px', color: '#6c757d' }}

                size={12}

              />

              <Form.Control

                type="text"

                placeholder={`Search ${title.toLowerCase()}...`}

                value={searchTerm}

                onChange={(e) => setSearchTerm(e.target.value)}

                onClick={(e) => e.stopPropagation()}

                className="ps-4"

                style={{ paddingLeft: '32px', fontSize: '0.9rem', minHeight: '38px' }}

                autoFocus

              />

            </div>



            {/* Selected items count */}

            <div className="px-2 mb-2 small text-muted" style={{ fontSize: '0.82rem' }}>

              Selected: {selectedValues.length}/{maxSelections}

            </div>



            {/* Options List */}

            <div className="dropdown-options" style={{ maxHeight: '170px', overflowY: 'auto' }}>

              {filteredOptions.length > 0 ? (

                filteredOptions.map((option) => (

                  <Dropdown.Item

                    key={option}

                    onClick={() => toggleSelection(option)}

                    className="py-2 d-flex align-items-center"

                    style={{ fontSize: '0.9rem', paddingTop: '0.38rem', paddingBottom: '0.38rem' }}

                    active={selectedValues.includes(option)}

                  >

                    <div className="form-check mb-0">

                      <input

                        type="checkbox"

                        className="form-check-input me-2"

                        checked={selectedValues.includes(option)}

                        onChange={() => { }}

                        style={{ cursor: 'pointer', transform: 'scale(0.92)' }}

                      />

                      <label className="form-check-label mb-0" style={{ cursor: 'pointer', fontSize: '0.9rem', lineHeight: '1.25' }}>

                        {option}

                      </label>

                    </div>

                  </Dropdown.Item>

                ))

              ) : (

                <Dropdown.Item disabled className="text-center py-2">

                  No options found

                </Dropdown.Item>

              )}

            </div>

          </Dropdown.Menu>

        </Dropdown>

        {error && <div className="invalid-feedback d-block">{error}</div>}

      </div>

    );

  };

  // const handleRegistration = async () => {

  //   // Validate form before submission



  //   if (formData.password !== formData.confirmPassword) {

  //     Swal.fire({

  //       icon: 'warning',

  //       title: 'Oops!',

  //       text: 'Passwords do not match',

  //       confirmButtonColor: '#f27474'

  //     });

  //     return;

  //   }



  //   if (userType === "agency" && !otpVerified) {

  //     Swal.fire({

  //       icon: 'warning',

  //       title: 'Email Not Verified',

  //       text: 'Please verify your email address before registration',

  //       confirmButtonColor: '#f27474'

  //     });

  //     return;

  //   }



  //   try {

  //     setLoading(true);



  //     let loginPayload = {

  //       email: formData.email,

  //       password: formData.password,

  //     };



  //     if (userType === "agency") {

  //       if (!otpVerified) {

  //         throw new Error("Email verification is required before agency registration");

  //       }



  //       const agencyPayload = {

  //         role: "agency_admin",

  //         password: formData.password,

  //         agency_name: formData.agency_name,

  //         city: formData.city,

  //         province: formData.province,

  //         country: formData.country,

  //         full_address: formData.full_address,

  //         whatsapp_number_1: formData.whatsapp_number_1,

  //         whatsapp_number_1_country_code: formData.whatsapp_number_1_country_code || '+971',

  //         whatsapp_number_2: formData.whatsapp_number_2 || "",

  //         whatsapp_number_2_country_code: formData.whatsapp_number_2_country_code || '+971',

  //         whatsapp_number_3: formData.whatsapp_number_3 || "",

  //         whatsapp_number_3_country_code: formData.whatsapp_number_3_country_code || '+971',

  //         whatsapp_number_4: formData.whatsapp_number_4 || "",

  //         whatsapp_number_4_country_code: formData.whatsapp_number_4_country_code || '+971',

  //         official_phone: formData.official_phone,

  //         official_phone_country_code: formData.official_phone_country_code || '+971',

  //         email: formData.email,

  //         website_url: formData.website_url || "",

  //         owner_name: formData.owner_name,

  //         owner_nationality: formData.owner_nationality,

  //         owner_mobile: formData.owner_mobile,

  //         owner_mobile_country_code: formData.owner_mobile_country_code || '+971',

  //         owner_email: formData.owner_email,

  //         manager_name: formData.manager_name,

  //         manager_nationality: formData.manager_nationality,

  //         manager_mobile: formData.manager_mobile,

  //         manager_mobile_country_code: formData.manager_mobile_country_code || '+971',

  //         manager_email: formData.manager_email,

  //       };



  //       const formDataToSend = new FormData();



  //       Object.keys(agencyPayload).forEach(key => {

  //         formDataToSend.append(key, agencyPayload[key]);

  //       });



  //       Object.keys(files).forEach(fileKey => {

  //         if (files[fileKey]) {

  //           formDataToSend.append(fileKey, files[fileKey]);

  //         }

  //       });



  //       console.log("Sending agency registration request...");



  //       const response = await fetch(`${BaseUrl}/api/agency`, {

  //         method: "POST",

  //         body: formDataToSend

  //       });



  //       const data = await response.json();



  //       if (!response.ok) {

  //         throw new Error(data.error || data.details || 'Agency registration failed');

  //       }



  //       console.log("Agency registration successful:", data);



  //       const loginRes = await fetch(`${BaseUrl}/login`, {

  //         method: "POST",

  //         headers: { "Content-Type": "application/json" },

  //         body: JSON.stringify(loginPayload),

  //       });



  //       const loginData = await loginRes.json();

  //       if (!loginRes.ok) throw new Error(loginData.message || "Login failed");



  //       localStorage.setItem("user", JSON.stringify(loginData.user));



  //       Swal.fire({

  //         icon: 'success',

  //         title: 'Registration Successful!',

  //         html: `

  //         <div class="text-center">

  //           <p>You have been logged in automatically.</p>

  //           <div class="alert alert-warning mt-2 p-2 small">

  //             <strong>Note:</strong> Admin approval is required before you can post jobs or candidates. Which may take up to 24hrs.

  //           </div>

  //         </div>

  //       `,

  //         confirmButtonColor: '#28a745'

  //       }).then(() => {

  //         // Check if we need to redirect back to job details

  //         if (state?.redirectBack && state?.jobId) {

  //           // Navigate back to the job details page

  //           navigate(`/alljobdetails/${state.jobId}`);

  //         } else {

  //           navigate("/agencydashboard");

  //         }

  //       });



  //     } else {

  //       const roleMap = {

  //         jobSeeker: "job seeker",

  //         employer: "employer",

  //       };



  //       const nameParts = formData.first_name.trim().split(' ');

  //       const firstName = nameParts[0] || "";

  //       const lastName = nameParts.slice(1).join(' ') || "";



  //       const payload = {

  //         first_name: firstName,

  //         last_name: lastName,

  //         mobile_number: formData.mobile_number || "",

  //         mobile_number_country_code: formData.mobile_number_country_code || "",

  //         email: formData.email,

  //         password: formData.password,

  //         // Add nationality only for job seekers

  //         ...(userType === "jobSeeker" && {

  //           nationality: formData.nationality, job_position: formData.job_position,

  //           current_country: formData.current_country

  //         }),

  //         // Add country for employers and agencies (with UAE fields if employer)

  //         ...((userType === "employer" || userType === "agency") && {

  //           country: formData.country || "",

  //           // Add UAE specific fields if UAE is selected (for employer)

  //           ...(userType === "employer" && formData.country === "UAE" && {

  //             uae_emirate: formData.uae_emirate,

  //             uae_city: formData.uae_city

  //           })

  //         }),

  //         role: roleMap[userType],

  //         source: "Direct",

  //         is_email_verified: otpVerified

  //       };



  //       const response = await fetch(`${BaseUrl}/`, {

  //         method: "POST",

  //         headers: {

  //           "Content-Type": "application/json",

  //         },

  //         body: JSON.stringify(payload)

  //       });



  //       const data = await response.json();

  //       if (!response.ok) throw new Error(data.error || 'Registration failed');



  //       const loginRes = await fetch(`${BaseUrl}/login`, {

  //         method: "POST",

  //         headers: { "Content-Type": "application/json" },

  //         body: JSON.stringify(loginPayload),

  //       });



  //       const loginData = await loginRes.json();

  //       if (!loginRes.ok) throw new Error(loginData.message || "Login failed");



  //       localStorage.setItem("user", JSON.stringify(loginData.user));



  //       Swal.fire({

  //         icon: 'success',

  //         title: 'Registration Successful!',

  //         text: 'You have been logged in automatically.',

  //         confirmButtonColor: '#28a745'

  //       }).then(() => {

  //         // Check if we need to redirect back to job details

  //         if (state?.redirectBack && state?.jobId) {

  //           // Navigate back to the job details page

  //           navigate(`/alljobdetails/${state.jobId}`);

  //         } else if (loginData.user.role === "employer") {

  //           navigate("/employer-dashboard");

  //         } else if (loginData.user.role === "agency_admin") {

  //           navigate("/agency-dashboard");

  //         } else {

  //           navigate("/viewjobs");

  //         }

  //       });

  //     }



  //     // Reset form

  //     setFormData({

  //       first_name: "",

  //       last_name: "",

  //       mobile_number: "",

  //       mobile_number_country_code: "",

  //       email: "",

  //       password: "",

  //       confirmPassword: "",

  //       nationality: "",

  //       country: "",

  //       agency_name: "",

  //       city: "",

  //       province: "",

  //       full_address: "",

  //       whatsapp_number_1: "",

  //       whatsapp_number_1_country_code: "",

  //       whatsapp_number_2: "",

  //       whatsapp_number_2_country_code: "",

  //       whatsapp_number_3: "",

  //       whatsapp_number_3_country_code: "",

  //       whatsapp_number_4: "",

  //       whatsapp_number_4_country_code: "",

  //       official_phone: "",

  //       official_phone_country_code: "",

  //       website_url: "",

  //       owner_name: "",

  //       owner_nationality: "",

  //       owner_mobile: "",

  //       owner_mobile_country_code: "",

  //       owner_email: "",

  //       manager_name: "",

  //       manager_nationality: "",

  //       manager_mobile: "",

  //       manager_mobile_country_code: "",

  //       manager_email: ""

  //     });



  //     setFiles({

  //       company_logo: null,

  //       business_card: null,

  //       license_copy: null,

  //       owner_photo: null,

  //       office_building_photo: null

  //     });



  //     setOtp("");

  //     setOtpSent(false);

  //     setOtpVerified(false);

  //     setRegistrationStep(1);

  //     setErrors({});



  //   } catch (error) {

  //     console.error("Error registering user:", error);



  //     let errorMessage = error.message || 'Please try again later.';



  //     if (errorMessage.includes('Email not verified with OTP')) {

  //       errorMessage = 'Email verification failed. Please complete the OTP verification process again.';

  //     } else if (errorMessage.includes('This email already registered')) {

  //       errorMessage = 'This email is already registered. Please use a different email or login.';

  //     } else if (errorMessage.includes('Required fields are missing')) {

  //       errorMessage = 'Please fill all required fields.';

  //     }



  //     Swal.fire({

  //       icon: 'error',

  //       title: 'Registration Failed',

  //       text: errorMessage,

  //       confirmButtonColor: '#d33'

  //     });

  //   } finally {

  //     setLoading(false);

  //   }

  // };





  const handleRegistration = async () => {

    // Validate form before submission

    if (formData.password !== formData.confirmPassword) {

      Swal.fire({

        icon: 'warning',

        title: 'Oops!',

        text: 'Passwords do not match',

        confirmButtonColor: '#f27474'

      });

      return;

    }



    // For Agency, validate required fields before final submission

    if (userType === "agency") {

      if (!formData.agency_name || !formData.country || !formData.full_address) {

        Swal.fire({

          icon: 'warning',

          title: 'Agency Information Missing',

          text: 'Please fill all required Agency/Business Information fields',

          confirmButtonColor: '#f27474'

        });

        return;

      }



      if (!formData.official_phone || !formData.whatsapp_number_1) {

        Swal.fire({

          icon: 'warning',

          title: 'Contact Information Missing',

          text: 'Please fill all required Contact Information fields',

          confirmButtonColor: '#f27474'

        });

        return;

      }



      if (!formData.owner_name) {

        Swal.fire({

          icon: 'warning',

          title: 'Owner Information Missing',

          text: 'Please fill Owner Name',

          confirmButtonColor: '#f27474'

        }).then(() => {

          const element = document.querySelector(`[name="owner_name"]`);

          if (element) {

            element.scrollIntoView({ behavior: 'smooth', block: 'center' });

            element.focus();

          }

        });

        return;

      }



      // Validate About Agency (minimum 50 words)

      const aboutWordCount = (formData.about_agency || '').trim().split(/\s+/).filter(w => w.length > 0).length;

      if (aboutWordCount < 50) {

        Swal.fire({

          icon: 'warning',

          title: 'About Agency Too Short',

          text: `Please write at least 50 words about your agency. Currently: ${aboutWordCount} words.`,

          confirmButtonColor: '#f27474'

        }).then(() => {

          const element = document.querySelector('[name="about_agency"]');

          if (element) {

            element.scrollIntoView({ behavior: 'smooth', block: 'center' });

            element.focus();

          }

        });

        return;

      }

    }



    try {

      setLoading(true);



      let loginPayload = {

        email: formData.email,

        password: formData.password,

      };



      if (userType === "agency") {

        if (!otpVerified) {

          throw new Error("Email verification is required before agency registration");

        }



        const agencyPayload = {

          role: "agency_admin",

          password: formData.password,

          agency_name: formData.agency_name,

          contact_person_name: formData.contact_person_name || '',

          owner_name: formData.owner_name || formData.contact_person_name || '',

          city: formData.city,

          province: formData.province,

          country: formData.country,

          full_address: formData.full_address,

          whatsapp_number_1: formData.whatsapp_number_1,

          whatsapp_number_1_country_code: formData.whatsapp_number_1_country_code || '+971',

          whatsapp_number_2: formData.whatsapp_number_2 || "",

          whatsapp_number_2_country_code: formData.whatsapp_number_2_country_code || '+971',

          whatsapp_number_3: formData.whatsapp_number_3 || "",

          whatsapp_number_3_country_code: formData.whatsapp_number_3_country_code || '+971',

          whatsapp_number_4: formData.whatsapp_number_4 || "",

          whatsapp_number_4_country_code: formData.whatsapp_number_4_country_code || '+971',

          official_phone: formData.official_phone,

          official_phone_country_code: formData.official_phone_country_code || '+971',

          email: formData.email,

          website_url: formData.website_url || "",

          owner_name: formData.owner_name,

          owner_nationality: formData.owner_nationality,

          owner_mobile: formData.owner_mobile,

          owner_mobile_country_code: formData.owner_mobile_country_code || '+971',

          owner_email: formData.owner_email,

          manager_name: formData.manager_name,

          manager_nationality: formData.manager_nationality,

          manager_mobile: formData.manager_mobile,

          manager_mobile_country_code: formData.manager_mobile_country_code || '+971',

          manager_email: formData.manager_email,

          recruitment_categories: JSON.stringify(formData.recruitment_categories || []),

          selected_plan: formData.selected_plan || 'Free',

          legal_confirmation: formData.legalConfirmation ? 1 : 0,

          about_agency: formData.about_agency || '',

        };



        const formDataToSend = new FormData();



        Object.keys(agencyPayload).forEach(key => {

          formDataToSend.append(key, agencyPayload[key]);

        });



        Object.keys(files).forEach(fileKey => {

          if (files[fileKey]) {

            formDataToSend.append(fileKey, files[fileKey]);

          }

        });



        console.log("Sending agency registration request...");



        const response = await fetch(`${BaseUrl}/api/agency`, {

          method: "POST",

          body: formDataToSend

        });



        const data = await response.json();



        if (!response.ok) {

          throw new Error(data.message || data.error || data.details || 'Agency registration failed');

        }



        console.log("Agency registration successful:", data);



        const loginRes = await fetch(`${BaseUrl}/login`, {

          method: "POST",

          headers: { "Content-Type": "application/json" },

          body: JSON.stringify(loginPayload),

        });



        const loginData = await loginRes.json();

        if (!loginRes.ok) throw new Error(loginData.message || "Login failed");



        localStorage.setItem("user", JSON.stringify(loginData.user));



        Swal.fire({

          icon: 'success',

          title: 'Registration Successful!',

          html: `

        <div class="text-center">

          <p>You have been logged in automatically.</p>

          <div class="alert alert-warning mt-2 p-2 small">

            <strong>Note:</strong> Admin approval is required before you can post jobs or candidates. Which may take up to 24hrs.

          </div>

        </div>

      `,

          confirmButtonColor: '#28a745'

        }).then(() => {

          if (state?.redirectBack && state?.jobId) {

            navigate(`/alljobdetails/${state.jobId}`);

          } else {

            navigate("/agencydashboard");

          }

        });



      } else {

        const roleMap = {

          jobSeeker: "job seeker",

          employer: "employer",

        };



        const nameParts = formData.first_name.trim().split(' ');

        const firstName = nameParts[0] || "";

        const lastName = nameParts.slice(1).join(' ') || "";



        const payload = {

          first_name: firstName,

          last_name: lastName,

          mobile_number: formData.mobile_number || "",

          mobile_number_country_code: formData.mobile_number_country_code || "",

          whatsapp_number: formData.whatsapp_number || "",

          whatsapp_country_code: formData.whatsapp_country_code || "",

          email: formData.email,

          password: formData.password,

          gender: formData.gender || "Not specified",

          age: formData.age || "",

          religion: formData.religion || "Not specified",

          employer_type: formData.employer_type || "",

          company_size: formData.company_size || "",

          // Add job position, nationality, current country, age, and gender for job seekers

          ...(userType === "jobSeeker" && {

            nationality: formData.nationality,

            job_position: formData.job_position,

            current_country: formData.current_country,

            driving_license_country: formData.driving_license_country || [],

            driving_country_experience: formData.driving_country_experience || [],

            total_work_experience: formData.total_work_experience || "",

            country_apply_for_job: formData.country_apply_for_job || "",

            age: formData.age ? parseInt(formData.age) : 0,

            gender: formData.gender || "Not specified",

            expected_monthly_salary_currency: formData.expected_monthly_salary_currency || "",

            expected_monthly_salary: formData.expected_monthly_salary || "",

            expected_monthly_salary_usd: formData.expected_monthly_salary_usd || "",

            expected_monthly_salary_qar: formData.expected_monthly_salary_qar || "",

            nurse_license_status: hasHealthcareLicenseFlow(formData.job_position) ? formData.nurse_license_status : null,

          }),

          // Add country for employers and agencies (with UAE fields if employer)

          ...((userType === "employer" || userType === "agency") && {

            country: formData.country || "",

            nationality: formData.nationality || "",

            expected_monthly_salary_currency: formData.expected_monthly_salary_currency || "",

            expected_monthly_salary: formData.expected_monthly_salary || "",

            expected_monthly_salary_usd: formData.expected_monthly_salary_usd || "",

            expected_monthly_salary_qar: formData.expected_monthly_salary_qar || "",

            ...(userType === "employer" && {

              employer_type: formData.employer_type || "",

              company_size: formData.company_size || "",

              domestic_worker_category: formData.domestic_worker_category || "",

              // Send state/city for ALL countries using uae_emirate/uae_city fields

              ...(formData.country === "UAE" ? {

                uae_emirate: formData.uae_emirate || "",

                uae_city: formData.uae_city || ""

              } : {

                uae_emirate: formData.state_or_province || "",

                uae_city: formData.working_city || ""

              })

            })

          }),

          role: roleMap[userType],

          source: "Direct",

          is_email_verified: otpVerified

        };



        console.log("Sending registration payload:", payload);



        const response = await fetch(`${BaseUrl}/`, {

          method: "POST",

          headers: {

            "Content-Type": "application/json",

          },

          body: JSON.stringify(payload)

        });



        const data = await response.json();

        if (!response.ok) throw new Error(data.message || data.error || 'Registration failed');



        console.log("User registration successful:", data);



        // If user is job seeker, create job seeker record

        if (userType === "jobSeeker") {

          try {

            // Prepare job seeker data

            const selectedJobPosition = formData.job_position || "Caregiver";
            const isDriver = typeof selectedJobPosition === 'string' && selectedJobPosition.toLowerCase().includes("driver");

            const jobSeekerData = {

              user_id: data.user?.id || data.id,

              email_id: formData.email,

              source: "Direct",

              first_name: firstName,

              last_name: lastName,
              whatsapp_number: formData.whatsapp_number || "",
              whatsapp_country_code: formData.whatsapp_country_code || "",

              gender: (formData.gender && formData.gender !== 'Not specified') ? formData.gender : "Not specified",

              age: formData.age ? parseInt(formData.age) : 0,

              nationality: formData.nationality || "Not specified",

              current_country: formData.current_country || "Not specified",

              country_apply_for_job: formData.country_apply_for_job || "",

              total_work_experience: formData.total_work_experience || "Not specified",

              // Derive category from the selected job position instead of hardcoding

              category: formData.domestic_worker_category || formData.category || (() => {
                const pos = (formData.job_position || '').toLowerCase();
                const isHospital = pos.includes('nurse') || pos.includes('midwife') || pos.includes('physiotherapy') || pos.includes('physiotherapist') || pos.includes('doctor') || pos.includes('physician') ||
                  pos.includes('surgeon') || pos.includes('medical') || pos.includes('dental') ||
                  pos.includes('pharmacist') || pos.includes('radiolog') || pos.includes('physiotherapist') ||
                  pos.includes('lab technician') || pos.includes('anesthes');
                const isDomestic = pos.includes('maid') || pos.includes('housekeeper') || pos.includes('nanny') ||
                  pos.includes('babysitter') || pos.includes('caregiver') || pos.includes('domestic') ||
                  pos.includes('cleaner') || pos.includes('helper') || pos.includes('houseboy') ||
                  pos.includes('housemaid') || pos.includes('butler');
                if (isHospital) return 'Hospital';
                if (isDomestic) return 'Domestic Helper';
                return 'Company Worker';
              })(),
              // Save the selected job position as a JSON array

              job_position: JSON.stringify([formData.job_position]),

              marital_status: "Unmarried",

              religion: formData.religion || "Not specified",

              expected_monthly_salary: formData.expected_monthly_salary || "0.00",

              expected_monthly_salary_usd: formData.expected_monthly_salary_usd || "0.00",

              expected_monthly_salary_qar: formData.expected_monthly_salary_qar || "0.00",

              nurse_license_status: hasHealthcareLicenseFlow(formData.job_position) ? formData.nurse_license_status : null,

              noc_or_transfer_letter: 0,

              reference_letter: 0,

              networking_opportunities: "0",

              day_off_preference: "Weekly Off",

              accommodation_preference: "Live in/Live out",

              height: "160-162",

              weight: "60-65",

              color: "Medium",

              resume_description: "Profile not completed yet",

              language: JSON.stringify([{ language: "English", speaking_level: "Fair", can_read: "1", can_write: "1" }]),

              main_skills: JSON.stringify((() => {
                const pos = (formData.job_position || '').toLowerCase();
                const skills = [];
                if (pos.includes('driver')) skills.push('Driving');
                if (pos.includes('cook') || pos.includes('chef')) skills.push('Cooking');
                if (pos.includes('cnc operator') || pos.includes('cnc machine')) skills.push('CNC Operator');

                if (pos.includes('cnc programmer')) skills.push('CNC Programmer');

                if (pos.includes('mechanic')) skills.push('Mechanic');

                if (pos.includes('welder')) skills.push('Welding');

                if (pos.includes('electrician')) skills.push('Electrician');

                if (pos.includes('fabricator')) skills.push('Fabricator');

                if (pos.includes('pipe fitter')) skills.push('Pipe Fitter');

                if (pos.includes('ac technician')) skills.push('AC Technician');

                if (pos.includes('hvac technician')) skills.push('HVAC Technician');

                if (pos.includes('chiller technician')) skills.push('Chiller Technician');
                if (pos.includes('lathe') || pos.includes('milling machine')) skills.push('Machine Operator');
                if (pos.includes('plumber')) skills.push('Plumber');
                if (formData.job_position && !skills.includes(formData.job_position)) skills.push(formData.job_position);
                return skills;
              })()),
              cooking_skills: JSON.stringify(["Indian"]),

              other_skills: JSON.stringify(["Car wash"]),

              personality: JSON.stringify(["Hard working", "Good listener", "Independent"]),

              experience: JSON.stringify([{

                job_position: [selectedJobPosition],

                country: ["Qatar", "Saudi Arabia", "Oman"],

                employer_type: 'Both',

                house_duties: []

              }]),

              education: JSON.stringify([{

                level: 'High School',

                course: '',

                status: 'Yes',

                completion_year: ''

              }]),

              car_type: JSON.stringify([]),

              previous_car: JSON.stringify([]),

              nursing_qualifications: JSON.stringify([]),

              professional_qualifications: JSON.stringify([]),

              specialized_qualifications: JSON.stringify([]),

              language_qualifications: JSON.stringify([]),

              cultural_adaptation_qualifications: JSON.stringify([]),

              nursing_job_countries: JSON.stringify([]),

              language_skills: JSON.stringify([]),

              nursing_license_countries: JSON.stringify(formData.nursing_license_countries || []),

              nursing_positions: JSON.stringify([]),

              driving_license_country: JSON.stringify(formData.driving_license_country || [])

            };



            console.log("Creating job seeker record:", jobSeekerData);



            const jobSeekerResponse = await fetch(`${BaseUrl}/api/job-seeker`, {

              method: "POST",

              headers: {

                "Content-Type": "application/json",

              },

              body: JSON.stringify(jobSeekerData)

            });



            const jobSeekerResult = await jobSeekerResponse.json();



            if (!jobSeekerResponse.ok) {

              console.warn("Job seeker record creation failed:", jobSeekerResult);

              // Don't fail the registration if job seeker record creation fails

              // User can complete their profile later

            } else {

              console.log("Job seeker record created successfully:", jobSeekerResult);

            }

          } catch (error) {

            console.error("Error creating job seeker record:", error);

            // Don't fail the registration if job seeker record creation fails

            // User can complete their profile later

          }

        } else if (userType === "employer") {

          let employerTempId = 1;

          try {

            // Fetch the latest temporary_id

            let latestTempId = 1;

            try {

              const tempIdRes = await fetch(`${BaseUrl}/api/employer/get/latest-temporary-id`);

              const tempIdData = await tempIdRes.json();

              if (tempIdRes.ok && tempIdData.latest_temporary_id) {

                latestTempId = parseInt(tempIdData.latest_temporary_id) + 1;

              }

            } catch (err) {

              console.warn("Could not fetch latest temporary_id, using 1", err);

            }



            const employerData = {

              user_id: data.user?.id || data.id,

              temporary_id: latestTempId,

              email_id: formData.email,

              name: `${firstName} ${lastName}`.trim(),

              emp_name: firstName,

              gender: formData.gender || "Not specified",

              age: formData.age || "",

              religion: formData.religion || "Not specified",

              country: formData.country || "",

              state_or_province: formData.country === "UAE" ? formData.uae_emirate : formData.state_or_province,

              working_city: formData.country === "UAE" ? formData.uae_city : formData.working_city,

              phone_number: formData.mobile_number || "",

              phone_number_country_code: formData.mobile_number_country_code || "",

              whatsapp_number: formData.whatsapp_number || "",

              whatsapp_number_country_code: formData.whatsapp_country_code || "",

              employer_type: formData.employer_type || "",

              nationality: formData.nationality || "",

              company_size: formData.company_size || "",

              domestic_worker_category: formData.domestic_worker_category || "",

              posted_by: "Direct",

              status: "Pending Verification"

            };



            console.log("Creating initial employer record:", employerData);



            const employerResponse = await fetch(`${BaseUrl}/api/employer`, {

              method: "POST",

              headers: {

                "Content-Type": "application/json",

              },

              body: JSON.stringify(employerData)

            });



            const employerResult = await employerResponse.json();



            if (!employerResponse.ok) {

              console.warn("Employer record creation failed:", employerResult);

            } else {

              console.log("Employer record created successfully:", employerResult);

              employerTempId = employerResult.temporary_id || latestTempId;

            }

          } catch (error) {

            console.error("Error creating employer record:", error);

          }



          // Store tempId for later use

          localStorage.setItem('employerTempId', employerTempId);

        }



        // Login the user after registration

        const loginRes = await fetch(`${BaseUrl}/login`, {

          method: "POST",

          headers: { "Content-Type": "application/json" },

          body: JSON.stringify(loginPayload),

        });



        const loginData = await loginRes.json();

        if (!loginRes.ok) throw new Error(loginData.message || "Login failed");



        localStorage.setItem("user", JSON.stringify(loginData.user));



        Swal.fire({

          icon: 'success',

          title: 'Registration Successful!',

          text: 'You have been logged in automatically.',

          confirmButtonColor: '#28a745'

        }).then(() => {

          // Check if we need to redirect back to job details

          if (state?.redirectBack && state?.jobId) {

            // Navigate back to the job details page

            navigate(`/alljobdetails/${state.jobId}`);

          } else if (loginData.user.role === "employer") {

            // Redirect employer to ViewJobDetails page showing their registration data

            const tempId = localStorage.getItem('employerTempId') || 1;

            localStorage.setItem('showEmployerWelcomePopup', 'true');

            navigate(`/viewjobdetails/${tempId}`);

          } else if (loginData.user.role === "agency_admin") {

            navigate("/agency-dashboard");

          } else {

            navigate(`/allcandidatesdetails/${loginData.user.id}`);

          }

        });

      }



      // Reset form

      setFormData({

        first_name: "",

        last_name: "",

        gender: "",

        age: "",

        job_position: "",

        mobile_number: "",

        mobile_number_country_code: "",

        whatsapp_number: "",

        whatsapp_country_code: "",

        driving_license_country: [],

        driving_country_experience: [],

        total_work_experience: "",

        country_apply_for_job: "",

        email: "",

        job_position: "",

        nurse_license_status: "",
        nursing_license_countries: [],

        password: "",

        confirmPassword: "",

        nationality: "",

        current_country: "",

        country: "",

        state_or_province: "",

        working_city: "",

        expected_monthly_salary_currency: "",

        expected_monthly_salary: "",

        expected_monthly_salary_usd: "",

        expected_monthly_salary_qar: "",

        salary_type: "",

        salary_value: "",

        agency_name: "",

        contact_person_name: "",

        city: "",

        province: "",

        full_address: "",

        whatsapp_number_1: "",

        whatsapp_number_1_country_code: "",

        whatsapp_number_2: "",

        whatsapp_number_2_country_code: "",

        whatsapp_number_3: "",

        whatsapp_number_3_country_code: "",

        whatsapp_number_4: "",

        whatsapp_number_4_country_code: "",

        official_phone: "",

        official_phone_country_code: "",

        website_url: "",

        owner_name: "",

        owner_nationality: "",

        owner_mobile: "",

        owner_mobile_country_code: "",

        owner_email: "",

        manager_name: "",

        manager_nationality: "",

        manager_mobile: "",

        manager_mobile_country_code: "",

        manager_email: "",

        domestic_worker_category: "",

        employer_type: "",

        company_size: "",

        recruitment_categories: [],

        selected_plan: "Free",

        legalConfirmation: false,

        termsAccepted: false

      });



      setFiles({

        company_logo: null,

        business_card: null,

        license_copy: null,

        owner_photo: null,

        office_building_photo: null

      });



      setOtp("");

      setOtpSent(false);

      setOtpVerified(false);

      setRegistrationStep(1);

      setErrors({});



    } catch (error) {

      console.error("Error registering user:", error);



      let errorMessage = error.message || 'Please try again later.';



      if (errorMessage.includes('Email not verified with OTP')) {

        errorMessage = 'Email verification failed. Please complete the OTP verification process again.';

      } else if (errorMessage.includes('This email already registered')) {

        errorMessage = 'This email is already registered. Please use a different email or login.';

      } else if (errorMessage.includes('Required fields are missing')) {

        errorMessage = 'Please fill all required fields.';

      }



      Swal.fire({

        icon: 'error',

        title: 'Registration Failed',

        text: errorMessage,

        confirmButtonColor: '#d33'

      });

    } finally {

      setLoading(false);

    }

  };





  const handleSubmit = async (e) => {

    e.preventDefault();

    console.log('handleSubmit called, registrationStep:', registrationStep); // Debug log



    // Before sending OTP, check for password mismatch

    if (registrationStep === 1) {

      // Validate all fields first

      const isValid = validateForm();

      console.log('Form validation result:', isValid, 'Errors:', errors); // Debug log

      if (!isValid) {

        console.log('Form validation failed, stopping'); // Debug log

        // Show the first error to the user

        const firstErrorKey = Object.keys(errors)[0];

        const firstErrorMessage = errors[firstErrorKey];

        if (firstErrorMessage) {

          Swal.fire({

            icon: 'warning',

            title: 'Validation Error',

            text: firstErrorMessage,

            confirmButtonColor: '#f27474'

          });

        }

        return; // Don't proceed if form is invalid

      }



      // Check password mismatch for all user types

      if (formData.password !== formData.confirmPassword) {

        Swal.fire({

          icon: 'warning',

          title: 'Passwords Do Not Match',

          text: 'Password and Confirm Password must be the same',

          confirmButtonColor: '#f27474'

        });

        return;

      }



      // For job seekers, check if job position is selected

      if (userType === "jobSeeker" && !formData.job_position) {

        Swal.fire({

          icon: 'warning',

          title: 'Job Position Required',

          text: 'Please select a job position',

          confirmButtonColor: '#f27474'

        });

        return;

      }



      // For job seekers, check country to apply for job

      if (userType === "jobSeeker" && !formData.country_apply_for_job) {

        Swal.fire({

          icon: 'warning',

          title: 'Country to Apply Required',

          text: 'Please select the country you want to apply for job',

          confirmButtonColor: '#f27474'

        });

        return;

      }



      // For job seekers, check driving license and experience

      if (userType === "jobSeeker") {

        if (!formData.driving_license_country || formData.driving_license_country.length === 0) {

          Swal.fire({

            icon: 'warning',

            title: 'Driving License Required',

            text: 'Please select at least one driving license',

            confirmButtonColor: '#f27474'

          });

          return;

        }



        if (!formData.driving_country_experience || formData.driving_country_experience.length === 0) {

          Swal.fire({

            icon: 'warning',

            title: 'Country Experience Required',

            text: 'Please select at least one country experience',

            confirmButtonColor: '#f27474'

          });

          return;

        }



        if (!formData.total_work_experience) {

          Swal.fire({

            icon: 'warning',

            title: 'Total Work Experience Required',

            text: 'Please select your total work experience',

            confirmButtonColor: '#f27474'

          });

          return;

        }

      }



      // For agency, check required fields in step 1

      if (userType === "agency") {

        if (!formData.agency_name || !formData.agency_name.trim()) {

          Swal.fire({

            icon: 'warning',

            title: 'Agency Name Required',

            text: 'Please enter your agency name',

            confirmButtonColor: '#f27474'

          });

          return;

        }

        if (!formData.country) {

          Swal.fire({

            icon: 'warning',

            title: 'Country Required',

            text: 'Please select your country of operation',

            confirmButtonColor: '#f27474'

          });

          return;

        }

        if (!formData.official_phone || !formData.official_phone.trim()) {

          Swal.fire({

            icon: 'warning',

            title: 'Mobile Number Required',

            text: 'Please enter your mobile number',

            confirmButtonColor: '#f27474'

          });

          return;

        }

        if (!formData.email || emailError) {

          Swal.fire({

            icon: 'warning',

            title: 'Invalid Email',

            text: 'Please enter a valid email address',

            confirmButtonColor: '#f27474'

          });

          return;

        }

        if (!formData.legalConfirmation) {

          Swal.fire({

            icon: 'warning',

            title: 'Legal Confirmation Required',

            text: 'Please confirm that your agency operates legally',

            confirmButtonColor: '#f27474'

          });

          return;

        }

      } else {

        // For other users, check required fields

        if (!formData.first_name || !formData.email || !formData.password || !formData.confirmPassword) {

          Swal.fire({

            icon: 'warning',

            title: 'Incomplete Form',

            text: 'Please fill all required fields',

            confirmButtonColor: '#f27474'

          });

          return;

        }

      }



      // Check if Terms and Conditions are accepted

      if (!formData.termsAccepted) {

        Swal.fire({

          icon: 'warning',

          title: 'Terms & Conditions',

          text: 'Please accept the Terms and Conditions to proceed',

          confirmButtonColor: '#f27474'

        });

        return;

      }



      // If all validations pass, send OTP

      await sendOtp();

    } else if (registrationStep === 2) {

      await verifyOtp();

    } else if (registrationStep === 3) {

      await handleRegistration();

    }

  };



  const recruitmentCategoryOptions = [

    "Domestic Workers",

    "Healthcare",

    "Construction",

    "Hospitality",

    "Manufacturing",

    "Drivers",

    "Other"

  ];



  const planOptions = ["Free", "Pay Per Click", "Silver", "Gold"];



  const handleRecruitmentCategoryToggle = (category) => {

    setFormData(prev => {

      const current = prev.recruitment_categories || [];

      if (current.includes(category)) {

        return { ...prev, recruitment_categories: current.filter(c => c !== category) };

      } else {

        return { ...prev, recruitment_categories: [...current, category] };

      }

    });

  };



  const handleWhatsappSameAsMobile = (checked) => {

    setWhatsappSameAsMobile(checked);

    if (checked) {

      setFormData(prev => ({

        ...prev,

        whatsapp_number_1: prev.official_phone,

        whatsapp_number_1_country_code: prev.official_phone_country_code

      }));

    }

  };



  // Get states for the selected country from countryStateCityData

  const getStatesForCountry = (countryName) => {

    if (countryStateCityData[countryName]) {

      return Object.keys(countryStateCityData[countryName]);

    }

    return [];

  };



  // Get cities for the selected state in the selected country

  const getCitiesForState = (countryName, stateName) => {

    if (countryStateCityData[countryName] && countryStateCityData[countryName][stateName]) {

      return countryStateCityData[countryName][stateName];

    }

    return [];

  };



  const renderAgencyForm = () => {

    if (registrationStep === 1) {

      const availableStates = formData.country ? getStatesForCountry(formData.country) : [];

      const availableCities = (formData.country && formData.province) ? getCitiesForState(formData.country, formData.province) : [];



      return (

        <>

          {/* Section 1: Basic Information */}

          <div className="mb-3">

            <div className="mb-2">

              <input

                type="text"

                name="agency_name"

                className={`form-control rounded-input ${errors.agency_name ? 'is-invalid' : ''}`}

                placeholder="Agency Name *"

                value={formData.agency_name}

                onChange={handleChange}

                required

              />

              {errors.agency_name && <div className="invalid-feedback d-block">{errors.agency_name}</div>}

            </div>



            <div className="mb-2">

              <input

                type="text"

                name="contact_person_name"

                className={`form-control rounded-input ${errors.contact_person_name ? 'is-invalid' : ''}`}

                placeholder="Owner Name *"

                value={formData.contact_person_name}

                onChange={handleChange}

                required

              />

              {errors.contact_person_name && <div className="invalid-feedback d-block">{errors.contact_person_name}</div>}

            </div>

          </div>



          {/* Section 2: Location */}

          <div className="mb-3">

            <div className="mb-2">

              <CustomDropdown

                title="Country of Operation"

                field="country"

                options={getCountryOptions(userType, "country")}

                selectedValue={formData.country}

                onSelect={handleSelect}

                error={errors.country}

                required={true}

                userType={userType}

                purpose="country"

              />

            </div>



            <div className="row">

              <div className="col-md-6 mb-2">

                {availableStates.length > 0 ? (

                  <CustomDropdown

                    title="State / Province"

                    field="province"

                    options={availableStates}

                    selectedValue={formData.province}

                    onSelect={(field, value) => {

                      setFormData(prev => ({ ...prev, province: value, city: '' }));

                    }}

                    error={errors.province}

                    required={false}

                    userType={userType}

                    purpose="nationality"

                  />

                ) : (

                  <input

                    type="text"

                    name="province"

                    className={`form-control rounded-input ${errors.province ? 'is-invalid' : ''}`}

                    placeholder="State / Province"

                    value={formData.province}

                    onChange={handleChange}

                  />

                )}

                {errors.province && <div className="invalid-feedback d-block">{errors.province}</div>}

              </div>

              <div className="col-md-6 mb-2">

                {availableCities.length > 0 ? (

                  <CustomDropdown

                    title="City"

                    field="city"

                    options={availableCities}

                    selectedValue={formData.city}

                    onSelect={(field, value) => {

                      setFormData(prev => ({ ...prev, city: value }));

                    }}

                    error={errors.city}

                    required={false}

                    userType={userType}

                    purpose="nationality"

                  />

                ) : (

                  <input

                    type="text"

                    name="city"

                    className={`form-control rounded-input ${errors.city ? 'is-invalid' : ''}`}

                    placeholder="City"

                    value={formData.city}

                    onChange={handleChange}

                  />

                )}

                {errors.city && <div className="invalid-feedback d-block">{errors.city}</div>}

              </div>

            </div>

          </div>



          {/* Section 3: Contact */}

          <div className="mb-3">

            <div className="mb-2">

              <PhoneInputWithCountryCode

                numberField="official_phone"

                countryCodeField="official_phone_country_code"

                placeholder="Enter mobile number"

                required={true}

                formData={formData}

                onCountryCodeChange={(field, value) => {

                  handleCountryCodeChange(field, value);

                  if (whatsappSameAsMobile) {

                    setFormData(prev => ({

                      ...prev,

                      [field]: value,

                      whatsapp_number_1_country_code: value

                    }));

                  }

                }}

                onInputChange={(e) => {

                  handleChange(e);

                  if (whatsappSameAsMobile) {

                    setFormData(prev => ({

                      ...prev,

                      [e.target.name]: e.target.value,

                      whatsapp_number_1: e.target.value

                    }));

                  }

                }}

                userType={userType}

              />

              {errors.official_phone && <div className="invalid-feedback d-block">{errors.official_phone}</div>}

            </div>



            <div className="mb-2">

              <div className="mb-2 d-flex align-items-center justify-content-start ms-4">

                <input

                  type="checkbox"

                  className="form-check-input mt-0"

                  id="whatsapp-same-mobile"

                  checked={whatsappSameAsMobile}

                  onChange={(e) => handleWhatsappSameAsMobile(e.target.checked)}

                  style={{ cursor: 'pointer', width: '18px', height: '18px' }}

                />

                <label className="form-check-label ms-2 small text-muted cursor-pointer" htmlFor="whatsapp-same-mobile" style={{ cursor: 'pointer', userSelect: 'none' }}>

                  Same as Mobile Number

                </label>

              </div>

              {!whatsappSameAsMobile && (

                <PhoneInputWithCountryCode

                  numberField="whatsapp_number_1"

                  countryCodeField="whatsapp_number_1_country_code"

                  placeholder="WhatsApp number (optional)"

                  formData={formData}

                  onCountryCodeChange={handleCountryCodeChange}

                  onInputChange={handleChange}

                  userType={userType}

                />

              )}

            </div>

          </div>



          {/* Section 4: Account Credentials */}

          <div className="mb-3">

            <div className="mb-2">

              <input

                type="email"

                name="email"

                className={`form-control rounded-input ${errors.email ? 'is-invalid' : ''}`}

                placeholder="Email Address *"

                value={formData.email}

                onChange={handleChange}

                required

              />

              {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}

            </div>



            <div className="mb-2 position-relative">

              <input

                type={showPassword ? "text" : "password"}

                name="password"

                className={`form-control rounded-input pe-5 ${errors.password ? 'is-invalid' : ''}`}

                placeholder="Password (minimum 8 characters) *"

                value={formData.password}

                onChange={handleChange}

                required

              />

              <i

                className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}

                style={{ top: "10px", right: "15px", cursor: "pointer", color: "#6c757d" }}

                onClick={() => setShowPassword((prev) => !prev)}

              ></i>

              {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}

            </div>



            <div className="mb-2 position-relative">

              <input

                type={showConfirmPassword ? "text" : "password"}

                name="confirmPassword"

                className={`form-control rounded-input pe-5 ${errors.confirmPassword ? 'is-invalid' : ''}`}

                placeholder="Confirm Password *"

                value={formData.confirmPassword}

                onChange={handleChange}

                required

              />

              <i

                className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}

                style={{ top: "10px", right: "15px", cursor: "pointer", color: "#6c757d" }}

                onClick={() => setShowConfirmPassword((prev) => !prev)}

              ></i>

              {errors.confirmPassword && <div className="invalid-feedback d-block">{errors.confirmPassword}</div>}

            </div>

          </div>



          {/* Section 5: Recruitment Category */}

          <div className="mb-3">

            <label className="form-label small fw-semibold mb-2">Recruitment Category *</label>

            <div className="d-flex flex-wrap gap-2">

              {recruitmentCategoryOptions.map((cat) => (

                <div

                  key={cat}

                  className={`badge py-2 px-3 ${(formData.recruitment_categories || []).includes(cat) ? '' : ''}`}

                  style={{

                    cursor: 'pointer',

                    fontSize: '0.85rem',

                    border: (formData.recruitment_categories || []).includes(cat) ? '2px solid #198754' : '1px solid #ced4da',

                    backgroundColor: (formData.recruitment_categories || []).includes(cat) ? '#e8f5e9' : '#fff',

                    color: (formData.recruitment_categories || []).includes(cat) ? '#198754' : '#6c757d',

                    borderRadius: '0px',

                    fontWeight: (formData.recruitment_categories || []).includes(cat) ? '600' : '400',

                    transition: 'all 0.2s ease'

                  }}

                  onClick={() => handleRecruitmentCategoryToggle(cat)}

                >

                  {(formData.recruitment_categories || []).includes(cat) && <FaCheck size={10} className="me-1" />}

                  {cat}

                </div>

              ))}

            </div>

            {errors.recruitment_categories && <div className="invalid-feedback d-block">{errors.recruitment_categories}</div>}

          </div>



          {/* Section 6: Select Plan */}

          <div className="mb-3">

            <label className="form-label small fw-semibold mb-2">Select Plan *</label>

            <div className="d-flex flex-wrap gap-2">

              {planOptions.map((plan) => (

                <div

                  key={plan}

                  className="d-flex align-items-center px-3 py-2"

                  style={{

                    cursor: 'pointer',

                    border: formData.selected_plan === plan ? '2px solid #198754' : '1px solid #ced4da',

                    borderRadius: '0px',

                    backgroundColor: formData.selected_plan === plan ? '#e8f5e9' : '#fff',

                    transition: 'all 0.2s ease',

                    flex: '1',

                    justifyContent: 'center'

                  }}

                  onClick={() => setFormData(prev => ({ ...prev, selected_plan: plan }))}

                >

                  <div

                    style={{

                      width: '18px',

                      height: '18px',

                      borderRadius: '50%',

                      border: formData.selected_plan === plan ? '2px solid #198754' : '2px solid #ced4da',

                      display: 'flex',

                      alignItems: 'center',

                      justifyContent: 'center',

                      marginRight: '8px',

                      transition: 'all 0.2s ease'

                    }}

                  >

                    {formData.selected_plan === plan && (

                      <div style={{

                        width: '10px',

                        height: '10px',

                        borderRadius: '50%',

                        backgroundColor: '#198754'

                      }} />

                    )}

                  </div>

                  <span style={{

                    color: formData.selected_plan === plan ? '#198754' : '#495057',

                    fontWeight: formData.selected_plan === plan ? '600' : '400',

                    fontSize: '0.9rem'

                  }}>

                    {plan}

                  </span>

                </div>

              ))}

            </div>

          </div>



          {/* Section 7: Legal Confirmation */}

          <div className="mb-3">

            <div className="mb-2 d-flex align-items-center justify-content-start ms-4">

              <input

                type="checkbox"

                className="form-check-input mt-0"

                id="legal-confirmation"

                checked={formData.legalConfirmation}

                onChange={(e) => setFormData(prev => ({ ...prev, legalConfirmation: e.target.checked }))}

                style={{ cursor: 'pointer', width: '18px', height: '18px' }}

              />

              <label className="form-check-label ms-2 small text-muted cursor-pointer" htmlFor="legal-confirmation" style={{ cursor: 'pointer', userSelect: 'none' }}>

                I confirm that my agency operates legally in my country.

              </label>

            </div>

            {errors.legalConfirmation && <div className="invalid-feedback d-block">{errors.legalConfirmation}</div>}

          </div>

        </>

      );

    } else if (registrationStep === 2) {

      return renderOtpVerification();

    } else {

      return (

        <>

          <div className="mb-3">

            <h6 className="fw-semibold border-bottom pb-2">Agency/Business Information<span className="text-danger">*</span></h6>



            <div className="mb-2">

              <input

                type="text"

                name="agency_name"

                className={`form-control rounded-input ${errors.agency_name ? 'is-invalid' : ''}`}

                placeholder="Enter name of your agency/business"

                value={formData.agency_name}

                onChange={handleChange}

                required

              />

              {errors.agency_name && <div className="invalid-feedback d-block">{errors.agency_name}</div>}

            </div>



            <div className="row">

              <div className="col-md-4 mb-2">

                <input

                  type="text"

                  name="city"

                  className={`form-control rounded-input ${errors.city ? 'is-invalid' : ''}`}

                  placeholder="Enter your city"

                  value={formData.city}

                  onChange={handleChange}

                  required

                />

                {errors.city && <div className="invalid-feedback d-block">{errors.city}</div>}

              </div>

              <div className="col-md-4 mb-2">

                <input

                  type="text"

                  name="province"

                  className="form-control rounded-input"

                  placeholder="Enter your province/state"

                  value={formData.province}

                  onChange={handleChange}

                />

              </div>

              <div className="col-md-4 mb-2">

                <CustomDropdown

                  title="Select your country"

                  field="country"

                  options={getCountryOptions(userType, "country")}

                  selectedValue={formData.country}

                  onSelect={handleSelect}

                  error={errors.country}

                  required={true}

                  userType={userType}

                  purpose="country"

                />

              </div>

            </div>



            <div className="mb-2">

              <textarea

                name="full_address"

                className={`form-control rounded-input ${errors.full_address ? 'is-invalid' : ''}`}

                placeholder="Enter your full address including postal code"

                value={formData.full_address}

                onChange={handleChange}

                required

                rows="3"

              />

              {errors.full_address && <div className="invalid-feedback d-block">{errors.full_address}</div>}

            </div>

          </div>



          <div className="mb-3">

            <h6 className="fw-semibold border-bottom pb-2">Contact Information</h6>



            <div className="mb-2">

              <label className="form-label small fw-semibold">Official Phone Number<span className="text-danger">*</span></label>

              <PhoneInputWithCountryCode

                numberField="official_phone"

                countryCodeField="official_phone_country_code"

                placeholder="Enter official phone number"

                required={true}

                formData={formData}

                onCountryCodeChange={handleCountryCodeChange}

                onInputChange={handleChange}

                userType={userType}

              />

              {errors.official_phone && <div className="invalid-feedback d-block">{errors.official_phone}</div>}

            </div>



            <div className="mb-2">

              <label className="form-label small fw-semibold">Primary WhatsApp Number<span className="text-danger">*</span></label>

              <PhoneInputWithCountryCode

                numberField="whatsapp_number_1"

                countryCodeField="whatsapp_number_1_country_code"

                placeholder="Primary WhatsApp number"

                required={true}

                formData={formData}

                onCountryCodeChange={handleCountryCodeChange}

                onInputChange={handleChange}

                userType={userType}

              />

              {errors.whatsapp_number_1 && <div className="invalid-feedback d-block">{errors.whatsapp_number_1}</div>}

            </div>



            <div className="mb-2">

              <label className="form-label small fw-semibold">Secondary WhatsApp Number (Optional)</label>

              <PhoneInputWithCountryCode

                numberField="whatsapp_number_2"

                countryCodeField="whatsapp_number_2_country_code"

                placeholder="Secondary WhatsApp number (optional)"

                formData={formData}

                onCountryCodeChange={handleCountryCodeChange}

                onInputChange={handleChange}

                userType={userType}

              />

            </div>



            <div className="mb-2">

              <label className="form-label small fw-semibold">Additional WhatsApp Number (Optional)</label>

              <PhoneInputWithCountryCode

                numberField="whatsapp_number_3"

                countryCodeField="whatsapp_number_3_country_code"

                placeholder="Additional WhatsApp number (optional)"

                formData={formData}

                onCountryCodeChange={handleCountryCodeChange}

                onInputChange={handleChange}

                userType={userType}

              />

            </div>



            <div className="mb-2">

              <label className="form-label small fw-semibold">Additional WhatsApp Number (Optional)</label>

              <PhoneInputWithCountryCode

                numberField="whatsapp_number_4"

                countryCodeField="whatsapp_number_4_country_code"

                placeholder="Additional WhatsApp number (optional)"

                formData={formData}

                onCountryCodeChange={handleCountryCodeChange}

                onInputChange={handleChange}

                userType={userType}

              />

            </div>



            <div className="mb-2">

              <input

                type="email"

                name="email"

                className={`form-control rounded-input ${errors.email ? 'is-invalid' : ''}`}

                value={formData.email}

                onChange={handleChange}

                placeholder="Enter email address"

                required

                disabled

              />

              {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}

            </div>



            <div className="mb-2">

              <input

                type="url"

                name="website_url"

                className="form-control rounded-input"

                value={formData.website_url}

                onChange={handleChange}

                placeholder="Enter website URL (optional)"

              />

            </div>

          </div>



          <div className="mb-3">

            <h6 className="fw-semibold border-bottom pb-2">Owner/Director Information<span className="text-danger">*</span></h6>



            <div className="mb-2">

              <input

                type="text"

                name="owner_name"

                className={`form-control rounded-input ${errors.owner_name ? 'is-invalid' : ''}`}

                value={formData.owner_name}

                onChange={handleChange}

                placeholder="Enter owner's full name"

                required

              />

              {errors.owner_name && <div className="invalid-feedback d-block">{errors.owner_name}</div>}

            </div>



            <div className="mb-2">

              <CustomDropdown

                title="Select owner nationality"

                field="owner_nationality"

                options={getCountryOptions(userType, "nationality")}

                selectedValue={formData.owner_nationality}

                onSelect={handleSelect}

                error={errors.owner_nationality}

                required={false}

                purpose="nationality"

              />

            </div>

            {/* 

            <div className="mb-2">

              <label className="form-label fw-semibold">Owner Photo (Optional)</label>

              <input

                type="file"

                name="owner_photo"

                className="form-control rounded-input"

                onChange={handleFileChange}

                accept="image/*"

              />

              <div className="form-text">Upload owner's photo (Image files only) - Optional</div>

            </div> */}



            <div className="mb-2">

              <label className="form-label small fw-semibold">Owner Mobile Number (Optional)</label>

              <PhoneInputWithCountryCode

                numberField="owner_mobile"

                countryCodeField="owner_mobile_country_code"

                placeholder="Enter owner's mobile number (optional)"

                formData={formData}

                onCountryCodeChange={handleCountryCodeChange}

                onInputChange={handleChange}

                userType={userType}

              />

            </div>



            <div className="mb-2">

              <input

                type="email"

                name="owner_email"

                className="form-control rounded-input"

                value={formData.owner_email}

                onChange={handleChange}

                placeholder="Enter owner's email address (optional)"

              />

            </div>

          </div>



          <div className="mb-3">

            <h6 className="fw-semibold border-bottom pb-2">Required Document Uploads</h6>



            <div className="mb-2">

              <label className="form-label fw-semibold">Company Logo</label>

              <input

                type="file"

                name="company_logo"

                className={`form-control rounded-input ${errors.company_logo ? 'is-invalid' : ''}`}

                onChange={handleFileChange}

                accept="image/*"

              />

              {errors.company_logo && <div className="invalid-feedback d-block">{errors.company_logo}</div>}

              <div className="form-text">Upload your company logo (Image files only) - Optional</div>

            </div>



            <div className="mb-2">

              <label className="form-label fw-semibold">Business Cards</label>

              <input

                type="file"

                name="business_card"

                className="form-control rounded-input"

                onChange={handleFileChange}

                accept="image/*,application/pdf"

              />

              <div className="form-text">Upload business cards (Image or PDF files) - Optional</div>

            </div>



            <div className="mb-2">

              <label className="form-label fw-semibold">Business/Agency License</label>

              <input

                type="file"

                name="license_copy"

                className={`form-control rounded-input ${errors.license_copy ? 'is-invalid' : ''}`}

                onChange={handleFileChange}

                accept="image/*,application/pdf"

              // Removed: required

              />

              {errors.license_copy && <div className="invalid-feedback d-block">{errors.license_copy}</div>}

              <div className="form-text">Upload your business/agency license copy (Image or PDF files) - Optional</div>

            </div>

          </div>



          <div className="mb-2">

            <label className="form-label fw-semibold">Agency Office Photo (Optional)</label>

            <input

              type="file"

              name="owner_photo"

              className="form-control rounded-input"

              onChange={handleFileChange}

              accept="image/*"

            />

            <div className="form-text">Upload owner's photo (Image files only) - Optional</div>

          </div>



          <div className="mb-2">

            <label className="form-label fw-semibold">Office Building Photo (Optional)</label>

            <input

              type="file"

              name="office_building_photo"

              className="form-control rounded-input"

              onChange={handleFileChange}

              accept="image/*"

            />

            <div className="form-text">Upload Office Building photo (Image files only) - Optional</div>

          </div>



          <div className="mb-3">

            <label className="form-label fw-semibold">About Agency<span className="text-danger">*</span></label>

            <textarea

              name="about_agency"

              className={`form-control rounded-input ${errors.about_agency ? 'is-invalid' : ''}`}

              placeholder="Write about your agency (minimum 50 words) - e.g. services, specializations, years of experience, countries you operate in..."

              value={formData.about_agency || ''}

              onChange={handleChange}

              rows="5"

              required

            />

            <div className="d-flex justify-content-between mt-1">

              <div className="form-text">

                Minimum 50 words required

              </div>

              <div className={`form-text ${(formData.about_agency || '').trim().split(/\s+/).filter(w => w.length > 0).length >= 50 ? 'text-success' : 'text-danger'}`}>

                {(formData.about_agency || '').trim().split(/\s+/).filter(w => w.length > 0).length} / 50 words

              </div>

            </div>

            {errors.about_agency && <div className="invalid-feedback d-block">{errors.about_agency}</div>}

          </div>



          {/* REMOVED Account Credentials section from here - Moved to Step 1 */}



          {/* <div className="alert alert-info small">

            <strong>Note:</strong> Please ensure that all contact numbers are active and reachable via WhatsApp.

            All photos should be clear and recent. License must be valid and current.

          </div> */}



          <div className="alert alert-info small">

            <strong>Note:</strong> Only Agency/Business Information, Official Phone Number and Primary WhatsApp Number are required.

            Other fields are optional. Please ensure that all contact numbers are active and reachable via WhatsApp.

          </div>

        </>

      );

    }

  };



  const getDisabledMessage = (field) => {

    if (userType !== "jobSeeker" && userType !== "employer") return null;



    let checkOrder = [];



    if (userType === "jobSeeker") {

      checkOrder = [

        { id: "country_apply_for_job", label: "Country to Apply for Job", check: !formData.country_apply_for_job },

        { id: "category", label: "Job Category", check: !formData.category },

        { id: "job_position", label: "Job Position", check: !formData.job_position },

        { id: "driving_license_country", label: "Driving License", check: !formData.driving_license_country || formData.driving_license_country.length === 0 },

        { id: "driving_country_experience", label: "Country Experience", check: !formData.driving_country_experience || formData.driving_country_experience.length === 0 },

        { id: "total_work_experience", label: "Total Work Experience", check: !formData.total_work_experience },

        { id: "nationality", label: "Nationality", check: !formData.nationality },

        { id: "mobile_number", label: "Mobile Number", check: !formData.mobile_number },

        { id: "current_country", label: "Current Country", check: !formData.current_country },

        { id: "whatsapp_number", label: "WhatsApp Number", check: !formData.whatsapp_number },

        { id: "gender", label: "Gender", check: !formData.gender },

        { id: "religion", label: "Religion", check: !formData.religion },

        { id: "age", label: "Age", check: !formData.age },

        { id: "expected_monthly_salary_currency", label: "Country currency", check: !parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency },

        { id: "salary_type", label: "Salary Type", check: !formData.salary_type },

        { id: "salary_value", label: "Expected Monthly Salary", check: formData.salary_type !== "Negotiable" && !formData.salary_value },

        { id: "first_name", label: "First & Last name", check: !formData.first_name },

        { id: "email", label: "Email address", check: !formData.email },

        { id: "password", label: "Password", check: !formData.password }

      ];

    } else if (userType === "employer") {

      checkOrder = [

        { id: "employer_type", label: "Employer Type", check: !formData.employer_type },

        { id: "nationality", label: "Nationality", check: !formData.nationality },

        { id: "company_size", label: "Company Size", check: formData.employer_type !== "Family" && !formData.company_size },

        { id: "country", label: "Country Of Work", check: !formData.country },

        // State, city, and UAE city are skipped as they are optional/conditional and handled via standard validation

        { id: "mobile_number", label: "Mobile Number", check: !formData.mobile_number },

        { id: "whatsapp_number", label: "WhatsApp Number", check: !formData.whatsapp_number },

        { id: "domestic_worker_category", label: "Worker Category", check: !formData.domestic_worker_category },

        { id: "gender", label: "Gender Preference", check: !formData.gender },

        { id: "religion", label: "Religion Preference", check: !formData.religion },

        { id: "age", label: "Age Preference", check: !formData.age },

        { id: "expected_monthly_salary_currency", label: "Country currency", check: !parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency },

        { id: "salary_type", label: "Salary Type", check: !formData.salary_type },

        { id: "salary_value", label: "Expected Monthly Salary", check: formData.salary_type !== "Negotiable" && !formData.salary_value },

        { id: "first_name", label: "First & Last name", check: !formData.first_name },

        { id: "email", label: "Email address", check: !formData.email },

        { id: "password", label: "Password", check: !formData.password }

      ];

    }



    const fieldIndex = checkOrder.findIndex(item => item.id === field);

    if (fieldIndex === -1) return null;



    for (let i = 0; i < fieldIndex; i++) {

      if (checkOrder[i].check) {

        return {

          message: `Please fill/select ${checkOrder[i].label} first.`,

          targetId: checkOrder[i].id

        };

      }

    }

    return null;

  };



  const handleFieldInteraction = (e, field) => {

    const disabledInfo = getDisabledMessage(field);

    if (disabledInfo) {

      e.preventDefault();

      if (e.target && e.target.blur) e.target.blur();



      if (!Swal.isVisible()) {

        Swal.fire({

          icon: 'warning',

          title: disabledInfo.message,

          confirmButtonColor: '#f27474'

        }).then(() => {

          // Find the target element

          let targetElement = document.querySelector(`[name="${disabledInfo.targetId}"]`);



          // If it's a custom dropdown without a name attribute, try to find it by ID

          if (!targetElement) {

            targetElement = document.getElementById(`dropdown-${disabledInfo.targetId}`);

          }



          if (targetElement) {

            // Scroll to the element smoothly

            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });



            // Add a temporary highlight animation to draw attention

            targetElement.classList.add('is-invalid');

            targetElement.classList.add('flash-highlight');



            // Remove flash animation after it completes so it can trigger again

            setTimeout(() => {

              targetElement.classList.remove('flash-highlight');

            }, 1000);



            // Focus the element if possible

            if (targetElement.focus) {

              setTimeout(() => targetElement.focus(), 500);

            }

          }

        });

      }

      return false;

    }

    return true;

  };



  const renderDefaultForm = () => (

    <>

      {/* Job seekers - Country to Apply for Job at the TOP */}

      {userType === "jobSeeker" && (

        <>

          {/* Country to Apply for Job field - NOW AT THE TOP */}

          <div className="mb-2">

            <CustomDropdown

              title="Select Country to Apply for Job"

              field="country_apply_for_job"

              options={countryApplyOptions}

              selectedValue={formData.country_apply_for_job}

              onSelect={handleSelect}

              error={errors.country_apply_for_job}

              required={true}

            />

          </div>



          {/* Job Category Selection */}

          <div className="mb-2">

            <CustomDropdown

              title="Select Job category"

              field="category"

              options={JOB_SEEKER_CATEGORY_OPTIONS}

              selectedValue={formData.category === "Hospital" ? "Healthcare" : formData.category}

              onSelect={(field, value) => {
                const normalizedValue = fromCategoryDisplayLabel(value);

                setFormData(prev => ({ ...prev, [field]: normalizedValue, job_position: "" }));

                validateField(field, normalizedValue);

              }}

              error={errors.category}

              required={true}

              disabledMessage={getDisabledMessage("category")}

            />

          </div>



          {/* Job Position Dropdown - MOVED ABOVE NAME */}

          <div className="mb-2">

            <JobPositionDropdown

              title="Select job position"

              field="job_position"

              selectedValue={formData.job_position}

              onSelect={handleSelect}

              error={errors.job_position}

              required={true}

              disabledMessage={getDisabledMessage("job_position")}

            />

          </div>



          {/* Nurse License / Exam Status Dropdown - ONLY SHOW FOR NURSES */}

          {hasHealthcareLicenseFlow(formData.job_position) && (

            <div className="mb-2">

              <CustomDropdown

                title="Select License / Exam Status"

                field="nurse_license_status"

                options={nurseLicenseOptions}

                selectedValue={formData.nurse_license_status}

                onSelect={handleSelect}

                error={errors.nurse_license_status}

                required={true}

                disabledMessage={getDisabledMessage("nurse_license_status")}

              />

            </div>

          )}

          {hasHealthcareLicenseFlow(formData.job_position) &&
            ["hospital", "healthcare"].includes(String(formData.category || "").toLowerCase()) &&
            formData.nurse_license_status &&
            formData.nurse_license_status !== "Not Yet Started" && (
              <div className="mb-2">
                <MultiSelectDropdown
                  title="Which Country Nursing License do you have?"
                  field="nursing_license_countries"
                  options={nursingLicenseCountries}
                  selectedValues={formData.nursing_license_countries || []}
                  onSelect={handleSelect}
                  error={errors.nursing_license_countries}
                  required={true}
                  disabledMessage={getDisabledMessage("nursing_license_countries")}
                />
              </div>
            )}



          {/* Cook Category Selection - ONLY SHOW FOR COOKS */}

          {cookPositions.includes(formData.job_position) && (

            <div className="mb-2">

              <MultiSelectDropdown

                title="Select Cook category"

                field="cook_category"

                options={flatCookCategoryOptions}

                selectedValues={formData.cook_category || []}

                onSelect={handleSelect}

                error={errors.cook_category}

                required={true}

                maxSelections={4}

                disabledMessage={getDisabledMessage("cook_category")}

              />

            </div>

          )}

        </>

      )}



      {/* Employer Type - ABOVE First Name field */}

      {userType === "employer" && (

        <div className="mb-2">

          <CustomDropdown

            title="Select Employer Type"

            field="employer_type"

            options={["Family", "Company", "Agency", "Other"]}

            selectedValue={formData.employer_type}

            onSelect={handleSelect}

            error={errors.employer_type}

            required={true}

            disabledMessage={getDisabledMessage("employer_type")}

          />

          {errors.employer_type &&

            <div className="invalid-feedback d-block">{errors.employer_type}</div>

          }

        </div>

      )}



      {/* Nationality Dropdown - Only for Employers */}

      {userType === "employer" && (

        <div className="mb-2">

          <CustomDropdown

            title="Select Your Nationality"

            field="nationality"

            options={getCountryOptions(userType, "nationality")}

            selectedValue={formData.nationality}

            onSelect={handleSelect}

            error={errors.nationality}

            required={true}

            disabledMessage={getDisabledMessage("nationality")}

          />

          {errors.nationality &&

            <div className="invalid-feedback d-block">{errors.nationality}</div>

          }

        </div>

      )}



      {/* Company Size Dropdown - Only for Employers, hidden for Family */}

      {userType === "employer" && formData.employer_type !== "Family" && (

        <div className="mb-2">

          <CustomDropdown

            title="Select Company Size"

            field="company_size"

            options={["1–5 employees", "6–20", "21–100", "100+"]}

            selectedValue={formData.company_size}

            onSelect={handleSelect}

            error={errors.company_size}

            required={true}

            disabledMessage={getDisabledMessage("company_size")}

          />

        </div>

      )}



      {/* Show UAE fields only for employers */}

      {userType === "employer" && (

        <>



          <div className="mb-2">

            <CustomDropdown

              title="Select Country Of Work"

              field="country"

              options={Object.keys(countryStateCityData)}

              selectedValue={formData.country}

              onSelect={handleSelect}

              error={errors.country}

              required={true}

              disabledMessage={getDisabledMessage("country")}

            />

          </div>



          <div className="mb-2">

            <CustomDropdown

              title="Select State/Province Of Work"

              field="state_or_province"

              options={getAvailableStates(formData.country)}

              selectedValue={formData.state_or_province}

              onSelect={handleSelect}

              error={errors.state_or_province}

              required={false}

              disabledMessage={getDisabledMessage("country")}

            />

          </div>



          <div className="mb-2">

            <CustomDropdown

              title="Select City Of Work"

              field="working_city"

              options={getAvailableCities(formData.country, formData.state_or_province)}

              selectedValue={formData.working_city}

              onSelect={handleSelect}

              error={errors.working_city}

              required={false}

              disabledMessage={getDisabledMessage("country")}

            />

          </div>



          {/* NEW FIELD: Mobile Number with Country Code - Moved below City Of Work */}

          <div className="mb-3">

            {/* <label className="form-label small fw-semibold">Mobile Number<span className="text-danger">*</span></label> */}

            <PhoneInputWithCountryCode

              numberField="mobile_number"

              countryCodeField="mobile_number_country_code"

              placeholder="Enter mobile number"

              className="form-control-register rounded-input"

              formData={formData}

              onCountryCodeChange={handleCountryCodeChange}

              onInputChange={handleChange}

              userType={userType}

              required={true}

              disabledMessage={getDisabledMessage("mobile_number")}

            />

            {errors.mobile_number &&

              <div className="invalid-feedback d-block">{errors.mobile_number}</div>

            }

            {errors.mobile_number_country_code &&

              <div className="invalid-feedback d-block">{errors.mobile_number_country_code}</div>

            }

          </div>



          {/* NEW FIELD: WhatsApp Number with Country Code - Moved below Mobile Number */}

          <div className="mb-3">

            {/* <label className="form-label small fw-semibold">WhatsApp Number<span className="text-danger">*</span></label> */}

            <PhoneInputWithCountryCode

              numberField="whatsapp_number"

              countryCodeField="whatsapp_country_code"

              placeholder="Enter WhatsApp number"

              className="form-control-register rounded-input"

              formData={formData}

              onCountryCodeChange={handleCountryCodeChange}

              onInputChange={handleChange}

              userType={userType}

              required={true}

              disabledMessage={getDisabledMessage("whatsapp_number")}

            />

            {errors.whatsapp_number &&

              <div className="invalid-feedback d-block">{errors.whatsapp_number}</div>

            }

            {errors.whatsapp_country_code &&

              <div className="invalid-feedback d-block">{errors.whatsapp_country_code}</div>

            }

          </div>



          {/* NEW FIELD: Worker Category Dropdown */}

          <div className="mb-2">

            <CustomDropdown

              title="Select Worker Category"

              field="domestic_worker_category"

              options={workerCategoryOptions}

              selectedValue={formData.domestic_worker_category}

              onSelect={handleSelect}

              error={errors.domestic_worker_category}

              required={true}

              disabledMessage={getDisabledMessage("domestic_worker_category")}

            />

            {errors.domestic_worker_category &&

              <div className="invalid-feedback d-block">{errors.domestic_worker_category}</div>

            }

          </div>



          {/* New Employer Preferences: Gender, Religion, Age */}

          {userType === "employer" && (

            <>

              <div className="row g-2 mb-2">

                <div className="col-6">

                  <select

                    name="gender"

                    className="form-control-register rounded-input"

                    value={formData.gender}

                    onChange={handleChange}

                    onClick={(e) => handleFieldInteraction(e, "gender")}

                    onMouseDown={(e) => handleFieldInteraction(e, "gender")}

                    onTouchStart={(e) => handleFieldInteraction(e, "gender")}

                    onKeyDown={(e) => handleFieldInteraction(e, "gender")}

                    style={{

                      color: formData.gender ? '#000' : '#6c757d',

                      height: '50px',

                      border: '1px solid #ced4da',

                      borderRadius: '0.375rem',

                      padding: '0.375rem 0.75rem',

                      fontSize: '1rem',

                      backgroundColor: '#fff'

                    }}

                  >

                    <option value="" disabled>Select Gender</option>

                    <option value="Male">Male</option>

                    <option value="Female">Female</option>

                    <option value="Any">Any</option>

                  </select>

                  {errors.gender && <div className="invalid-feedback d-block">{errors.gender}</div>}

                </div>

                <div className="col-6">

                  <select

                    name="religion"

                    className="form-control-register rounded-input"

                    value={formData.religion}

                    onChange={handleChange}

                    onClick={(e) => handleFieldInteraction(e, "religion")}

                    onMouseDown={(e) => handleFieldInteraction(e, "religion")}

                    onTouchStart={(e) => handleFieldInteraction(e, "religion")}

                    onKeyDown={(e) => handleFieldInteraction(e, "religion")}

                    style={{

                      color: formData.religion ? '#000' : '#6c757d',

                      height: '50px',

                      border: '1px solid #ced4da',

                      borderRadius: '0.375rem',

                      padding: '0.375rem 0.75rem',

                      fontSize: '1rem',

                      backgroundColor: '#fff'

                    }}

                  >

                    <option value="" disabled>Select Religion</option>

                    <option value="Muslim">Muslim</option>

                    <option value="Hindu">Hindu</option>

                    <option value="Christian">Christian</option>

                    <option value="Any">Any</option>

                  </select>

                </div>

              </div>

              <div className="mb-2">

                <select

                  name="age"

                  className="form-control-register rounded-input"

                  value={formData.age}

                  onChange={handleChange}

                  onClick={(e) => handleFieldInteraction(e, "age")}

                  onMouseDown={(e) => handleFieldInteraction(e, "age")}

                  onTouchStart={(e) => handleFieldInteraction(e, "age")}

                  onKeyDown={(e) => handleFieldInteraction(e, "age")}

                  style={{

                    color: formData.age ? '#000' : '#6c757d',

                    height: '50px',

                    border: '1px solid #ced4da',

                    borderRadius: '0.375rem',

                    padding: '0.375rem 0.75rem',

                    fontSize: '1rem',

                    backgroundColor: '#fff'

                  }}

                >

                  <option value="" disabled>Select Age Range</option>

                  <option value="18-20">18-20</option>

                  <option value="20-25">20-25</option>

                  <option value="25-30">25-30</option>

                  <option value="30-35">30-35</option>

                  <option value="35-40">35-40</option>

                  <option value="40-45">40-45</option>

                  <option value="45-50">45-50</option>

                  <option value="Below 30">Below 30</option>

                  <option value="Below 35">Below 35</option>

                  <option value="21-40">21-40</option>

                  <option value="Below 40">Below 40</option>

                  <option value="Below 45">Below 45</option>

                  <option value="Below 50">Below 50</option>

                  <option value="Below 55">Below 55</option>

                </select>

                {errors.age && <div className="invalid-feedback d-block">{errors.age}</div>}

              </div>

            </>

          )}



          <Row className="mb-3 g-2">

            <Col xs={12} md={4}>

              <CustomDropdown

                title="Select Country currency"

                field="expected_monthly_salary_currency"

                options={currencyOptions}

                selectedValue={parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency}

                onSelect={(field, value) => handleSalaryChange('expected_monthly_salary_currency', value)}

                error={errors.expected_monthly_salary_currency}

                required={false}

              />

            </Col>

            <Col xs={12} md={4}>

              <CustomDropdown

                title="Select Salary Type"

                field="salary_type"

                options={salaryTypeOptions}

                selectedValue={formData.salary_type}

                onSelect={(field, value) => handleSalaryChange('salary_type', value)}

                error={errors.salary_type}

                required={false}

                disabled={!parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency}

              />

            </Col>

            {formData.salary_type === "Fix salary" && (

              <Col xs={12} md={4}>

                <input

                  type="number"

                  min="0"

                  step="1"

                  className={`form-control-register rounded-input ${errors.salary_value ? 'is-invalid' : ''}`}

                  placeholder="Enter Salary"

                  value={formData.salary_value}

                  onChange={(e) => handleSalaryChange('salary_value', e.target.value)}

                  disabled={!parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency}

                />

                {errors.salary_value && <div className="invalid-feedback d-block">{errors.salary_value}</div>}

              </Col>

            )}

          </Row>







          {/* Show UAE specific fields only when UAE is selected (always for employer) */}

          {/* {formData.country && (

            <>

              <div className="mb-2">

                <CustomDropdown

                  title="Select State/Province"

                  field="state_or_province"

                  options={getAvailableStates(formData.country)}

                  selectedValue={formData.state_or_province}

                  onSelect={handleSelect}

                  error={errors.state_or_province}

                  required={false}

                />

              </div>



              {formData.state_or_province && (

                <div className="mb-2">

                  <CustomDropdown

                    title="Select City"

                    field="working_city"

                    options={getAvailableCities(formData.country, formData.state_or_province)}

                    selectedValue={formData.working_city}

                    onSelect={handleSelect}

                    error={errors.working_city}

                    required={false}

                  />

                </div>

              )}

            </>

          )} */}

        </>

      )}



      {/* Job seekers - Rest of the fields */}

      {userType === "jobSeeker" && (

        <>

          {/* Driving License Field */}

          <div className="mb-2">

            <MultiSelectDropdown

              title="Select Driving License"

              field="driving_license_country"

              options={drivingLicenseOptions}

              selectedValues={formData.driving_license_country || []}

              onSelect={handleSelect}

              error={errors.driving_license_country}

              required={false}

              maxSelections={3}

              disabledMessage={getDisabledMessage("driving_license_country")}

            />

          </div>



          {/* Country Experience Field */}

          <div className="mb-2">

            <MultiSelectDropdown

              title="Select Country Experience"

              field="driving_country_experience"

              options={allWorldCountries}

              selectedValues={formData.driving_country_experience}

              onSelect={handleSelect}

              error={errors.driving_country_experience}

              required={false}

              maxSelections={3}

              disabledMessage={getDisabledMessage("driving_country_experience")}

            />

          </div>



          {/* Total Experience Field */}

          <div className="mb-2">

            <CustomDropdown

              title="Select Total Work Experience"

              field="total_work_experience"

              options={totalExperienceOptions}

              selectedValue={formData.total_work_experience}

              onSelect={handleSelect}

              error={errors.total_work_experience}

              required={false}

              disabledMessage={getDisabledMessage("total_work_experience")}

            />

          </div>



          <div className="mb-2">

            <CustomDropdown

              title="Select your nationality"

              field="nationality"

              options={getCountryOptions(userType, "nationality")}

              selectedValue={formData.nationality}

              onSelect={handleSelect}

              error={errors.nationality}

              required={true}

              userType={userType}

              purpose="nationality"

              disabledMessage={getDisabledMessage("nationality")}

            />

          </div>



          {/* Mobile Number field */}

          <div className="mb-3">

            <PhoneInputWithCountryCode

              numberField="mobile_number"

              countryCodeField="mobile_number_country_code"

              placeholder="Enter Mobile number"

              className="form-control-register rounded-input"

              formData={formData}

              onCountryCodeChange={handleCountryCodeChange}

              onInputChange={handleChange}

              userType={userType}

              required={true}

              disabledMessage={getDisabledMessage("mobile_number")}

            />

            {errors.mobile_number && <div className="invalid-feedback d-block">{errors.mobile_number}</div>}

          </div>



          {/* Current Country dropdown */}

          <div className="mb-2">

            <CustomDropdown

              title="Which country are you living now?"

              field="current_country"

              options={getCountryOptions(userType, "nationality")}

              selectedValue={formData.current_country}

              onSelect={handleSelect}

              error={errors.current_country}

              required={true}

              userType={userType}

              purpose="nationality"

              disabledMessage={getDisabledMessage("current_country")}

            />

          </div>



          {/* WhatsApp field */}

          <div className="mb-3">

            <PhoneInputWithCountryCode

              numberField="whatsapp_number"

              countryCodeField="whatsapp_country_code"

              placeholder="Enter WhatsApp number"

              className="form-control-register rounded-input"

              formData={formData}

              onCountryCodeChange={handleCountryCodeChange}

              onInputChange={handleChange}

              userType={userType}

              required={true}

              disabledMessage={getDisabledMessage("whatsapp_number")}

            />

            {errors.whatsapp_number && <div className="invalid-feedback d-block">{errors.whatsapp_number}</div>}

          </div>

        </>

      )}



      {/* Agencies get regular country dropdown */}

      {userType === "agency" && (

        <div className="mb-2">

          <CustomDropdown

            title="Select your country"

            field="country"

            options={getCountryOptions(userType, "country")}

            selectedValue={formData.country}

            onSelect={handleSelect}

            error={errors.country}

            required={true}

            userType={userType}

            purpose="country"

          />

        </div>

      )}



      {/* Gender, Religion, Age and Salary - Moved just above Email */}

      {userType === "jobSeeker" && (

        <>

          <div className="row g-2 mb-2">

            <div className="col-12 col-md-4">

              <select

                name="gender"

                className="form-control-register rounded-input"

                value={formData.gender}

                onChange={handleChange}

                onClick={(e) => handleFieldInteraction(e, "gender")}

                onMouseDown={(e) => handleFieldInteraction(e, "gender")}

                onTouchStart={(e) => handleFieldInteraction(e, "gender")}

                onKeyDown={(e) => handleFieldInteraction(e, "gender")}

                style={{

                  color: formData.gender ? '#000' : '#6c757d',

                  height: '50px',

                  border: '1px solid #ced4da',

                  borderRadius: '0.375rem',

                  padding: '0.375rem 0.75rem',

                  fontSize: '0.9rem',

                  backgroundColor: '#fff'

                }}

              >

                <option value="" disabled>Select Gender</option>

                <option value="Male">Male</option>

                <option value="Female">Female</option>

              </select>

            </div>



            <div className="col-12 col-md-4">

              <select

                name="religion"

                className="form-control-register rounded-input"

                value={formData.religion}

                onChange={handleChange}

                onClick={(e) => handleFieldInteraction(e, "religion")}

                onMouseDown={(e) => handleFieldInteraction(e, "religion")}

                onTouchStart={(e) => handleFieldInteraction(e, "religion")}

                onKeyDown={(e) => handleFieldInteraction(e, "religion")}

                style={{

                  color: formData.religion ? '#000' : '#6c757d',

                  height: '50px',

                  border: '1px solid #ced4da',

                  borderRadius: '0.375rem',

                  padding: '0.375rem 0.75rem',

                  fontSize: '0.9rem',

                  backgroundColor: '#fff'

                }}

              >

                <option value="" disabled>Religion *</option>

                {religions.map((rel) => (

                  <option key={rel} value={rel}>{rel}</option>

                ))}

              </select>

            </div>



            <div className="col-12 col-md-4">

              <AgeDropdown

                selectedValue={formData.age}

                onSelect={handleSelect}

                disabledMessage={getDisabledMessage("age")}

              />

            </div>

          </div>



          <Row className="mb-3 g-2">

            <Col xs={12} md={4}>

              <CustomDropdown

                title="Select Country currency"

                field="expected_monthly_salary_currency"

                options={currencyOptions}

                selectedValue={parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency}

                onSelect={(field, value) => handleSalaryChange('expected_monthly_salary_currency', value)}

                error={errors.expected_monthly_salary_currency}

                required={false}

                disabledMessage={getDisabledMessage("expected_monthly_salary_currency")}

              />

            </Col>

            <Col xs={12} md={4}>

              <CustomDropdown

                title="Select Salary Type"

                field="salary_type"

                options={salaryTypeOptions}

                selectedValue={formData.salary_type}

                onSelect={(field, value) => handleSalaryChange('salary_type', value)}

                error={errors.salary_type}

                required={false}

                disabled={!parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency}

              />

            </Col>

            {formData.salary_type === "Fix salary" && (

              <Col xs={12} md={4}>

                <input

                  type="number"

                  min="0"

                  step="1"

                  className={`form-control-register rounded-input ${errors.salary_value ? 'is-invalid' : ''}`}

                  placeholder="Enter Salary"

                  value={formData.salary_value}

                  onChange={(e) => handleSalaryChange('salary_value', e.target.value)}

                  disabled={!parseStoredCurrencyValue(formData.expected_monthly_salary_currency).baseCurrency}

                />

                {errors.salary_value && <div className="invalid-feedback d-block">{errors.salary_value}</div>}

              </Col>

            )}

          </Row>

        </>

      )}



      {/* First Name field - Now just above Email */}

      <div className="mb-2">

        <input

          type="text"

          name="first_name"

          style={{ marginBottom: '7px' }}

          className={`form-control-register rounded-input ${errors.first_name ? 'is-invalid' : ''}`}

          placeholder="Type your first & last name"

          value={formData.first_name}

          onChange={handleChange}

          onClick={(e) => handleFieldInteraction(e, "first_name")}

          onFocus={(e) => handleFieldInteraction(e, "first_name")}

          required

        />

        {errors.first_name && <div className="invalid-feedback d-block">{errors.first_name}</div>}

      </div>



      {/* Email field */}

      <div className="mb-3">

        <input

          type="email"

          name="email"

          className={`form-control-register rounded-input ${errors.email ? 'is-invalid' : ''}`}

          placeholder="Type your Email address"

          value={formData.email}

          onChange={handleChange}

          required

          disabled={otpSent}

          onClick={(e) => { if (!otpSent) handleFieldInteraction(e, "email"); }}

          onFocus={(e) => { if (!otpSent) handleFieldInteraction(e, "email"); }}

        />

        {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}

      </div>



      {/* Password field */}

      <div className="mb-3 position-relative">

        <input

          type={showPassword ? "text" : "password"}

          name="password"

          className={`form-control-register rounded-input pe-5 ${errors.password ? 'is-invalid' : ''}`}

          placeholder="Create password (minimum 8 characters)"

          value={formData.password}

          onChange={handleChange}

          onClick={(e) => handleFieldInteraction(e, "password")}

          onFocus={(e) => handleFieldInteraction(e, "password")}

          required

        />

        <i

          className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}

          style={{

            top: "10px",

            right: "15px",

            cursor: "pointer",

            color: "#6c757d"

          }}

          onClick={() => setShowPassword((prev) => !prev)}

        ></i>

        {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}

      </div>



      {/* Confirm Password field */}

      <div className="mb-3 position-relative">

        <input

          type={showConfirmPassword ? "text" : "password"}

          name="confirmPassword"

          className={`form-control-register rounded-input pe-5 ${errors.confirmPassword ? 'is-invalid' : ''}`}

          placeholder="Reconfirm your password"

          value={formData.confirmPassword}

          onChange={handleChange}

          required

        />

        <i

          className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}

          style={{

            top: "10px",

            right: "15px",

            cursor: "pointer",

            color: "#6c757d"

          }}

          onClick={() => setShowConfirmPassword((prev) => !prev)}

        ></i>

        {errors.confirmPassword && <div className="invalid-feedback d-block">{errors.confirmPassword}</div>}

      </div>

    </>

  );



  const renderOtpVerification = () => (

    <div className="mb-4">

      <h6 className="fw-semibold border-bottom pb-2">Email Verification</h6>

      <div className="alert alert-info small mb-3">

        We've sent a 4-digit verification code to <strong>{formData.email}</strong>.

        Please enter it below to verify your email address.

      </div>



      <div className="mb-3">

        <input

          type="text"

          className={`form-control rounded-input ${otpError ? 'is-invalid' : ''}`}

          placeholder="Enter 4-digit verification code"

          value={otp}

          onChange={(e) => {

            setOtp(e.target.value);

            setOtpError("");

          }}

          maxLength="4"

          required

        />

        {otpError && (

          <div className="invalid-feedback d-block">{otpError}</div>

        )}

      </div>



      <div className="text-center text-md-start">

        <div className="mb-2 mb-md-0">

          <button

            type="button"

            className="btn btn-outline-secondary btn-sm"

            onClick={sendOtp}

            disabled={otpLoading}

          >

            {otpLoading ? "Resending..." : "Resend OTP"}

          </button>

        </div>

        <div className="small text-muted">

          Didn't receive code? Check spam folder

        </div>

      </div>

    </div>

  );



  const renderCurrentStep = () => {

    if (userType === "agency") {

      return renderAgencyForm();

    } else {

      switch (registrationStep) {

        case 1:

          return renderDefaultForm();

        case 2:

          return renderOtpVerification();

        default:

          return renderDefaultForm();

      }

    }

  };



  const getSubmitButtonText = () => {

    if (loading) return "Processing...";

    if (otpLoading) return "Verifying...";



    if (userType === "agency") {

      switch (registrationStep) {

        case 1:

          return "Send Verification Code";

        case 2:

          return "Verify OTP";

        case 3:

          return "Complete Registration";

        default:

          return "Continue";

      }

    } else {

      switch (registrationStep) {

        case 1:

          return "Send Verification Code";

        case 2:

          return "Verify OTP";

        default:

          return "Create an account";

      }

    }

  };



  return (

    <>

      <Navbar />

      <div className="d-flex justify-content-center align-items-start bg-white py-5">

        <div className="card p-4 border-0 shadow-sm" style={{ maxWidth: "800px", width: "100%", marginTop: "33px" }}>

          <h2 className="mb-3 text-center fw-semibold">Register</h2>



          <div className="rounded px-3 py-2 mb-3 small" style={{ backgroundColor: '#e9ecf1', color: 'black' }}>

            Register on Gulfworker.net to connect directly with employers, job seekers and manpower agencies easily

          </div>



          {registrationStep === 1 && (

            <div className="rounded d-flex justify-content-around align-items-center text-center mb-4 py-3 flex-wrap" style={{ backgroundColor: '#e9ecf1', color: 'black' }}>

              {userOptions.map((option) => (

                <div

                  key={option.value}

                  className="mx-1 px-2 d-flex flex-column align-items-center job-role-registration"

                  onClick={() => {

                    setUserType(option.value);

                    setFormData(prev => ({ ...prev, country: "", nationality: "" }));

                    setErrors({});

                  }}

                >

                  <div className="d-flex align-items-center">

                    <div

                      className={`custom-radio-icon-registration me-2 ${userType === option.value ? 'select' : ''}`}

                    >

                      {userType === option.value && <FaCheck size={10} color="#fff" />}

                    </div>

                    <span className="fw-semibold">{option.label}</span>

                  </div>

                  <div className="job-rple-info-register">

                    {option.sub}

                  </div>

                </div>

              ))}

            </div>

          )}



          {registrationStep > 1 && (

            <div className="mb-4">

              <div className="d-flex align-items-center mb-2">

                <div className={`rounded-circle ${registrationStep >= 1 ? 'bg-primary text-white' : 'bg-light text-muted'}`}

                  style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>

                  1

                </div>

                <div className={`ms-2 ${registrationStep >= 1 ? 'fw-semibold' : 'text-muted'}`}>Basic Information</div>

                <div className="flex-grow-1 mx-2 border-top"></div>



                <div className={`rounded-circle ${registrationStep >= 2 ? 'bg-primary text-white' : 'bg-light text-muted'}`}

                  style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>

                  2

                </div>

                <div className={`ms-2 ${registrationStep >= 2 ? 'fw-semibold' : 'text-muted'}`}>Email Verification</div>



                {userType === "agency" && (

                  <>

                    <div className="flex-grow-1 mx-2 border-top"></div>

                    <div className={`rounded-circle ${registrationStep >= 3 ? 'bg-primary text-white' : 'bg-light text-muted'}`}

                      style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>

                      3

                    </div>

                    <div className={`ms-2 ${registrationStep >= 3 ? 'fw-semibold' : 'text-muted'}`}>Agency Details</div>

                  </>

                )}

              </div>

            </div>

          )}



          <form onSubmit={handleSubmit}>

            {renderCurrentStep()}



            {registrationStep === 1 && (

              <div className="mb-3 d-flex align-items-center justify-content-start ms-4">

                <input

                  type="checkbox"

                  className="form-check-input mt-0"

                  id="terms-checkbox"

                  checked={formData.termsAccepted}

                  onChange={(e) => setFormData(prev => ({ ...prev, termsAccepted: e.target.checked }))}

                  style={{ cursor: 'pointer', width: '18px', height: '18px' }}

                />

                <label className="form-check-label ms-2 small text-muted cursor-pointer" htmlFor="terms-checkbox" style={{ cursor: 'pointer', userSelect: 'none' }}>

                  I agree to the <a href="/terms-and-conditions" target="_blank" className="text-success text-decoration-none fw-semibold">Terms & Conditions</a> & <a href="/privacy-policy" target="_blank" className="text-success text-decoration-none fw-semibold">Privacy Policy</a>

                </label>

              </div>

            )}



            <button

              type="submit"

              className="btn w-100 d-flex justify-content-center align-items-center py-2 registration-submit-button"

              disabled={loading || otpLoading}

            >

              <div className="d-flex align-items-center" style={{ gap: "10px" }}>

                <span style={{ fontSize: "17px" }}>

                  {getSubmitButtonText()}

                </span>

                {!(loading || otpLoading) && (

                  <span style={{ fontSize: "28px", lineHeight: "1", marginBottom: "4px" }}>

                    &#8250;

                  </span>

                )}

              </div>

            </button>

          </form>



          {registrationStep === 1 && (

            <Row className="mb-3 mt-4">

              <Col className="text-center">

                <div style={{ fontSize: '0.9rem', whiteSpace: 'nowrap' }}>

                  <span className="text-muted">Already have an account? </span>

                  <span

                    onClick={() => navigate('/login')}

                    className="text-success text-decoration-none fw-semibold"

                    style={{ cursor: 'pointer' }}

                  >

                    Login

                  </span>

                </div>

              </Col>

            </Row>

          )}

        </div>

      </div>

    </>

  );

};



export default Register;
























